var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2403.545,
    height: 870.457,
    viewBox: "0 0 2403.545 870.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.16,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M287.652,229.19a4.756,4.756,0,0,0-3.6,2.609,19.061,19.061,0,0,0-1.605,4.806l1-.8-1.2,3.812a61.932,61.932,0,0,1-11.217-8.026c-4.615-4.414-7.414-5.217-9.822-5.217s-17.437,1-19.243.8-5.809-2.408-6.411.2,2.207,4.645,5.628,6.652,10.033.8,12.039.6a17.489,17.489,0,0,1,4.2.2s8.618,6.21,13.634,13.424,10.615,13.635,14.628,12.631,8.217-6.21,8.819-6.21,5.408.2,7.214-3.411a27.166,27.166,0,0,0,2.2-5.408",
    transform: "translate(-235.47 -226.111)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M223.506,334.677a73.869,73.869,0,0,1-5.016,7.816,59.554,59.554,0,0,1-7.214,8.026s3.6,5.809,6.812,10.615,4.2,5.418,2.007,6.812-7.224,9.22-9.421,11.227-8.417,2.207-8.417,2.207-4.013-.8-3.21-2.809a4.525,4.525,0,0,1,4.013-2.609c1,0,3.6-.2,4.4-.793s5.016-5.217,5.608-6.622-5.408-6.411-8.809-11.819-6.421-5.809-3.812-13.825S221.9,329.259,223.506,334.677Z",
    transform: "translate(-198.94 -332.533)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M192.222,232.246s1.8,4.806.6,7.414-2.809,5.016-3.21,8.026,1.806,23.246,3.01,33.469,7.214,20.637,11.417,25.082,5.207,5.418,5.207,5.418,11.628,3.01,16.835,8.217,7.214,8.618,12.039,10.033a15.3,15.3,0,0,0,14.046-3.6,60.2,60.2,0,0,0,4.254-4.7c.371-.462.552-.712.552-.712v2.237s6.622-5.247,6.622-4.013a34.229,34.229,0,0,1-.592,4.2s3.2-3.6,3.2-2.007.2,9.029,0,9.611,1.4-.4,1.4,1-1,5.809-4.806,10.424-16.273,11.086-27.721,7.725-12.22-17.236-14.628-22.243S210,321.026,210,321.026s-1.2,11.819-6.812,17.056-16.052,9.621-18.631,13.635.793,11.618,1.395,12.621,5.618,5.809,4.013,7.816-11.628,11.227-15.049,13.424-8.217,2.408-9.421,2.809-11.819.2-11.819-2.408,2.4-3.8,6.612-4.806,8.217,1.605,9.812.6,8.819-7.023,9.421-9.029-.8-9.029-5.016-12.621-15.049-9.22-13.624-24.249,6.411-22.453,6.411-22.453-7.023-14.046-16.052-22.072S140.2,271.916,140.2,271.916l-1,2.207-.8-6.822-1.194,1.2-.4-3.4s-2.609-14.828-.2-24.65,6.21-13.043,6.21-13.043L140.6,228l4.816-2.8-.6-.8s3.4-2.408,5.016-2.608,6.812-1.605,6.812-1.605-2.8-.592-2.207-.592,6.22-1.4,6.22-1.4l2.4-.2s4.615.6,11.829,5.207a153.1,153.1,0,0,0,17.337,9.05Z",
    transform: "translate(-135.58 -217.99)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M213.477,182.069s4.615,4.615,8.618,5.418,15.049.6,19.243,9.411,1.4,24.249-1.4,28.463-2.007,7.023-3.411,7.815-14.628-4.013-22.243-8.819-9.812-4.806-10.033-7.615,2.007-4.414,3.6-5.809,2.809-2.609,2.007-3.01-6.02-2.207-7.214-3.8.2-5.418,2.007-5.016,9.029,2.609,9.029,2.609-8.819-3.812-10.414-9.621a11.879,11.879,0,0,1,2.8-11.819C208.069,178.066,211.882,180.073,213.477,182.069Z",
    transform: "translate(-202.197 -179.309)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slider",
    transform: "translate(231.9 -152.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slider_illustration",
    "data-name": "slider illustration"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 178.732,
    cy: 15.564,
    rx: 178.732,
    ry: 15.564,
    transform: "translate(564.246 991.346)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62423",
    "data-name": "Path 62423",
    d: "M271.6,424.48l-11.33,6.027-11.33-6.027-11.33,6.027-11.33-6.027-11.315,6.027v7.988H271.6Z",
    transform: "translate(1269.398 411.857)",
    fill: "#f0f0f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-351",
    transform: "translate(-231.9 349.23)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M72.882,317.45c.4,0,.732-.224.732-.5V102.09h66.593V208.66h29.284V137.37h47V246.15h28.274V181.47h20.192v67.62h14.862V185h18.127v64.08h30.339v-9.56h46.226V156.67h73.973V238.8H565.433V101.35h83.08v61h50.911V91.68h77.97V252.76H797.41v-83h70.722V211.6H906.2v89.68h44.117c.4-.005.724-.226.732-.5s-.328-.5-.732-.5h-42.58V210.6H869.6V168.71H795.946v83H778.858V90.68h-80.9v70.68H649.933v-61H563.925V237.8H449.905V155.67H373.048v82.86H326.823v9.56h-27.41V184H278.357v64.08H266.423V180.47H243.3v64.68H217.957V136.37H168.042v71.29H141.686V101.09H72.15V317C72.188,317.256,72.5,317.451,72.882,317.45Z",
    transform: "translate(-72.15 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M109.48,233.65h9.708V225.3H109.48Zm8.244-1h-6.779V226.3h6.779Z",
    transform: "translate(705.054 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M118.63,233.65h9.708V225.3H118.63Zm8.244-1h-6.779V226.3h6.779Z",
    transform: "translate(682.506 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M127.78,233.65H137.5V225.3H127.78Zm8.258-1h-6.794V226.3h6.794Z",
    transform: "translate(659.944 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M136.94,233.65h9.708V225.3H136.94Zm8.244-1H138.4V226.3h6.779Z",
    transform: "translate(637.386 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M146.09,233.65h9.722V225.3H146.09Zm8.258-1h-6.794V226.3h6.794Z",
    transform: "translate(614.824 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M155.25,233.65h9.708V225.3H155.25Zm8.244-1h-6.779V226.3h6.779Z",
    transform: "translate(592.266 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M198.2,179.26h9.708v-8.35H198.2Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(486.428 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M207.36,179.26h9.722v-8.35H207.36Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(463.841 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M216.51,179.26h9.708v-8.35H216.51Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(441.308 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M225.66,179.26h9.722v-8.35H225.66Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(418.745 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M198.2,166h9.708v-8.35H198.2Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(486.428 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M207.36,166h9.722v-8.35H207.36Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(463.841 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M216.51,166h9.708v-8.35H216.51Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(441.308 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M225.66,166h9.722v-8.35H225.66Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(418.745 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M198.2,152.8h9.708v-8.35H198.2Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(486.428 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M207.36,152.8h9.722v-8.35H207.36Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(463.841 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M216.51,152.8h9.708v-8.35H216.51Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(441.308 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M225.66,152.8h9.722v-8.35H225.66Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(418.745 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M198.2,139.57h9.708v-8.35H198.2Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(486.428 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M207.36,139.57h9.722v-8.35H207.36Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(463.841 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M216.51,139.57h9.708v-8.35H216.51Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(441.308 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M225.66,139.57h9.722v-8.35H225.66Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(418.745 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M198.2,126.34h9.708V118H198.2Zm8.244-1h-6.779V119h6.779Z",
    transform: "translate(486.428 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M207.36,126.34h9.722V118H207.36Zm8.258-1h-6.794V119h6.794Z",
    transform: "translate(463.841 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M216.51,126.34h9.708V118H216.51Zm8.244-1h-6.779V119h6.779Z",
    transform: "translate(441.308 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M225.66,126.34h9.722V118H225.66Zm8.258-1h-6.794V119h6.794Z",
    transform: "translate(418.745 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M234.82,179.26h9.708v-8.35H234.82Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(396.188 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M244.044,179.26h9.664v-8.35H244Zm8.244-1h-6.779v-6.35h6.735Z",
    transform: "translate(373.566 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M198.2,194h9.708v-8.35H198.2Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(486.428 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M207.36,194h9.722v-8.35H207.36Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(463.841 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M216.51,194h9.708v-8.35H216.51Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(441.308 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M225.66,194h9.722v-8.35H225.66Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(418.745 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M234.82,194h9.708v-8.35H234.82Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(396.188 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M244.044,194h9.664v-8.35H244Zm8.2-1h-6.779v-6.35h6.779Z",
    transform: "translate(373.566 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M109.48,249.09h9.708v-8.35H109.48Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(705.054 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M118.63,249.09h9.708v-8.35H118.63Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(682.506 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M127.78,249.09H137.5v-8.35H127.78Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(659.944 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M136.94,249.09h9.708v-8.35H136.94Zm8.244-1H138.4v-6.35h6.779Z",
    transform: "translate(637.386 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M146.09,249.09h9.722v-8.35H146.09Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(614.824 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M155.25,249.09h9.708v-8.35H155.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(592.266 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M109.48,264.53h9.708v-8.35H109.48Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(705.054 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M118.63,264.53h9.708v-8.35H118.63Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(682.506 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M127.78,264.53H137.5v-8.35H127.78Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(659.944 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M136.94,264.53h9.708v-8.35H136.94Zm8.244-1H138.4v-6.35h6.779Z",
    transform: "translate(637.386 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M146.09,264.53h9.722v-8.35H146.09Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(614.824 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M155.25,264.53h9.708v-8.35H155.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(592.266 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M109.48,280h9.708v-8.35H109.48Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(705.054 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M118.63,280h9.708v-8.35H118.63Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(682.506 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M127.78,280H137.5v-8.35H127.78Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(659.944 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M136.94,280h9.708v-8.35H136.94Zm8.244-1H138.4v-6.35h6.779Z",
    transform: "translate(637.386 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M146.09,280h9.722v-8.35H146.09Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(614.824 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M155.25,280h9.708v-8.35H155.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(592.266 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M109.48,295.4h9.708v-8.35H109.48Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(705.054 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M118.63,295.4h9.708v-8.35H118.63Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(682.506 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M127.78,295.4H137.5v-8.35H127.78Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(659.944 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M136.94,295.4h9.708v-8.35H136.94Zm8.244-1H138.4v-6.35h6.779Z",
    transform: "translate(637.386 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M146.09,295.4h9.722v-8.35H146.09Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(614.824 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M155.25,295.4h9.708v-8.35H155.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(592.266 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M642.53,124.87h9.708v-8.35H642.53Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M651.68,124.87H661.4v-8.35H651.68Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M660.84,124.87h9.708v-8.35H660.84Zm8.244-1H662.3v-6.35h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M642.53,143.25h9.708V134.9H642.53Zm8.244-1h-6.779V135.9h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M651.68,143.25H661.4V134.9H651.68Zm8.258-1h-6.794V135.9h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M660.84,143.25h9.708V134.9H660.84Zm8.244-1H662.3V135.9h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M642.53,161.62h9.708v-8.35H642.53Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M651.68,161.62H661.4v-8.35H651.68Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M660.84,161.62h9.708v-8.35H660.84Zm8.244-1H662.3v-6.35h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M642.53,180h9.708v-8.35H642.53Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M651.68,180H661.4v-8.35H651.68Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M660.84,180h9.708v-8.35H660.84Zm8.244-1H662.3v-6.35h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M642.53,198.37h9.708V190H642.53Zm8.244-1h-6.779V191h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M651.68,198.37H661.4V190H651.68Zm8.258-1h-6.794V191h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M660.84,198.37h9.708V190H660.84Zm8.244-1H662.3V191h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M642.53,216.75h9.708V208.4H642.53Zm8.244-1h-6.779V209.4h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M651.68,216.75H661.4V208.4H651.68Zm8.258-1h-6.794V209.4h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M660.84,216.75h9.708V208.4H660.84Zm8.244-1H662.3V209.4h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M642.53,235.12h9.708v-8.35H642.53Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M651.68,235.12H661.4v-8.35H651.68Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M660.84,235.12h9.708v-8.35H660.84Zm8.244-1H662.3v-6.35h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M642.53,253.5h9.708v-8.35H642.53Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M651.68,253.5H661.4v-8.35H651.68Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M660.84,253.5h9.708v-8.35H660.84Zm8.244-1H662.3v-6.35h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M642.53,271.88h9.708v-8.35H642.53Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-608.501 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M651.68,271.88H661.4v-8.35H651.68Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-631.064 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M582.6,161.62h9.708v-8.35H582.6Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M591.75,161.62h9.708v-8.35H591.75Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M582.6,180h9.708v-8.35H582.6Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M591.75,180h9.708v-8.35H591.75Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M582.6,198.37h9.708V190H582.6Zm8.244-1h-6.779V191h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M591.75,198.37h9.708V190H591.75Zm8.244-1h-6.779V191h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M582.6,216.75h9.708V208.4H582.6Zm8.244-1h-6.779V209.4h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M591.75,216.75h9.708V208.4H591.75Zm8.244-1h-6.779V209.4h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M582.6,235.12h9.708v-8.35H582.6Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M591.75,235.12h9.708v-8.35H591.75Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M582.6,253.5h9.708v-8.35H582.6Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M591.75,253.5h9.708v-8.35H591.75Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M582.6,271.88h9.708v-8.35H582.6Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-460.82 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M591.75,271.88h9.708v-8.35H591.75Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(-483.368 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M421.26,180h9.708v-8.35H421.26Zm8.244-1h-6.779v-6.35H429.5Z",
    transform: "translate(-63.242 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M430.41,180h9.722v-8.35H430.41Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-85.805 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M421.26,198.37h9.708V190H421.26Zm8.244-1h-6.779V191H429.5Z",
    transform: "translate(-63.242 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M430.41,198.37h9.722V190H430.41Zm8.258-1h-6.794V191h6.794Z",
    transform: "translate(-85.805 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M421.26,216.75h9.708V208.4H421.26Zm8.244-1h-6.779V209.4H429.5Z",
    transform: "translate(-63.242 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M430.41,216.75h9.722V208.4H430.41Zm8.258-1h-6.794V209.4h6.794Z",
    transform: "translate(-85.805 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M421.26,235.12h9.708v-8.35H421.26Zm8.244-1h-6.779v-6.35H429.5Z",
    transform: "translate(-63.242 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M430.41,235.12h9.722v-8.35H430.41Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-85.805 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M421.26,253.5h9.708v-8.35H421.26Zm8.244-1h-6.779v-6.35H429.5Z",
    transform: "translate(-63.242 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M430.41,253.5h9.722v-8.35H430.41Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-85.805 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M421.26,271.88h9.708v-8.35H421.26Zm8.244-1h-6.779v-6.35H429.5Z",
    transform: "translate(-63.242 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M430.41,271.88h9.722v-8.35H430.41Zm8.258-1h-6.794v-6.35h6.794Z",
    transform: "translate(-85.805 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M442.015,180h9.693v-8.35H442Zm8.229-1h-6.779v-6.35h6.779Z",
    transform: "translate(-114.35 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M451.14,180h9.722v-8.35H451.14Zm8.258-1H452.6v-6.35H459.4Z",
    transform: "translate(-136.888 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M442.015,198.37h9.693V190H442Zm8.244-1h-6.779V191h6.765Z",
    transform: "translate(-114.35 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M451.14,198.37h9.722V190H451.14Zm8.258-1H452.6V191H459.4Z",
    transform: "translate(-136.888 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M442.015,216.75h9.693V208.4H442Zm8.244-1h-6.779V209.4h6.765Z",
    transform: "translate(-114.35 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M451.14,216.75h9.722V208.4H451.14Zm8.258-1H452.6V209.4H459.4Z",
    transform: "translate(-136.888 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M442.015,235.12h9.693v-8.35H442Zm8.244-1h-6.779v-6.35h6.765Z",
    transform: "translate(-114.35 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M451.14,235.12h9.722v-8.35H451.14Zm8.258-1H452.6v-6.35H459.4Z",
    transform: "translate(-136.888 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M442.015,253.5h9.693v-8.35H442Zm8.244-1h-6.779v-6.35h6.765Z",
    transform: "translate(-114.35 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M451.14,253.5h9.722v-8.35H451.14Zm8.258-1H452.6v-6.35H459.4Z",
    transform: "translate(-136.888 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M442.015,271.88h9.693v-8.35H442Zm8.244-1h-6.779v-6.35h6.765Z",
    transform: "translate(-114.35 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M451.14,271.88h9.722v-8.35H451.14Zm8.258-1H452.6v-6.35H459.4Z",
    transform: "translate(-136.888 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M298.1,124.87h9.708v-8.35H298.1Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M307.25,124.87h9.708v-8.35H307.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M298.1,143.25h9.708V134.9H298.1Zm8.244-1h-6.779V135.9h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M307.25,143.25h9.708V134.9H307.25Zm8.244-1h-6.779V135.9h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M298.1,161.62h9.708v-8.35H298.1Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M307.25,161.62h9.708v-8.35H307.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M298.1,180h9.708v-8.35H298.1Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M307.25,180h9.708v-8.35H307.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M298.1,198.37h9.708V190H298.1Zm8.244-1h-6.779V191h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M307.25,198.37h9.708V190H307.25Zm8.244-1h-6.779V191h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M298.1,216.75h9.708V208.4H298.1Zm8.244-1h-6.779V209.4h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M307.25,216.75h9.708V208.4H307.25Zm8.244-1h-6.779V209.4h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M298.1,235.12h9.708v-8.35H298.1Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M307.25,235.12h9.708v-8.35H307.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M298.1,253.5h9.708v-8.35H298.1Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M307.25,253.5h9.708v-8.35H307.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M298.1,271.88h9.708v-8.35H298.1Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(240.252 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M307.25,271.88h9.708v-8.35H307.25Zm8.244-1h-6.779v-6.35h6.779Z",
    transform: "translate(217.704 -90.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M660.84,271.88h9.708v-8.35H660.84Zm8.244-1H662.3v-6.35h6.779Z",
    transform: "translate(-653.621 -90.68)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-351-2",
    "data-name": "freepik--City--inject-351",
    transform: "translate(1220.594 244.551)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1702-2",
    "data-name": "Path 1702",
    d: "M950.319,317.45c-.4,0-.732-.224-.732-.5V102.09H882.994V208.66H853.709V137.37h-47V246.15H778.433V181.47H758.242v67.62H743.38V185H725.253v64.08H694.914v-9.56H648.688V156.67H574.716V238.8H457.768V101.35h-83.08v61H323.777V91.68h-77.97V252.76H225.791v-83H155.069V211.6H117v89.68H72.882c-.4-.005-.724-.226-.732-.5s.328-.5.732-.5h42.58V210.6H153.6V168.71h73.65v83h17.087V90.68h80.9v70.68h48.027v-61h86.009V237.8H573.3V155.67h76.857v82.86h46.226v9.56h27.41V184h21.056v64.08h11.933V180.47H779.9v64.68h25.346V136.37h49.915v71.29h26.356V101.09h69.536V317C951.013,317.256,950.7,317.451,950.319,317.45Z",
    transform: "translate(0)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703-2",
    "data-name": "Path 1703",
    d: "M119.188,233.65H109.48V225.3h9.708Zm-8.244-1h6.779V226.3h-6.779Z",
    transform: "translate(17.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704-2",
    "data-name": "Path 1704",
    d: "M128.338,233.65H118.63V225.3h9.708Zm-8.244-1h6.779V226.3h-6.779Z",
    transform: "translate(21.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705-2",
    "data-name": "Path 1705",
    d: "M137.5,233.65H127.78V225.3H137.5Zm-8.258-1h6.794V226.3h-6.794Z",
    transform: "translate(25.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706-2",
    "data-name": "Path 1706",
    d: "M146.648,233.65H136.94V225.3h9.708Zm-8.244-1h6.779V226.3H138.4Z",
    transform: "translate(30.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707-2",
    "data-name": "Path 1707",
    d: "M155.812,233.65H146.09V225.3h9.722Zm-8.258-1h6.794V226.3h-6.794Z",
    transform: "translate(34.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708-2",
    "data-name": "Path 1708",
    d: "M164.958,233.65H155.25V225.3h9.708Zm-8.244-1h6.779V226.3h-6.779Z",
    transform: "translate(38.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709-2",
    "data-name": "Path 1709",
    d: "M207.908,179.26H198.2v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(58.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710-2",
    "data-name": "Path 1710",
    d: "M217.082,179.26H207.36v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(62.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711-2",
    "data-name": "Path 1711",
    d: "M226.218,179.26H216.51v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(67.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712-2",
    "data-name": "Path 1712",
    d: "M235.382,179.26H225.66v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(71.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713-2",
    "data-name": "Path 1713",
    d: "M207.908,166H198.2v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(58.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714-2",
    "data-name": "Path 1714",
    d: "M217.082,166H207.36v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(62.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715-2",
    "data-name": "Path 1715",
    d: "M226.218,166H216.51v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(67.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716-2",
    "data-name": "Path 1716",
    d: "M235.382,166H225.66v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(71.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717-2",
    "data-name": "Path 1717",
    d: "M207.908,152.8H198.2v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(58.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718-2",
    "data-name": "Path 1718",
    d: "M217.082,152.8H207.36v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(62.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719-2",
    "data-name": "Path 1719",
    d: "M226.218,152.8H216.51v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(67.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720-2",
    "data-name": "Path 1720",
    d: "M235.382,152.8H225.66v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(71.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721-2",
    "data-name": "Path 1721",
    d: "M207.908,139.57H198.2v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(58.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722-2",
    "data-name": "Path 1722",
    d: "M217.082,139.57H207.36v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(62.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723-2",
    "data-name": "Path 1723",
    d: "M226.218,139.57H216.51v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(67.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724-2",
    "data-name": "Path 1724",
    d: "M235.382,139.57H225.66v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(71.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725-2",
    "data-name": "Path 1725",
    d: "M207.908,126.34H198.2V118h9.708Zm-8.244-1h6.779V119h-6.779Z",
    transform: "translate(58.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726-2",
    "data-name": "Path 1726",
    d: "M217.082,126.34H207.36V118h9.722Zm-8.258-1h6.794V119h-6.794Z",
    transform: "translate(62.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727-2",
    "data-name": "Path 1727",
    d: "M226.218,126.34H216.51V118h9.708Zm-8.244-1h6.779V119h-6.779Z",
    transform: "translate(67.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728-2",
    "data-name": "Path 1728",
    d: "M235.382,126.34H225.66V118h9.722Zm-8.258-1h6.794V119h-6.794Z",
    transform: "translate(71.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729-2",
    "data-name": "Path 1729",
    d: "M244.528,179.26H234.82v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(75.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730-2",
    "data-name": "Path 1730",
    d: "M253.664,179.26H244v-8.35h9.708Zm-8.244-1H252.2v-6.35h-6.735Z",
    transform: "translate(79.777)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731-2",
    "data-name": "Path 1731",
    d: "M207.908,194H198.2v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(58.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732-2",
    "data-name": "Path 1732",
    d: "M217.082,194H207.36v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(62.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733-2",
    "data-name": "Path 1733",
    d: "M226.218,194H216.51v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(67.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734-2",
    "data-name": "Path 1734",
    d: "M235.382,194H225.66v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(71.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735-2",
    "data-name": "Path 1735",
    d: "M244.528,194H234.82v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(75.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736-2",
    "data-name": "Path 1736",
    d: "M253.664,194H244v-8.35h9.708Zm-8.2-1h6.779v-6.35h-6.779Z",
    transform: "translate(79.777)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737-2",
    "data-name": "Path 1737",
    d: "M119.188,249.09H109.48v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(17.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738-2",
    "data-name": "Path 1738",
    d: "M128.338,249.09H118.63v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(21.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739-2",
    "data-name": "Path 1739",
    d: "M137.5,249.09H127.78v-8.35H137.5Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(25.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740-2",
    "data-name": "Path 1740",
    d: "M146.648,249.09H136.94v-8.35h9.708Zm-8.244-1h6.779v-6.35H138.4Z",
    transform: "translate(30.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741-2",
    "data-name": "Path 1741",
    d: "M155.812,249.09H146.09v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(34.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742-2",
    "data-name": "Path 1742",
    d: "M164.958,249.09H155.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(38.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743-2",
    "data-name": "Path 1743",
    d: "M119.188,264.53H109.48v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(17.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744-2",
    "data-name": "Path 1744",
    d: "M128.338,264.53H118.63v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(21.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745-2",
    "data-name": "Path 1745",
    d: "M137.5,264.53H127.78v-8.35H137.5Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(25.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746-2",
    "data-name": "Path 1746",
    d: "M146.648,264.53H136.94v-8.35h9.708Zm-8.244-1h6.779v-6.35H138.4Z",
    transform: "translate(30.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747-2",
    "data-name": "Path 1747",
    d: "M155.812,264.53H146.09v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(34.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748-2",
    "data-name": "Path 1748",
    d: "M164.958,264.53H155.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(38.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749-2",
    "data-name": "Path 1749",
    d: "M119.188,280H109.48v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(17.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750-2",
    "data-name": "Path 1750",
    d: "M128.338,280H118.63v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(21.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751-2",
    "data-name": "Path 1751",
    d: "M137.5,280H127.78v-8.35H137.5Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(25.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752-2",
    "data-name": "Path 1752",
    d: "M146.648,280H136.94v-8.35h9.708Zm-8.244-1h6.779v-6.35H138.4Z",
    transform: "translate(30.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753-2",
    "data-name": "Path 1753",
    d: "M155.812,280H146.09v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(34.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754-2",
    "data-name": "Path 1754",
    d: "M164.958,280H155.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(38.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755-2",
    "data-name": "Path 1755",
    d: "M119.188,295.4H109.48v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(17.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756-2",
    "data-name": "Path 1756",
    d: "M128.338,295.4H118.63v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(21.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757-2",
    "data-name": "Path 1757",
    d: "M137.5,295.4H127.78v-8.35H137.5Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(25.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758-2",
    "data-name": "Path 1758",
    d: "M146.648,295.4H136.94v-8.35h9.708Zm-8.244-1h6.779v-6.35H138.4Z",
    transform: "translate(30.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759-2",
    "data-name": "Path 1759",
    d: "M155.812,295.4H146.09v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(34.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760-2",
    "data-name": "Path 1760",
    d: "M164.958,295.4H155.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(38.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761-2",
    "data-name": "Path 1761",
    d: "M652.238,124.87H642.53v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762-2",
    "data-name": "Path 1762",
    d: "M661.4,124.87H651.68v-8.35H661.4Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763-2",
    "data-name": "Path 1763",
    d: "M670.548,124.87H660.84v-8.35h9.708Zm-8.244-1h6.779v-6.35H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764-2",
    "data-name": "Path 1764",
    d: "M652.238,143.25H642.53V134.9h9.708Zm-8.244-1h6.779V135.9h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765-2",
    "data-name": "Path 1765",
    d: "M661.4,143.25H651.68V134.9H661.4Zm-8.258-1h6.794V135.9h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766-2",
    "data-name": "Path 1766",
    d: "M670.548,143.25H660.84V134.9h9.708Zm-8.244-1h6.779V135.9H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767-2",
    "data-name": "Path 1767",
    d: "M652.238,161.62H642.53v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768-2",
    "data-name": "Path 1768",
    d: "M661.4,161.62H651.68v-8.35H661.4Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769-2",
    "data-name": "Path 1769",
    d: "M670.548,161.62H660.84v-8.35h9.708Zm-8.244-1h6.779v-6.35H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770-2",
    "data-name": "Path 1770",
    d: "M652.238,180H642.53v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771-2",
    "data-name": "Path 1771",
    d: "M661.4,180H651.68v-8.35H661.4Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772-2",
    "data-name": "Path 1772",
    d: "M670.548,180H660.84v-8.35h9.708Zm-8.244-1h6.779v-6.35H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773-2",
    "data-name": "Path 1773",
    d: "M652.238,198.37H642.53V190h9.708Zm-8.244-1h6.779V191h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774-2",
    "data-name": "Path 1774",
    d: "M661.4,198.37H651.68V190H661.4Zm-8.258-1h6.794V191h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775-2",
    "data-name": "Path 1775",
    d: "M670.548,198.37H660.84V190h9.708Zm-8.244-1h6.779V191H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776-2",
    "data-name": "Path 1776",
    d: "M652.238,216.75H642.53V208.4h9.708Zm-8.244-1h6.779V209.4h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777-2",
    "data-name": "Path 1777",
    d: "M661.4,216.75H651.68V208.4H661.4Zm-8.258-1h6.794V209.4h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778-2",
    "data-name": "Path 1778",
    d: "M670.548,216.75H660.84V208.4h9.708Zm-8.244-1h6.779V209.4H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779-2",
    "data-name": "Path 1779",
    d: "M652.238,235.12H642.53v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780-2",
    "data-name": "Path 1780",
    d: "M661.4,235.12H651.68v-8.35H661.4Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781-2",
    "data-name": "Path 1781",
    d: "M670.548,235.12H660.84v-8.35h9.708Zm-8.244-1h6.779v-6.35H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782-2",
    "data-name": "Path 1782",
    d: "M652.238,253.5H642.53v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783-2",
    "data-name": "Path 1783",
    d: "M661.4,253.5H651.68v-8.35H661.4Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784-2",
    "data-name": "Path 1784",
    d: "M670.548,253.5H660.84v-8.35h9.708Zm-8.244-1h6.779v-6.35H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785-2",
    "data-name": "Path 1785",
    d: "M652.238,271.88H642.53v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(264.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786-2",
    "data-name": "Path 1786",
    d: "M661.4,271.88H651.68v-8.35H661.4Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(269.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787-2",
    "data-name": "Path 1787",
    d: "M592.308,161.62H582.6v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788-2",
    "data-name": "Path 1788",
    d: "M601.458,161.62H591.75v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789-2",
    "data-name": "Path 1789",
    d: "M592.308,180H582.6v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790-2",
    "data-name": "Path 1790",
    d: "M601.458,180H591.75v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791-2",
    "data-name": "Path 1791",
    d: "M592.308,198.37H582.6V190h9.708Zm-8.244-1h6.779V191h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792-2",
    "data-name": "Path 1792",
    d: "M601.458,198.37H591.75V190h9.708Zm-8.244-1h6.779V191h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793-2",
    "data-name": "Path 1793",
    d: "M592.308,216.75H582.6V208.4h9.708Zm-8.244-1h6.779V209.4h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794-2",
    "data-name": "Path 1794",
    d: "M601.458,216.75H591.75V208.4h9.708Zm-8.244-1h6.779V209.4h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795-2",
    "data-name": "Path 1795",
    d: "M592.308,235.12H582.6v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796-2",
    "data-name": "Path 1796",
    d: "M601.458,235.12H591.75v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797-2",
    "data-name": "Path 1797",
    d: "M592.308,253.5H582.6v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798-2",
    "data-name": "Path 1798",
    d: "M601.458,253.5H591.75v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799-2",
    "data-name": "Path 1799",
    d: "M592.308,271.88H582.6v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(236.963)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800-2",
    "data-name": "Path 1800",
    d: "M601.458,271.88H591.75v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(241.211)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801-2",
    "data-name": "Path 1801",
    d: "M430.968,180H421.26v-8.35h9.708Zm-8.244-1H429.5v-6.35h-6.779Z",
    transform: "translate(162.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802-2",
    "data-name": "Path 1802",
    d: "M440.132,180H430.41v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(166.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803-2",
    "data-name": "Path 1803",
    d: "M430.968,198.37H421.26V190h9.708Zm-8.244-1H429.5V191h-6.779Z",
    transform: "translate(162.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804-2",
    "data-name": "Path 1804",
    d: "M440.132,198.37H430.41V190h9.722Zm-8.258-1h6.794V191h-6.794Z",
    transform: "translate(166.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805-2",
    "data-name": "Path 1805",
    d: "M430.968,216.75H421.26V208.4h9.708Zm-8.244-1H429.5V209.4h-6.779Z",
    transform: "translate(162.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806-2",
    "data-name": "Path 1806",
    d: "M440.132,216.75H430.41V208.4h9.722Zm-8.258-1h6.794V209.4h-6.794Z",
    transform: "translate(166.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807-2",
    "data-name": "Path 1807",
    d: "M430.968,235.12H421.26v-8.35h9.708Zm-8.244-1H429.5v-6.35h-6.779Z",
    transform: "translate(162.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808-2",
    "data-name": "Path 1808",
    d: "M440.132,235.12H430.41v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(166.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809-2",
    "data-name": "Path 1809",
    d: "M430.968,253.5H421.26v-8.35h9.708Zm-8.244-1H429.5v-6.35h-6.779Z",
    transform: "translate(162.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810-2",
    "data-name": "Path 1810",
    d: "M440.132,253.5H430.41v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(166.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811-2",
    "data-name": "Path 1811",
    d: "M430.968,271.88H421.26v-8.35h9.708Zm-8.244-1H429.5v-6.35h-6.779Z",
    transform: "translate(162.065)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812-2",
    "data-name": "Path 1812",
    d: "M440.132,271.88H430.41v-8.35h9.722Zm-8.258-1h6.794v-6.35h-6.794Z",
    transform: "translate(166.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813-2",
    "data-name": "Path 1813",
    d: "M451.693,180H442v-8.35h9.708Zm-8.229-1h6.779v-6.35h-6.779Z",
    transform: "translate(171.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814-2",
    "data-name": "Path 1814",
    d: "M460.862,180H451.14v-8.35h9.722Zm-8.258-1H459.4v-6.35H452.6Z",
    transform: "translate(175.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815-2",
    "data-name": "Path 1815",
    d: "M451.693,198.37H442V190h9.708Zm-8.244-1h6.779V191h-6.765Z",
    transform: "translate(171.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816-2",
    "data-name": "Path 1816",
    d: "M460.862,198.37H451.14V190h9.722Zm-8.258-1H459.4V191H452.6Z",
    transform: "translate(175.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817-2",
    "data-name": "Path 1817",
    d: "M451.693,216.75H442V208.4h9.708Zm-8.244-1h6.779V209.4h-6.765Z",
    transform: "translate(171.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818-2",
    "data-name": "Path 1818",
    d: "M460.862,216.75H451.14V208.4h9.722Zm-8.258-1H459.4V209.4H452.6Z",
    transform: "translate(175.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819-2",
    "data-name": "Path 1819",
    d: "M451.693,235.12H442v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.765Z",
    transform: "translate(171.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820-2",
    "data-name": "Path 1820",
    d: "M460.862,235.12H451.14v-8.35h9.722Zm-8.258-1H459.4v-6.35H452.6Z",
    transform: "translate(175.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821-2",
    "data-name": "Path 1821",
    d: "M451.693,253.5H442v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.765Z",
    transform: "translate(171.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822-2",
    "data-name": "Path 1822",
    d: "M460.862,253.5H451.14v-8.35h9.722Zm-8.258-1H459.4v-6.35H452.6Z",
    transform: "translate(175.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823-2",
    "data-name": "Path 1823",
    d: "M451.693,271.88H442v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.765Z",
    transform: "translate(171.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824-2",
    "data-name": "Path 1824",
    d: "M460.862,271.88H451.14v-8.35h9.722Zm-8.258-1H459.4v-6.35H452.6Z",
    transform: "translate(175.936)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825-2",
    "data-name": "Path 1825",
    d: "M307.808,124.87H298.1v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826-2",
    "data-name": "Path 1826",
    d: "M316.958,124.87H307.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827-2",
    "data-name": "Path 1827",
    d: "M307.808,143.25H298.1V134.9h9.708Zm-8.244-1h6.779V135.9h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828-2",
    "data-name": "Path 1828",
    d: "M316.958,143.25H307.25V134.9h9.708Zm-8.244-1h6.779V135.9h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829-2",
    "data-name": "Path 1829",
    d: "M307.808,161.62H298.1v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830-2",
    "data-name": "Path 1830",
    d: "M316.958,161.62H307.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831-2",
    "data-name": "Path 1831",
    d: "M307.808,180H298.1v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832-2",
    "data-name": "Path 1832",
    d: "M316.958,180H307.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833-2",
    "data-name": "Path 1833",
    d: "M307.808,198.37H298.1V190h9.708Zm-8.244-1h6.779V191h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834-2",
    "data-name": "Path 1834",
    d: "M316.958,198.37H307.25V190h9.708Zm-8.244-1h6.779V191h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835-2",
    "data-name": "Path 1835",
    d: "M307.808,216.75H298.1V208.4h9.708Zm-8.244-1h6.779V209.4h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836-2",
    "data-name": "Path 1836",
    d: "M316.958,216.75H307.25V208.4h9.708Zm-8.244-1h6.779V209.4h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837-2",
    "data-name": "Path 1837",
    d: "M307.808,235.12H298.1v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838-2",
    "data-name": "Path 1838",
    d: "M316.958,235.12H307.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839-2",
    "data-name": "Path 1839",
    d: "M307.808,253.5H298.1v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840-2",
    "data-name": "Path 1840",
    d: "M316.958,253.5H307.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841-2",
    "data-name": "Path 1841",
    d: "M307.808,271.88H298.1v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(104.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842-2",
    "data-name": "Path 1842",
    d: "M316.958,271.88H307.25v-8.35h9.708Zm-8.244-1h6.779v-6.35h-6.779Z",
    transform: "translate(109.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843-2",
    "data-name": "Path 1843",
    d: "M670.548,271.88H660.84v-8.35h9.708Zm-8.244-1h6.779v-6.35H662.3Z",
    transform: "translate(273.284)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 -702.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(16.264 0)",
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-2",
    transform: "translate(1225.269 1062.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M733.771,428.833c-1.561-9.161-23.253,4.587-23.253,4.587a38.183,38.183,0,0,0,4.647-17.181c0-9.161-15.433,2.281-15.433,2.281s10.855-14.888,9.311-30.916S684.23,389.9,684.23,389.9s9.311-24.074,10.855-30.928-43.4,8.02-43.4,8.02a169.47,169.47,0,0,0,4.647-20.615c.806-5.271-6.859-3.079-14.61.329-1.715-4.587-6.293-4.9-11.386-3.472.326-1.14.686-2.382,1.08-3.712,1.715-6.17-10.186.786-20.081,7.361-1.2-8.013-6.1-15.474-13.89-21.121-7.494-5.537-15.57.633-22.293,9.3l-11.129,2.534a47.968,47.968,0,0,0-.686-4.941c-2.006-10.364-13.719.811-21.761,10.009L533,344.614c-1.372-6.487-4.733-15.952-13-23.415C506.06,308.6,473.5,344.107,473.5,344.107s-20.149-24.074-27.9-11.4,3.1,38.948,3.1,38.948-4.647-9.173-10.838-11.4-23.253,8.008-23.253,8.008,9.294-16.028,0-21.755c-8.42-5.182-19.343,13.038-21.367,16.585,1.423-2.686,6.859-14.317,2.761-30.333-4.647-18.321-23.253,5.727-23.253,5.727s3.1-22.908-13.941-26.342,7.751,0-9.311,22.908S338.659,319.02,313.846,321.3s-18.589,71.017-18.589,71.017l-97.8-41.33s-4.647-6.88-20.389-8.958-5.95,15.851-5.95,15.851-21.71-14.888-31-14.888c-2.418,0-9.843,7.944-19.515,19.7-.7-1.2-1.423-2.433-2.178-3.674-5.882-9.541-10.855,11.8-12.93,22.705l-1.715,2.192c-1.252-5.385-4.9-14.634-14.816-14.634-12,0-5.642,30.561-3.635,39.05v.1c-1.543-4.827-5.985-16.471-13.341-17.4-9.294-1.14-1.56,25.2-1.56,25.2s-6.19-3.434-10.838-3.434c-3.43,0,1.32,15.977,4.2,24.96C54.016,451.2,47.38,460.509,47.38,460.509l61.734-24.8H433.54L417.85,451.754H727.512S735.314,438.019,733.771,428.833Z",
    transform: "translate(-22.671 -37.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M402.762,455.13c-4.04-11.758-10.654-26.354-19.875-31.8-16.369-9.68-43,5.537-57.327-1.381s16.369-74.666-32.808-78.809-67.584,64.986-90.118,71.891-30.718-17.966-61.437-19.348c-26.851-1.267-78.756,47.235-91.378,59.449Z",
    transform: "translate(-20.897 -28.899)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M402.762,455.13c-4.04-11.758-10.654-26.354-19.875-31.8-16.369-9.68-43,5.537-57.327-1.381s16.369-74.666-32.808-78.809-67.584,64.986-90.118,71.891-30.718-17.966-61.437-19.348c-26.851-1.267-78.756,47.235-91.378,59.449Z",
    transform: "translate(-20.897 -28.899)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M191,481.732h11.345l6.907-183.719,14.556-32.2L208.492,286.99l2.262-20.678,24.519-36.617-23.552,22.857-2.038-54.812-3.143,33.741-11.586-5.068,10.153,11.277L202.344,277.6l-9.169-10.63,7.891,18.917Z",
    transform: "translate(79.892 -67.676)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M102.59,481.732h11.345l6.907-183.719,14.539-32.132-15.333,21.172,2.279-20.678,24.554-36.63-23.622,22.807-2.02-54.812-3.212,33.741-11.586-5.068,10.153,11.277L113.831,277.6l-9.186-10.63,7.908,18.917Z",
    transform: "translate(16.655 -67.676)",
    fill: "#a8adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M291.08,467.868h11.345l6.907-141.211,14.608-24.618-15.333,16.269,2.262-15.889,24.519-28.255-23.621,17.612-2.038-42.116L306.482,275.6l-11.569-3.877,10.153,8.654-2.78,30.675-9.169-8.172,7.891,14.533Z",
    transform: "translate(151.476 -53.812)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M214.34,467.868h11.345l6.907-141.211,14.591-24.618-15.316,16.269,2.262-15.889,24.519-28.255-23.622,17.612-2.038-42.116L229.777,275.6l-11.586-3.877,10.17,8.654-2.78,30.675-9.169-8.172,7.891,14.533Z",
    transform: "translate(96.586 -53.812)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M264.59,467.868h11.327l6.907-141.211,14.608-24.618L282.1,318.308l2.279-15.889,24.5-28.255-23.622,17.612-2.037-42.116L280.027,275.6l-11.586-3.877,10.153,8.654-2.763,30.675-9.186-8.172,7.908,14.533Z",
    transform: "translate(132.529 -53.812)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M410.07,481.729h11.345l6.907-183.719,14.539-32.132L427.544,287.05l2.262-20.678,24.519-36.617L430.7,252.562l-2.038-54.812-3.177,33.728L413.9,226.41l10.153,11.277L421.294,277.6l-9.169-10.63,7.891,18.917Z",
    transform: "translate(236.139 -67.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M370.32,481.732h11.327l6.907-183.719,14.556-32.132-15.333,21.172,2.279-20.678,24.606-36.63-23.621,22.807L389,197.74l-3.194,33.741-11.586-5.068,10.153,11.277L381.613,277.6l-9.186-10.63,7.908,18.917Z",
    transform: "translate(208.153 -67.676)",
    fill: "#8a9094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M302.17,481.732H313.5L320.4,298.013l14.539-32.132L319.61,287.053l2.279-20.678,24.571-36.63-23.622,22.807L320.87,197.74l-3.194,33.741-11.586-5.068,10.153,11.277L313.48,277.6l-9.186-10.63,7.908,18.917Z",
    transform: "translate(159.408 -67.676)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M529.658,455.13c-3.453-11.758-9.221-26.354-17.181-31.8-14.176-9.68-37.228,5.537-49.626-1.381s14.176-74.666-28.353-78.809-58.484,64.986-77.979,71.891-26.591-17.966-53.166-19.348c-23.242-1.267-68.154,47.235-79.084,59.449Z",
    transform: "translate(102.439 -28.899)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M529.658,455.13c-3.453-11.758-9.221-26.354-17.181-31.8-14.176-9.68-37.228,5.537-49.626-1.381s14.176-74.666-28.353-78.809-58.484,64.986-77.979,71.891-26.591-17.966-53.166-19.348c-23.242-1.267-68.154,47.235-79.084,59.449Z",
    transform: "translate(102.439 -28.899)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M315.248,202.44s-24.537,0-31.685,29.256S294.8,268.44,272.3,283.467s-25.555,25.518-14.315,32.271,17.388,14.254,3.074,25.505S244.695,369,295.823,379.507s89.979-15,92.034-32.259-15.351-28.521-16.369-42.775,34.776-27.761,30.684-47.26S361.265,245.2,351.043,230.2,339.785,202.44,315.248,202.44Z",
    transform: "translate(122.834 -66.421)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M315.248,202.44s-24.537,0-31.685,29.256S294.8,268.44,272.3,283.467s-25.555,25.518-14.315,32.271,17.388,14.254,3.074,25.505S244.695,369,295.823,379.507s89.979-15,92.034-32.259-15.351-28.521-16.369-42.775,34.776-27.761,30.684-47.26S361.265,245.2,351.043,230.2,339.785,202.44,315.248,202.44Z",
    transform: "translate(122.834 -66.421)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M278,482.135h8.962l12.674-183.06,11.5-25.341-12.087,16.737,1.727-16.345,19.374-28.964-18.666,18.081L299.86,219.91l-2.521,26.608-9.169-3.978,8.029,8.869-2.193,31.549-7.252-8.4,6.251,14.951Z",
    transform: "translate(142.129 -61.756)",
    fill: "#92989b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M199.56,453.3c2.625-10.846,6.907-24.327,12.933-29.344,10.671-8.933,27.99,5.068,37.332-1.267s-10.671-68.9,21.325-72.728,44,59.969,58.709,66.354,20-16.6,39.991-17.865c17.492-1.115,51.266,43.6,59.485,54.862Z",
    transform: "translate(85.351 -27.072)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M199.56,453.3c2.625-10.846,6.907-24.327,12.933-29.344,10.671-8.933,27.99,5.068,37.332-1.267s-10.671-68.9,21.325-72.728,44,59.969,58.709,66.354,20-16.6,39.991-17.865c17.492-1.115,51.266,43.6,59.485,54.862Z",
    transform: "translate(85.351 -27.072)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M357.163,446.545c-2.366-7.475-6.251-16.775-11.638-20.272-9.6-6.158-25.193,3.522-33.585-.874s9.583-47.539-19.2-50.174-39.594,41.369-52.786,45.765-17.992-11.4-35.985-12.316c-15.73-.773-46.138,30.079-53.528,37.846Z",
    transform: "translate(50.488 -20.313)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M107.388,378.6s-23.552,1.825-56.982-21.818,32.238-107.33,58.26-125.525,79.429,98.233,59.5,120.064S127.245,377.7,107.388,378.6Z",
    transform: "translate(-27.216 -59.24)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M107.388,378.6s-23.552,1.825-56.982-21.818,32.238-107.33,58.26-125.525,79.429,98.233,59.5,120.064S127.245,377.7,107.388,378.6Z",
    transform: "translate(-27.216 -59.24)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M81.054,466.417l3.73-121.876L68.656,331.808l17.354,7.273V317.25L63.7,298.155l21.083,11.821L82.3,294.519l6.2,7.273,3.712-43.662,2.486,66.392,40.906-16.37L94.695,333.62V470.053",
    transform: "translate(-10.811 -51.551)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M439.207,298.291s-23.552,1.812-56.982-21.831,32.255-107.33,58.156-125.525S519.81,249.168,499.884,271,459.03,297.378,439.207,298.291Z",
    transform: "translate(209.16 -80.688)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M403.808,482.657,416.6,264.221l-16.11-12.734,17.354,7.273V236.93L395.52,217.835,416.6,229.657,414.117,214.2l6.2,7.273,3.73-43.662,2.469,66.405,40.906-16.383L426.515,253.3v11.834l-9.065,221.16",
    transform: "translate(225.565 -72.998)",
    fill: "#a8adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M155.685,435.119a8.152,8.152,0,0,0-4.679-4.941c-4.628-1.85-4.628,0-10.1-1.267-3.626-.824-2.9-6.817-3.194-8.869-.915-6.272-5.646-11.695-14.366-13.316-8.818-1.7-18.209.051-24.848,4.637-10.516,7.412-9.255,13.937-15.989,14.2S71.991,419.7,60.215,423.4a21.215,21.215,0,0,0-12.8,11.733Z",
    transform: "translate(-22.642 -12.042)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M155.685,435.119a8.152,8.152,0,0,0-4.679-4.941c-4.628-1.85-4.628,0-10.1-1.267-3.626-.824-2.9-6.817-3.194-8.869-.915-6.272-5.646-11.695-14.366-13.316-8.818-1.7-18.209.051-24.848,4.637-10.516,7.412-9.255,13.937-15.989,14.2S71.991,419.7,60.215,423.4a21.215,21.215,0,0,0-12.8,11.733Z",
    transform: "translate(-22.642 -12.042)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M53.72,434.412a9.549,9.549,0,0,1,8.15-6.145c6.285-.507,10.706,7.007,20.03.684s14.9-22.388,29.354-21.869,14.211,13.329,12.571,18.625,7.926,5.068,12.087,4.435,9.083,2.737,9.083,4.789",
    transform: "translate(-18.063 -11.779)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    x1: 5.111,
    y1: 3.408,
    transform: "translate(43.582 419.567)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    y1: 20.501,
    x2: 13.745,
    transform: "translate(79.895 402.652)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M83.25,414.09l1.64,6.665,10.947-4.447",
    transform: "translate(3.397 -9.905)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M78.13,419.48l5.595,7.526,10.93-2.572",
    transform: "translate(-0.324 -8.465)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M294.553,434.1a9.034,9.034,0,0,0-5.18-5.461c-5.18-2.053-5.18,0-11.172-1.368-4.006-.9-3.212-7.526-3.54-9.794-1-6.943-6.233-12.936-15.886-14.736-9.784-1.921-20.227-.006-27.627,5.068-11.638,8.2-10.24,15.369-17.682,15.711s-11.638-6.487-24.675-2.395c-7.995,2.534-12.087,8.628-14.142,12.974Z",
    transform: "translate(68.007 -13.13)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M294.553,434.1a9.034,9.034,0,0,0-5.18-5.461c-5.18-2.053-5.18,0-11.172-1.368-4.006-.9-3.212-7.526-3.54-9.794-1-6.943-6.233-12.936-15.886-14.736-9.784-1.921-20.227-.006-27.627,5.068-11.638,8.2-10.24,15.369-17.682,15.711s-11.638-6.487-24.675-2.395c-7.995,2.534-12.087,8.628-14.142,12.974Z",
    transform: "translate(68.007 -13.13)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    x1: 5.664,
    y1: 3.776,
    transform: "translate(263.726 417.071)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    y1: 22.68,
    x2: 15.195,
    transform: "translate(303.63 398.357)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M214.37,410.83l1.8,7.374,12.1-4.916",
    transform: "translate(96.692 -10.775)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M208.7,416.8l6.182,8.324,12.1-2.838",
    transform: "translate(92.623 -9.181)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M171.242,134.66s-35.346,0-45.654,42.141,16.2,52.949-16.2,74.552-36.814,36.744-20.6,46.462,25.02,20.526,4.4,36.744-23.552,39.987,50.075,55.116,129.5-21.616,132.526-46.462-22.1-41.064-23.57-61.59,50.075-39.975,44.169-68.065-58.9-17.295-73.61-38.9S206.588,134.66,171.242,134.66Z",
    transform: "translate(0.774 -84.521)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M362.178,154.257s-35.311.9-43.617,43.282,18.683,52.493-12.657,74.919-35.052,37.656-18.407,46.956,25.987,19.88,6.147,36.6-21.636,40.545,52.648,53.785S474.777,384.907,476.538,360s-24.019-40.469-26.471-60.944,48.141-41.216,40.923-69.091-59.675-15.775-75.423-37S397.489,153.357,362.178,154.257Z",
    transform: "translate(141.067 -79.296)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(418.806 74.929)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M362.178,154.257s-35.311.9-43.617,43.282,18.683,52.493-12.657,74.919-35.052,37.656-18.407,46.956,25.987,19.88,6.147,36.6-21.636,40.545,52.648,53.785S474.777,384.907,476.538,360s-24.019-40.469-26.471-60.944,48.141-41.216,40.923-69.091-59.675-15.775-75.423-37S397.489,153.357,362.178,154.257Z",
    transform: "translate(-277.738 -154.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M320.64,380.418l7.911-.2,5.74-131.066,9.087-22.707-10,15.045.9-14.47,15.886-25.994-15.727,16.381L331.2,179.18l-1.123,23.608-8.25-3.31,7.466,7.686-.614,27.906-6.757-7.258,6.132,13.055Z",
    transform: "translate(172.602 54.24)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M566.063,451.119c-3.074-9.756-8.133-21.882-15.178-26.4-12.5-8.033-32.808,4.6-43.79-1.14s12.5-62-25.037-65.442-51.629,53.963-68.844,59.7-23.466-14.926-46.932-16.079c-20.513-1-60.159,39.278-69.811,49.414Z",
    transform: "translate(153.583 -24.887)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M313.936,449.979c1.174-6.69,1.813-19.005-7.373-25.721-13.037-9.566-32.583,5.968-37.47,5.968s-6.527-9.553-21.187-17.928-32.583,2.395-42.356,0S213.7,372.855,186,371.664s-37.47,50.2-56.982,50.2-22.81-9.566-42.356-1.191C71.349,427.224,63.044,443.3,60.16,449.979Z",
    transform: "translate(-13.383 -21.239)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M313.936,449.979c1.174-6.69,1.813-19.005-7.373-25.721-13.037-9.566-32.583,5.968-37.47,5.968s-6.527-9.553-21.187-17.928-32.583,2.395-42.356,0S213.7,372.855,186,371.664s-37.47,50.2-56.982,50.2-22.81-9.566-42.356-1.191C71.349,427.224,63.044,443.3,60.16,449.979Z",
    transform: "translate(-13.383 -21.239)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    x1: 17.492,
    y1: 20.843,
    transform: "translate(81.864 406.289)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    y1: 60.399,
    x2: 8.737,
    transform: "translate(160.977 365.123)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    y1: 23.516,
    x2: 8.737,
    transform: "translate(210.924 403.083)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    y1: 16.573,
    x2: 8.754,
    transform: "translate(272.436 411.091)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M103.71,416.17,94.973,427.4,74.58,421.517",
    transform: "translate(-2.904 -9.349)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M124.36,387.06l10.188,13.367,13.848-12.3",
    transform: "translate(32.255 -17.122)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M120.98,403.94,134.1,415.7l13.106-7.488",
    transform: "translate(29.834 -12.615)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    y1: 7.475,
    x2: 17.474,
    transform: "translate(215.97 405.757)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x1: 8.754,
    y1: 16.573,
    transform: "translate(205.845 400.942)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x1: 4.386,
    y1: 10.694,
    transform: "translate(272.446 408.417)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    y1: 3.738,
    x2: 12.381,
    transform: "translate(275.327 417.515)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M306.152,204.852a95.7,95.7,0,0,0-21.411-21.679c-12.436-9.239-29.946-13.8-47.537-12.379-35.018,2.914-44.6,35.667-54.513,55.585C159,273.955,129.612,344.516,218.193,365.3c38.178,8.958,90.618,0,105.969-30.029,13.278-25.974,13.071-54.571,5.025-81.407C324.421,238.162,317.359,220.284,306.152,204.852Z",
    transform: "translate(56.186 -74.94)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M202,569.311h14.657l8.857-237.447,18.792-41.511L224.5,317.673l2.978-26.7,31.666-47.32-30.49,29.577L226.024,202.4,221.87,246,206.9,239.482l13.129,14.565-3.586,51.561-11.757-13.731,10.189,24.443Z",
    transform: "translate(87.744 -110.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M214.3,355.593l.242-6.183c-2.055,0-4.973.52-4.973,2.8C209.57,354.1,212.039,355.086,214.3,355.593Z",
    transform: "translate(93.279 -27.176)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M210.8,298.963c0,2.015,2.78,2.99,5.18,3.472l.242-6.335C214.167,296.163,210.8,296.518,210.8,298.963Z",
    transform: "translate(94.159 -41.411)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M209.88,321.428c0,2.154,3.194,3.13,5.664,3.56l.242-6.335C213.869,318.565,209.88,318.755,209.88,321.428Z",
    transform: "translate(93.499 -35.393)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M214.925,268.3c.673-2-2.556-2.078-4.973-1.875l-.432,6.335C211.316,271.976,214.2,270.4,214.925,268.3Z",
    transform: "translate(93.242 -49.355)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M206.49,429.48c0,2.357,3.816,3.307,6.337,3.674l.242-6.424C211.687,426.617,206.49,426.439,206.49,429.48Z",
    transform: "translate(91.071 -6.543)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M210.772,250.39l-.432,6.208a9.539,9.539,0,0,0,5.059-4.308C216.038,250.39,213.206,250.226,210.772,250.39Z",
    transform: "translate(93.83 -53.63)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M212,236.77c0,2.116,3.108,3.092,5.56,3.535l-.242-6.335C215.333,234.008,212,234.35,212,236.77Z",
    transform: "translate(95.018 -58.002)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M214.353,396.961c1.295-3.8-5.422-3.7-9.756-3.256l-.587,11.517C207.118,403.917,212.972,400.991,214.353,396.961Z",
    transform: "translate(89.286 -15.405)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M213.707,405.815s-6.907-.773-6.907,2.737c0,2.534,4.317,3.421,6.8,3.8l.224-6.006Z",
    transform: "translate(91.291 -12.134)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M207.72,368.794c0,3.028,3.453,4.827,7.062,5.866l.414-11.01C211.657,363.979,207.72,365.158,207.72,368.794Z",
    transform: "translate(91.949 -23.374)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M205.771,359.061l-.311,6.17a9.386,9.386,0,0,0,4.973-4.27C211.089,359,208.119,358.9,205.771,359.061Z",
    transform: "translate(90.337 -24.613)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M207.656,308.22l-.276,5.3a7.145,7.145,0,0,0,3.246-3.358C211.127,308.689,209.5,308.271,207.656,308.22Z",
    transform: "translate(91.716 -38.175)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M211.16,387.131c.829-2.42-4.11-2.027-6.354-1.723l-.345,6.715C205.5,391.743,210.21,389.906,211.16,387.131Z",
    transform: "translate(89.617 -17.624)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M370.2,236.48c.656-1.888-1.312-2.534-3.661-2.61l-.4,6.931a9.391,9.391,0,0,0,4.058-4.321Z",
    transform: "translate(205.366 -58.029)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M363.042,321.162l-.432,8.324c2.435-1.14,5.819-3.155,6.717-5.765S366.236,320.972,363.042,321.162Z",
    transform: "translate(202.826 -34.735)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M369.85,174.693,369.28,183c2.435-1.153,5.767-3.142,6.648-5.74S373.027,174.49,369.85,174.693Z",
    transform: "translate(207.601 -73.847)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M369.462,257.3a1.592,1.592,0,0,0,0-1.267,14.047,14.047,0,0,0,5.18-6.335c1.312-3.8-3.453-4.726-8.323-4.675l-.95,16.6A9.492,9.492,0,0,0,369.462,257.3Z",
    transform: "translate(204.789 -55.052)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M376.08,160.372l-.294-7.6c-2.477.19-4.348,1.733-4.317,3.56C371.47,158.345,373.629,159.6,376.08,160.372Z",
    transform: "translate(209.179 -79.685)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M367.762,205.488a9.834,9.834,0,0,0,2.469-2.534l-.138,1.875c2.435-1.09,6.337-3.206,7.287-6.031s-3.3-2.8-6.544-2.534l-.207,3.1-.138-.165v.874c-.967-.836-3.177-.95-5.18-.849Z",
    transform: "translate(204.733 -68.101)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M370.15,189.423c0,2.534,3.177,3.8,6.182,4.511l.294-2.686.225-5.588C374.087,185.723,370.15,186.344,370.15,189.423Z",
    transform: "translate(208.224 -70.902)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M361.27,365.723c1.4-.507,7.753-2.99,9.031-6.728,1.105-3.269-5.543-2.737-8.634-2.331Z",
    transform: "translate(201.856 -25.32)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M368.162,311.821a3.9,3.9,0,0,0,2.573,3.256l.311-6.487C369.231,309.094,368.067,310.4,368.162,311.821Z",
    transform: "translate(206.816 -38.076)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M375.157,261.631c-2.02-.139-8.737-.3-8.737,3.725,0,2.116,2.279,3.383,4.818,4.143a2.838,2.838,0,0,0-1.105,2.306c0,1.977,2,3.218,4.351,3.991Z",
    transform: "translate(205.544 -50.63)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M369.82,240.113c.158,1.768,1.742,3.3,4.023,3.877l.363-7.45c-2.507.171-4.415,1.726-4.386,3.573Z",
    transform: "translate(207.999 -57.316)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M376.04,207.732l.294-2.762c-4.351.621-8.634,2.344-8.634,6.766,0,4.092,4.576,6.5,9.514,7.919l.535-14.191Z",
    transform: "translate(206.454 -65.746)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M365.675,334.139c.129,2.688,2.184,5.126,5.4,6.411l.6-12.67c-3.726.824-6.206,3.407-6.009,6.259Z",
    transform: "translate(205.016 -32.925)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M372.54,375.708l.345-7.146c-2.711-1.267-7.718-1.039-11.431-.659l-.794,15.407A33.827,33.827,0,0,0,372.54,375.708Z",
    transform: "translate(201.405 -22.318)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M367.758,412.55c-2.236.322-3.824,1.788-3.747,3.459.106,1.6,1.447,3.017,3.453,3.649Z",
    transform: "translate(203.842 -10.316)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M364.42,387.828c0,1.989,2.037,3.231,4.4,4l.363-7.6C366.82,384.509,364.42,385.421,364.42,387.828Z",
    transform: "translate(204.132 -17.878)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M163.806,227.146S136.092,232.784,121.311,257s9.065,43.244-2.452,67.355S74.69,360.6,103.871,379.443s66.22-10.82,85.8-8.286,21.118,28.6,74.37,17.384,36.261-44.688,15.851-59.867-4.559-40.216-18.424-73.8C250.815,229.1,202,216.414,163.806,227.146Z",
    transform: "translate(9.798 -60.845)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M163.806,227.146S136.092,232.784,121.311,257s9.065,43.244-2.452,67.355S74.69,360.6,103.871,379.443s66.22-10.82,85.8-8.286,21.118,28.6,74.37,17.384,36.261-44.688,15.851-59.867-4.559-40.216-18.424-73.8C250.815,229.1,202,216.414,163.806,227.146Z",
    transform: "translate(9.798 -60.845)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M177.432,571.066l10.552-223.709L115.31,310l73.479,29.951.584-32.33-16.21-18.854,18.345,12.323L196.5,258.48l3.846,64.482,51.591-21.041-50.926,32.093-1.389,39.747,42.066-11.51-42.771,20.76-6.424,187.566Z",
    transform: "translate(6.177 -96.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M148.274,411.64l-.224,4.764v1.026a35.189,35.189,0,0,0,6.164-3.345C156.114,412.654,151.97,411.969,148.274,411.64Z",
    transform: "translate(49.237 -10.559)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M149.692,370.75l-.242,5.347a32.534,32.534,0,0,0,5.336-2.978C156.6,371.789,153.145,371.067,149.692,370.75Z",
    transform: "translate(50.241 -21.478)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M148.89,392.5a34.83,34.83,0,0,0,6.3-3.408c1.986-1.457-2.314-2.141-6.026-2.458l-.121,2.445Z",
    transform: "translate(49.838 -17.237)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M151.94,303.529v2.534a29.759,29.759,0,0,0,4.766-2.711c1.727-1.267-1.364-1.964-4.679-2.331Z",
    transform: "translate(52.024 -40.098)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M154.128,382.1a11.726,11.726,0,0,0,3.661.735l.173-5.068C155.112,379.088,151.417,381.115,154.128,382.1Z",
    transform: "translate(52.914 -19.603)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M153.834,367.769a27.96,27.96,0,0,0,5.715,1.457l.345-10.136C153.989,362.017,148.429,365.793,153.834,367.769Z",
    transform: "translate(51.803 -24.591)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M152.81,399.689a15.829,15.829,0,0,0,5.422,1.026l.242-7.1C154.536,395.369,148.994,398.283,152.81,399.689Z",
    transform: "translate(51.726 -15.371)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M157.693,412.7l.19-5.676c-2.625,1.064-8.634,3.8-5.439,4.979a11.382,11.382,0,0,0,5.249.7Z",
    transform: "translate(51.729 -11.793)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M150.389,351l-.259,5.6a32.772,32.772,0,0,0,5.8-3.193C157.831,351.963,153.981,351.266,150.389,351Z",
    transform: "translate(50.727 -26.751)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M293.653,464.625a8.967,8.967,0,0,0-5.18-5.461c-5.18-2.053-5.18,0-11.172-1.368-4.006-.9-3.212-7.6-3.54-9.807-1-6.931-6.233-12.924-15.886-14.723-9.784-1.939-20.238-.021-27.628,5.068-11.638,8.2-10.239,15.369-17.682,15.7s-11.638-6.487-24.675-2.382c-7.995,2.534-12.087,8.628-14.142,12.974Z",
    transform: "translate(67.364 -4.982)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M293.653,464.625a8.967,8.967,0,0,0-5.18-5.461c-5.18-2.053-5.18,0-11.172-1.368-4.006-.9-3.212-7.6-3.54-9.807-1-6.931-6.233-12.924-15.886-14.723-9.784-1.939-20.238-.021-27.628,5.068-11.638,8.2-10.239,15.369-17.682,15.7s-11.638-6.487-24.675-2.382c-7.995,2.534-12.087,8.628-14.142,12.974Z",
    transform: "translate(67.364 -4.982)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x1: 5.664,
    y1: 3.776,
    transform: "translate(262.182 455.741)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    y1: 22.68,
    x2: 15.212,
    transform: "translate(302.086 437.027)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M213.47,441.35l1.8,7.374,12.122-4.916",
    transform: "translate(96.048 -2.625)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M207.8,447.32l6.182,8.312,12.1-2.838",
    transform: "translate(91.979 -1.031)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M298.864,485.6a19.7,19.7,0,0,0-11.483-12.113c-11.362-4.549-11.362,0-24.778-3.028-8.893-2.015-7.131-16.712-7.857-21.742-2.227-15.394-13.814-28.7-35.26-32.664-21.688-4.029-44.895-.253-61.16,11.226-25.8,18.182-22.706,34.083-39.231,34.843s-25.711-14.393-54.668-5.309C46.763,462.4,37.525,475.954,33.07,485.6Z",
    transform: "translate(-33.07 -9.799)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x1: 12.571,
    y1: 8.375,
    transform: "translate(46.293 467.144)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    y1: 50.326,
    x2: 33.723,
    transform: "translate(134.541 425.624)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    y1: 5.03,
    x2: 10.844,
    transform: "translate(222.021 469.653)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M121.1,433.99l4.006,16.357,26.851-10.909",
    transform: "translate(29.913 -4.591)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M108.52,447.23l13.727,18.448,26.85-6.284",
    transform: "translate(20.901 -1.055)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M73.087,462.12l-2.3,9.224L58.22,469.672",
    transform: "translate(-14.793 2.921)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x1: 1.709,
    y1: 4.612,
    transform: "translate(223.737 467.98)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(149.127 427.461)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M133.644,431.267a1.359,1.359,0,0,1-1.045,1.311,2.384,2.384,0,0,1-2.047-.224,1.126,1.126,0,0,1-.48-1.478,1.909,1.909,0,0,1,1.69-.877A1.7,1.7,0,0,1,133.644,431.267Z",
    transform: "translate(36.286 -5.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(181.523 432.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M135.225,456.923a1.416,1.416,0,0,1-1.133,1.263,2.36,2.36,0,0,1-2.021-.291,1.107,1.107,0,0,1-.4-1.483,1.954,1.954,0,0,1,1.721-.831C134.4,455.587,135.216,456.184,135.225,456.923Z",
    transform: "translate(37.416 1.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(128.261 444.578)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(221.898 466.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M171.325,465.813a1.415,1.415,0,0,1-1.129,1.261,2.362,2.362,0,0,1-2.019-.286,1.109,1.109,0,0,1-.408-1.479,1.944,1.944,0,0,1,1.709-.84c1.014,0,1.838.6,1.848,1.343Z",
    transform: "translate(63.259 3.548)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(56.446 463.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M62.155,463.506c0,.749-.827,1.356-1.848,1.356s-1.848-.607-1.848-1.356.827-1.356,1.848-1.356S62.155,462.757,62.155,463.506Z",
    transform: "translate(-14.619 2.929)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(40.768 471.161)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M421.676,385.218s-27.99,2.167-67.739-25.923,38.281-127.5,69.207-149.1,94.331,116.681,70.675,142.617S445.228,384.141,421.676,385.218Z",
    transform: "translate(187.322 -64.961)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M390.36,489.536l4.42-144.784-19.132-15.116,20.617,8.641V312.341L369.76,289.649,394.78,303.7l-2.935-18.372,7.356,8.641,4.42-51.86,2.935,78.873,48.607-19.449L406.556,331.79V493.856",
    transform: "translate(206.844 -55.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M391.726,388.553c1.243-2.281-6.682-2.534-8.789-2.623l-.207,6.918C385.493,392.037,390.69,390.415,391.726,388.553Z",
    transform: "translate(217.217 -17.424)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M395.4,341.83c-4.023.735-12.26,2.534-9.86,4.257,1.9,1.381,6.492,1.939,9.86,2.154Z",
    transform: "translate(218.915 -29.2)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M391.8,357.706c1.261-2.306-8.185-2.306-8.185-2.306v.114l-.19,6.082C385.658,361.013,390.82,359.505,391.8,357.706Z",
    transform: "translate(217.721 -25.577)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M390.8,334.011c.932-1.723-4.058-2.167-6.665-2.281l-.173,5.74C386.464,336.722,390,335.455,390.8,334.011Z",
    transform: "translate(218.109 -31.897)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M382.862,412.86l-.622,3.206-.121,3.978c2.158-.532,8.858-2.357,10.05-4.561C393.6,412.86,382.862,412.86,382.862,412.86Z",
    transform: "translate(216.775 -10.233)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M384.826,375.287c2.141,1.571,7.3,2.192,11.137,2.458V370.46C391.353,371.309,382.115,373.3,384.826,375.287Z",
    transform: "translate(218.355 -21.555)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M385.182,322.421c2,1.47,7.08,2,10.481,2.192V318.05C391.951,318.7,382.644,320.521,385.182,322.421Z",
    transform: "translate(218.654 -35.55)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M393.877,289c-4.127.887-9.186,2.306-7.235,3.8,1.468,1.077,4.559,1.647,7.459,1.964Z",
    transform: "translate(201.998 -43.307)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M395.959,397.43c-4.61.849-13.814,2.838-11.137,4.827,2.141,1.571,7.3,2.2,11.137,2.458Z",
    transform: "translate(218.359 -14.353)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M385.11,302.19v5.917c2.5-.71,6.51-2.065,7.356-3.624C393.554,302.6,387.355,302.253,385.11,302.19Z",
    transform: "translate(218.929 -39.785)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M537.151,451.133c1.278-8.552-8.2-17.738-20.2-18.182-10.775-.38-22.62,4.929-31.6.545-7.339-3.586-7.494-11.239-8.323-17.738s-3.246-12.936-8.979-17.738-15.368-7.6-23.587-5.4c-16.559,4.473-17.578,24.4-34.534,28.077-11.707,2.534-23.915-4.6-35.933-3.016-14.712,1.926-21.36,13.874-32.652,19.715-1.174.608-6.078,3.218-11.707,6.234-4.714,2.534-9.929,5.334-13.814,7.5Z",
    transform: "translate(167.645 -15.841)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M537.151,451.133c1.278-8.552-8.2-17.738-20.2-18.182-10.775-.38-22.62,4.929-31.6.545-7.339-3.586-7.494-11.239-8.323-17.738s-3.246-12.936-8.979-17.738-15.368-7.6-23.587-5.4c-16.559,4.473-17.578,24.4-34.534,28.077-11.707,2.534-23.915-4.6-35.933-3.016-14.712,1.926-21.36,13.874-32.652,19.715-1.174.608-6.078,3.218-11.707,6.234-4.714,2.534-9.929,5.334-13.814,7.5Z",
    transform: "translate(167.645 -15.841)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x1: 9.29,
    y1: 19.918,
    transform: "translate(559.385 414.664)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    y1: 38.264,
    x2: 19.287,
    transform: "translate(601.216 396.849)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    y1: 7.868,
    x2: 11.431,
    transform: "translate(670.331 427.245)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    y1: 12.049,
    x2: 6.13,
    transform: "translate(566.091 417.819)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x1: 21.256,
    y1: 3.877,
    transform: "translate(543.715 423.052)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x1: 5.715,
    y1: 6.817,
    transform: "translate(596.031 401.563)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    y1: 8.375,
    x2: 20.703,
    transform: "translate(597.056 410.483)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    y1: 4.916,
    x2: 19.028,
    transform: "translate(602.881 427.245)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x1: 12.139,
    y1: 15.724,
    transform: "translate(593.446 411.002)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M397.285,408.586a1.426,1.426,0,0,1-1.145,1.254,2.356,2.356,0,0,1-2.016-.3,1.105,1.105,0,0,1-.389-1.482,1.956,1.956,0,0,1,1.719-.828,2.208,2.208,0,0,1,1.3.4A1.189,1.189,0,0,1,397.285,408.586Z",
    transform: "translate(212.678 -11.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M390.555,412.216c0,.749-.827,1.356-1.848,1.356s-1.848-.607-1.848-1.356.827-1.356,1.848-1.356a2.216,2.216,0,0,1,1.312.393A1.191,1.191,0,0,1,390.555,412.216Z",
    transform: "translate(218.856 -10.767)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(627.042 409.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(591.652 409.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(620.152 425.687)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(679.189 426.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M361.715,422.643a1.415,1.415,0,0,1-1.129,1.262,2.362,2.362,0,0,1-2.019-.286,1.109,1.109,0,0,1-.408-1.479,1.943,1.943,0,0,1,1.709-.84c1.014,0,1.838.6,1.848,1.343Z",
    transform: "translate(199.555 -7.979)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(570.032 416.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 1.848,
    cy: 1.356,
    rx: 1.848,
    ry: 1.356,
    transform: "translate(541.961 421.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M536.291,461.789c-.764-2.762-3.044-5.172-6.3-6.665-6.251-2.534-6.251,0-13.624-1.66-4.887-1.1-3.92-9.186-4.317-11.961-1.226-8.451-7.615-15.762-19.391-17.954-11.917-2.358-24.649-.024-33.654,6.17-14.194,10-12.484,18.739-21.567,19.158s-14.194-7.906-30.08-2.914c-9.756,3.066-14.8,10.516-17.267,15.825Z",
    transform: "translate(221.619 -7.619)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x1: 6.907,
    y1: 4.612,
    transform: "translate(637.212 449.406)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    y1: 27.659,
    x2: 18.545,
    transform: "translate(686.217 426.587)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M438.52,433.41l2.193,8.983,14.763-5.993",
    transform: "translate(256.814 -4.746)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M431.61,440.69l7.529,10.136,14.763-3.459",
    transform: "translate(251.792 -2.802)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-2-2",
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(-33.264 1062.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172-2",
    "data-name": "Path 2172",
    d: "M47.576,428.833c1.512-9.161,22.532,4.587,22.532,4.587a39.132,39.132,0,0,1-4.5-17.181c0-9.161,14.955,2.281,14.955,2.281S70.042,403.632,71.537,387.6,95.582,389.9,95.582,389.9s-9.023-24.074-10.518-30.928,42.057,8.02,42.057,8.02a174.052,174.052,0,0,1-4.5-20.615c-.781-5.271,6.647-3.079,14.157.329,1.662-4.587,6.1-4.9,11.033-3.472-.316-1.14-.665-2.382-1.047-3.712-1.662-6.17,9.87.786,19.458,7.361,1.16-8.013,5.914-15.474,13.459-21.121,7.261-5.537,15.088.633,21.6,9.3l10.784,2.534a49.409,49.409,0,0,1,.665-4.941c1.944-10.364,13.293.811,21.087,10.009l8.308,1.951c1.329-6.487,4.586-15.952,12.6-23.415,13.509-12.594,45.065,22.908,45.065,22.908s19.525-24.074,27.035-11.4-3.008,38.948-3.008,38.948,4.5-9.173,10.5-11.4,22.532,8.008,22.532,8.008-9.006-16.028,0-21.755c8.159-5.182,18.744,13.038,20.7,16.585-1.379-2.686-6.647-14.317-2.675-30.333,4.5-18.321,22.532,5.727,22.532,5.727s-3.008-22.908,13.509-26.342-7.511,0,9.023,22.908,10.5-16.028,34.546-13.747S472.5,392.317,472.5,392.317l94.765-41.33s4.5-6.88,19.757-8.958,5.766,15.851,5.766,15.851,21.037-14.888,30.043-14.888c2.343,0,9.538,7.944,18.91,19.7.681-1.2,1.379-2.433,2.11-3.674,5.7-9.541,10.518,11.8,12.529,22.705l1.662,2.192c1.213-5.385,4.752-14.634,14.357-14.634,11.632,0,5.467,30.561,3.523,39.05v.1c1.5-4.827,5.8-16.471,12.928-17.4,9.006-1.14,1.512,25.2,1.512,25.2s6-3.434,10.5-3.434c3.323,0-1.279,15.977-4.071,24.96,9.472,13.43,15.9,22.743,15.9,22.743l-59.82-24.8H338.5l15.2,16.041H53.641S46.08,438.019,47.576,428.833Z",
    transform: "translate(1.993 -37.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174-2",
    "data-name": "Path 2174",
    d: "M49.82,455.13c4.28-11.758,11.286-26.354,21.054-31.8,17.341-9.68,45.547,5.537,60.729-1.381s-17.341-74.666,34.754-78.809,71.594,64.986,95.465,71.891,32.541-17.966,65.082-19.348c28.444-1.267,83.429,47.235,96.8,59.449Z",
    transform: "translate(286.518 -28.899)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175-2",
    "data-name": "Path 2175",
    d: "M49.82,455.13c4.28-11.758,11.286-26.354,21.054-31.8,17.341-9.68,45.547,5.537,60.729-1.381s-17.341-74.666,34.754-78.809,71.594,64.986,95.465,71.891,32.541-17.966,65.082-19.348c28.444-1.267,83.429,47.235,96.8,59.449Z",
    transform: "translate(286.518 -28.899)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176-2",
    "data-name": "Path 2176",
    d: "M237.9,481.732H225.882l-7.317-183.719-15.42-32.2,16.225,21.172-2.4-20.678L191,229.695l24.95,22.857,2.158-54.812,3.329,33.741,12.274-5.068-10.756,11.277,2.927,39.911,9.713-10.63-8.359,18.917Z",
    transform: "translate(239.537 -67.676)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177-2",
    "data-name": "Path 2177",
    d: "M149.508,481.732H137.491l-7.317-183.719-15.4-32.132,16.243,21.172L128.6,266.375l-26.011-36.63,25.023,22.807,2.14-54.812,3.4,33.741,12.274-5.068-10.756,11.277L137.6,277.6l9.731-10.63-8.378,18.917Z",
    transform: "translate(475.395 -67.676)",
    fill: "#a8adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178-2",
    "data-name": "Path 2178",
    d: "M338.017,467.868H326l-7.317-141.211-15.475-24.618,16.243,16.269-2.4-15.889L291.08,274.164,316.1,291.776l2.158-42.116L321.7,275.6l12.255-3.877L323.2,280.373l2.945,30.675,9.713-8.172L327.5,317.408Z",
    transform: "translate(-27.508 -53.812)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179-2",
    "data-name": "Path 2179",
    d: "M261.277,467.868H249.259l-7.317-141.211-15.457-24.618,16.225,16.269-2.4-15.889L214.34,274.164l25.023,17.612,2.158-42.116,3.4,25.936,12.274-3.877-10.774,8.654,2.945,30.675,9.713-8.172-8.359,14.533Z",
    transform: "translate(177.232 -53.812)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180-2",
    "data-name": "Path 2180",
    d: "M311.508,467.868h-12l-7.317-141.211-15.475-24.618,16.243,16.269-2.415-15.889L264.59,274.164l25.023,17.612,2.158-42.116,3.384,25.936,12.274-3.877-10.756,8.654,2.927,30.675,9.731-8.172-8.378,14.533Z",
    transform: "translate(43.184 -53.812)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181-2",
    "data-name": "Path 2181",
    d: "M456.952,481.729H444.934L437.617,298.01l-15.4-32.132,16.225,21.172-2.4-20.678L410.07,229.755l25.023,22.807,2.158-54.812,3.366,33.728,12.274-5.068-10.756,11.277,2.927,39.911,9.713-10.63-8.359,18.917Z",
    transform: "translate(-338.622 -67.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182-2",
    "data-name": "Path 2182",
    d: "M417.293,481.732h-12l-7.317-183.719-15.42-32.132L398.8,287.053l-2.415-20.678-26.066-36.63,25.023,22.807L397.5,197.74l3.384,33.741,12.274-5.068L402.4,237.689,405.33,277.6l9.731-10.63-8.378,18.917Z",
    transform: "translate(-238.952 -67.676)",
    fill: "#8a9094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-2",
    "data-name": "Path 2183",
    d: "M349.088,481.732h-12l-7.317-183.719-15.4-32.132,16.243,21.172L328.2,266.375l-26.029-36.63,25.023,22.807,2.085-54.812,3.384,33.741,12.274-5.068-10.756,11.277,2.927,39.911,9.731-10.63-8.378,18.917Z",
    transform: "translate(-57.078 -67.676)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-2",
    "data-name": "Path 2184",
    d: "M224.27,455.13c3.658-11.758,9.768-26.354,18.2-31.8,15.018-9.68,39.437,5.537,52.571-1.381s-15.018-74.666,30.035-78.809,61.954,64.986,82.606,71.891,28.169-17.966,56.32-19.348c24.621-1.267,72.2,47.235,83.776,59.449Z",
    transform: "translate(-108.235 -28.899)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-2",
    "data-name": "Path 2185",
    d: "M224.27,455.13c3.658-11.758,9.768-26.354,18.2-31.8,15.018-9.68,39.437,5.537,52.571-1.381s-15.018-74.666,30.035-78.809,61.954,64.986,82.606,71.891,28.169-17.966,56.32-19.348c24.621-1.267,72.2,47.235,83.776,59.449Z",
    transform: "translate(-108.235 -28.899)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186-2",
    "data-name": "Path 2186",
    d: "M344.072,202.44s25.993,0,33.565,29.256-11.908,36.744,11.926,51.771,27.072,25.518,15.164,32.271-18.42,14.254-3.256,25.505S418.812,369,364.65,379.507s-95.318-15-97.5-32.259,16.261-28.521,17.341-42.775-36.84-27.761-32.5-47.26S295.324,245.2,306.153,230.2,318.079,202.44,344.072,202.44Z",
    transform: "translate(-29.028 -66.421)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187-2",
    "data-name": "Path 2187",
    d: "M344.072,202.44s25.993,0,33.565,29.256-11.908,36.744,11.926,51.771,27.072,25.518,15.164,32.271-18.42,14.254-3.256,25.505S418.812,369,364.65,379.507s-95.318-15-97.5-32.259,16.261-28.521,17.341-42.775-36.84-27.761-32.5-47.26S295.324,245.2,306.153,230.2,318.079,202.44,344.072,202.44Z",
    transform: "translate(-29.028 -66.421)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188-2",
    "data-name": "Path 2188",
    d: "M322.65,482.135h-9.493l-13.426-183.06-12.182-25.341,12.8,16.737-1.829-16.345L278,245.162l19.773,18.081,1.719-43.332,2.671,26.608,9.713-3.978-8.506,8.869,2.323,31.549,7.683-8.4-6.622,14.951Z",
    transform: "translate(9.557 -61.756)",
    fill: "#92989b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189-2",
    "data-name": "Path 2189",
    d: "M442.969,453.3c-2.78-10.846-7.317-24.327-13.7-29.344-11.3-8.933-29.651,5.068-39.547-1.267s11.3-68.9-22.59-72.728-46.607,59.969-62.192,66.354-21.182-16.6-42.364-17.865c-18.53-1.115-54.308,43.6-63.015,54.862Z",
    transform: "translate(29.534 -27.072)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190-2",
    "data-name": "Path 2190",
    d: "M442.969,453.3c-2.78-10.846-7.317-24.327-13.7-29.344-11.3-8.933-29.651,5.068-39.547-1.267s11.3-68.9-22.59-72.728-46.607,59.969-62.192,66.354-21.182-16.6-42.364-17.865c-18.53-1.115-54.308,43.6-63.015,54.862Z",
    transform: "translate(29.534 -27.072)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191-2",
    "data-name": "Path 2191",
    d: "M150.44,446.545c2.506-7.475,6.622-16.775,12.329-20.272,10.17-6.158,26.688,3.522,35.578-.874s-10.152-47.539,20.34-50.174,41.943,41.369,55.918,45.765,19.06-11.4,38.12-12.316c16.664-.773,48.876,30.079,56.7,37.846Z",
    transform: "translate(181.19 -20.313)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192-2",
    "data-name": "Path 2192",
    d: "M110.128,378.6s24.95,1.825,60.363-21.818S136.34,249.45,108.775,231.255,24.632,329.488,45.741,351.319,89.093,377.7,110.128,378.6Z",
    transform: "translate(545.804 -59.24)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193-2",
    "data-name": "Path 2193",
    d: "M110.128,378.6s24.95,1.825,60.363-21.818S136.34,249.45,108.775,231.255,24.632,329.488,45.741,351.319,89.093,377.7,110.128,378.6Z",
    transform: "translate(545.804 -59.24)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194-2",
    "data-name": "Path 2194",
    d: "M121.484,466.417l-3.951-121.876,17.085-12.734-18.383,7.273V317.25l23.633-19.094-22.334,11.821,2.634-15.458-6.567,7.273-3.933-43.662-2.634,66.392L63.7,308.152l43.333,25.467V470.053",
    transform: "translate(544.966 -51.551)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195-2",
    "data-name": "Path 2195",
    d: "M441.831,298.291s24.95,1.812,60.363-21.831-34.169-107.33-61.607-125.525S356.445,249.168,377.554,271,420.832,297.378,441.831,298.291Z",
    transform: "translate(-325.788 -80.688)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197-2",
    "data-name": "Path 2197",
    d: "M47.42,435.119a8.36,8.36,0,0,1,4.957-4.941c4.9-1.85,4.9,0,10.7-1.267,3.841-.824,3.073-6.817,3.384-8.869.969-6.272,5.981-11.695,15.219-13.316,9.341-1.7,19.29.051,26.322,4.637,11.14,7.412,9.8,13.937,16.938,14.2s11.14-5.866,23.615-2.167a21.979,21.979,0,0,1,13.554,11.733Z",
    transform: "translate(552.503 -12.042)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198-2",
    "data-name": "Path 2198",
    d: "M47.42,435.119a8.36,8.36,0,0,1,4.957-4.941c4.9-1.85,4.9,0,10.7-1.267,3.841-.824,3.073-6.817,3.384-8.869.969-6.272,5.981-11.695,15.219-13.316,9.341-1.7,19.29.051,26.322,4.637,11.14,7.412,9.8,13.937,16.938,14.2s11.14-5.866,23.615-2.167a21.979,21.979,0,0,1,13.554,11.733Z",
    transform: "translate(552.503 -12.042)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199-2",
    "data-name": "Path 2199",
    d: "M150.41,434.412a9.959,9.959,0,0,0-8.634-6.145c-6.658-.507-11.341,7.007-21.218.684s-15.786-22.388-31.1-21.869-15.054,13.329-13.316,18.625-8.4,5.068-12.8,4.435-9.621,2.737-9.621,4.789",
    transform: "translate(552.678 -11.779)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258-2",
    "data-name": "Line 258",
    y1: 3.408,
    x2: 5.414,
    transform: "translate(689.278 419.567)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259-2",
    "data-name": "Line 259",
    x1: 14.56,
    y1: 20.501,
    transform: "translate(641.664 402.652)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200-2",
    "data-name": "Path 2200",
    d: "M96.585,414.09l-1.738,6.665-11.6-4.447",
    transform: "translate(552.488 -9.905)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201-2",
    "data-name": "Path 2201",
    d: "M95.635,419.48l-5.927,7.526L78.13,424.434",
    transform: "translate(562.803 -8.465)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202-2",
    "data-name": "Path 2202",
    d: "M174.65,434.1c.68-2.262,2.662-4.234,5.487-5.461,5.488-2.053,5.488,0,11.835-1.368,4.244-.9,3.4-7.526,3.75-9.794,1.061-6.943,6.6-12.936,16.828-14.736,10.365-1.921,21.427-.006,29.267,5.068,12.329,8.2,10.847,15.369,18.731,15.711s12.329-6.487,26.139-2.395A24.482,24.482,0,0,1,301.668,434.1Z",
    transform: "translate(205.726 -13.13)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203-2",
    "data-name": "Path 2203",
    d: "M174.65,434.1c.68-2.262,2.662-4.234,5.487-5.461,5.488-2.053,5.488,0,11.835-1.368,4.244-.9,3.4-7.526,3.75-9.794,1.061-6.943,6.6-12.936,16.828-14.736,10.365-1.921,21.427-.006,29.267,5.068,12.329,8.2,10.847,15.369,18.731,15.711s12.329-6.487,26.139-2.395A24.482,24.482,0,0,1,301.668,434.1Z",
    transform: "translate(205.726 -13.13)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260-2",
    "data-name": "Line 260",
    y1: 3.776,
    x2: 6,
    transform: "translate(477.23 417.071)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261-2",
    "data-name": "Line 261",
    x1: 16.097,
    y1: 22.68,
    transform: "translate(428.473 398.357)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204-2",
    "data-name": "Path 2204",
    d: "M229.095,410.83l-1.9,7.374-12.823-4.916",
    transform: "translate(208.177 -10.775)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205-2",
    "data-name": "Path 2205",
    d: "M228.071,416.8l-6.548,8.324L208.7,422.286",
    transform: "translate(218.855 -9.181)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M177.715,134.66s27.594,0,35.642,21.653S200.712,183.52,226,194.62s28.74,18.88,16.082,23.873-19.533,10.547-3.438,18.88,18.387,20.547-39.093,28.32S98.45,254.587,96.09,241.82s17.255-21.1,18.4-31.647S75.4,189.633,80.008,175.2s45.982-8.887,57.467-19.987S150.12,134.66,177.715,134.66Z",
    transform: "translate(345.92 41.181)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209-2",
    "data-name": "Path 2209",
    d: "M414.943,154.257s37.407.9,46.205,43.282-19.792,52.493,13.408,74.919,37.132,37.656,19.5,46.956-27.529,19.88-6.512,36.6,22.92,40.545-55.772,53.785S295.662,384.907,293.8,360s25.444-40.469,28.041-60.944-51-41.216-43.351-69.091,63.216-15.775,79.9-37S377.536,153.357,414.943,154.257Z",
    transform: "translate(-159.435 -79.296)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_89-2",
    "data-name": "Group 89",
    transform: "translate(118.303 74.929)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210-2",
    "data-name": "Path 2210",
    d: "M414.943,154.257s37.407.9,46.205,43.282-19.792,52.493,13.408,74.919,37.132,37.656,19.5,46.956-27.529,19.88-6.512,36.6,22.92,40.545-55.772,53.785S295.662,384.907,293.8,360s25.444-40.469,28.041-60.944-51-41.216-43.351-69.091,63.216-15.775,79.9-37S377.536,153.357,414.943,154.257Z",
    transform: "translate(-277.739 -154.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211-2",
    "data-name": "Path 2211",
    d: "M359.475,429.04l-10.405-.251-7.55-162.733-11.951-28.193,13.149,18.68-1.184-17.966L320.64,206.3l20.685,20.339,4.262-47.461,1.476,29.312,10.851-4.11-9.82,9.542.808,34.648,8.887-9.012-8.065,16.21Z",
    transform: "translate(-89.01 5.618)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212-2",
    "data-name": "Path 2212",
    d: "M296.47,451.119c3.256-9.756,8.615-21.882,16.078-26.4,13.243-8.033,34.754,4.6,46.388-1.14s-13.243-62,26.523-65.442,54.692,53.963,72.929,59.7,24.859-14.926,49.717-16.079c21.731-1,63.729,39.278,73.954,49.414Z",
    transform: "translate(-255.935 -24.887)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213-2",
    "data-name": "Path 2213",
    d: "M60.861,449.979c-1.244-6.69-1.921-19.005,7.811-25.721,13.81-9.566,34.517,5.968,39.693,5.968s6.914-9.553,22.444-17.928,34.517,2.395,44.87,0-8.634-39.443,20.706-40.634,39.693,50.2,60.363,50.2,24.163-9.566,44.87-1.191c16.225,6.551,25.023,22.629,28.078,29.306Z",
    transform: "translate(361.613 -21.239)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214-2",
    "data-name": "Path 2214",
    d: "M60.861,449.979c-1.244-6.69-1.921-19.005,7.811-25.721,13.81-9.566,34.517,5.968,39.693,5.968s6.914-9.553,22.444-17.928,34.517,2.395,44.87,0-8.634-39.443,20.706-40.634,39.693,50.2,60.363,50.2,24.163-9.566,44.87-1.191c16.225,6.551,25.023,22.629,28.078,29.306Z",
    transform: "translate(361.613 -21.239)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262-2",
    "data-name": "Line 262",
    y1: 20.843,
    x2: 18.53,
    transform: "translate(635.61 406.289)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263-2",
    "data-name": "Line 263",
    x1: 9.256,
    y1: 60.399,
    transform: "translate(574.403 365.123)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264-2",
    "data-name": "Line 264",
    x1: 9.256,
    y1: 23.516,
    transform: "translate(525.627 403.083)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265-2",
    "data-name": "Line 265",
    x1: 9.274,
    y1: 16.573,
    transform: "translate(465.54 411.091)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215-2",
    "data-name": "Path 2215",
    d: "M74.58,416.17,83.836,427.4l21.6-5.879",
    transform: "translate(559.493 -9.349)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216-2",
    "data-name": "Path 2216",
    d: "M149.822,387.06,139.03,400.427l-14.67-12.3",
    transform: "translate(438.366 -17.122)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217-2",
    "data-name": "Path 2217",
    d: "M148.765,403.94l-13.9,11.758L120.98,408.21",
    transform: "translate(445.117 -12.615)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266-2",
    "data-name": "Line 266",
    x1: 18.511,
    y1: 7.475,
    transform: "translate(511.655 405.757)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267-2",
    "data-name": "Line 267",
    y1: 16.573,
    x2: 9.274,
    transform: "translate(530.569 400.942)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268-2",
    "data-name": "Line 268",
    y1: 10.694,
    x2: 4.646,
    transform: "translate(470.027 408.417)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269-2",
    "data-name": "Line 269",
    x1: 13.115,
    y1: 3.738,
    transform: "translate(458.986 417.515)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218-2",
    "data-name": "Path 2218",
    d: "M188.63,204.852a98.615,98.615,0,0,1,22.682-21.679c13.174-9.239,31.723-13.8,50.357-12.379,37.1,2.914,47.248,35.667,57.747,55.585,25.1,47.577,56.229,118.138-37.608,138.917-40.443,8.958-96,0-112.257-30.029-14.066-25.974-13.847-54.571-5.323-81.407C169.277,238.162,176.758,220.284,188.63,204.852Z",
    transform: "translate(191.273 -74.94)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219-2",
    "data-name": "Path 2219",
    d: "M255.339,525.721H241.657l-8.268-209.237L215.847,279.9l18.493,24.074-2.78-23.529L202,238.751l28.462,26.063,2.451-62.414,3.878,38.416,13.975-5.74L238.51,247.912l3.347,45.436,10.975-12.1-9.512,21.539Z",
    transform: "translate(203.983 -66.432)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220-2",
    "data-name": "Path 2220",
    d: "M209.826,355.593l-.256-6.183c2.177,0,5.268.52,5.268,2.8C214.838,354.1,212.222,355.086,209.826,355.593Z",
    transform: "translate(230.15 -27.176)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221-2",
    "data-name": "Path 2221",
    d: "M216.544,298.963c0,2.015-2.945,2.99-5.488,3.472L210.8,296.1C212.977,296.163,216.544,296.518,216.544,298.963Z",
    transform: "translate(226.398 -41.411)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222-2",
    "data-name": "Path 2222",
    d: "M216.136,321.428c0,2.154-3.384,3.13-6,3.56l-.256-6.335C211.91,318.565,216.136,318.755,216.136,321.428Z",
    transform: "translate(228.365 -35.393)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223-2",
    "data-name": "Path 2223",
    d: "M209.616,268.3c-.713-2,2.707-2.078,5.268-1.875l.457,6.335C213.439,271.976,210.384,270.4,209.616,268.3Z",
    transform: "translate(229.749 -49.355)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224-2",
    "data-name": "Path 2224",
    d: "M213.459,429.48c0,2.357-4.042,3.307-6.713,3.674l-.256-6.424C207.953,426.617,213.459,426.439,213.459,429.48Z",
    transform: "translate(236.748 -6.543)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225-2",
    "data-name": "Path 2225",
    d: "M215.339,250.39l.457,6.208a9.96,9.96,0,0,1-5.359-4.308C209.76,250.39,212.76,250.226,215.339,250.39Z",
    transform: "translate(227.907 -53.63)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226-2",
    "data-name": "Path 2226",
    d: "M217.89,236.77c0,2.116-3.292,3.092-5.89,3.535l.256-6.335C214.36,234.008,217.89,234.35,217.89,236.77Z",
    transform: "translate(223.045 -58.002)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227-2",
    "data-name": "Path 2227",
    d: "M204.183,396.961c-1.372-3.8,5.744-3.7,10.335-3.256l.622,11.517C211.847,403.917,205.646,400.991,204.183,396.961Z",
    transform: "translate(239.361 -15.405)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228-2",
    "data-name": "Path 2228",
    d: "M206.928,405.815s7.317-.773,7.317,2.737c0,2.534-4.573,3.421-7.207,3.8l-.238-6.006Z",
    transform: "translate(235.458 -12.134)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229-2",
    "data-name": "Path 2229",
    d: "M215.64,368.794c0,3.028-3.658,4.827-7.481,5.866l-.439-11.01C211.47,363.979,215.64,365.158,215.64,368.794Z",
    transform: "translate(232.537 -23.374)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230-2",
    "data-name": "Path 2230",
    d: "M210.5,359.061l.329,6.17a9.794,9.794,0,0,1-5.268-4.27C204.863,359,208.009,358.9,210.5,359.061Z",
    transform: "translate(241.055 -24.613)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231-2",
    "data-name": "Path 2231",
    d: "M210.624,308.22l.293,5.3a7.344,7.344,0,0,1-3.439-3.358C206.947,308.689,208.666,308.271,210.624,308.22Z",
    transform: "translate(237.685 -38.175)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232-2",
    "data-name": "Path 2232",
    d: "M204.558,387.131c-.878-2.42,4.353-2.027,6.731-1.723l.366,6.715C210.558,391.743,205.564,389.906,204.558,387.131Z",
    transform: "translate(241.961 -17.624)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M347.611,129.4a98.248,98.248,0,0,1,22.682-21.679c13.178-9.243,31.735-13.8,50.376-12.379,37.077,2.9,47.248,35.667,57.747,55.572,25.151,47.59,56.284,118.151-37.626,138.93-40.461,8.958-96.013,0-112.257-30.029-14.066-25.987-13.847-54.571-5.341-81.407C328.259,162.712,335.74,144.834,347.611,129.4Z",
    transform: "translate(-216.24 -95.088)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M347.611,129.4a98.248,98.248,0,0,1,22.682-21.679c13.178-9.243,31.735-13.8,50.376-12.379,37.077,2.9,47.248,35.667,57.747,55.572,25.151,47.59,56.284,118.151-37.626,138.93-40.461,8.958-96.013,0-112.257-30.029-14.066-25.987-13.847-54.571-5.341-81.407C328.259,162.712,335.74,144.834,347.611,129.4Z",
    transform: "translate(-216.24 -95.088)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236-2",
    "data-name": "Path 2236",
    d: "M366.275,236.48c-.7-1.888,1.39-2.534,3.878-2.61l.421,6.931a9.63,9.63,0,0,1-4.3-4.321Z",
    transform: "translate(-188.103 -58.029)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237-2",
    "data-name": "Path 2237",
    d: "M369.4,321.162l.457,8.324c-2.579-1.14-6.164-3.155-7.116-5.765S366.02,320.972,369.4,321.162Z",
    transform: "translate(-181.296 -34.735)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238-2",
    "data-name": "Path 2238",
    d: "M375.856,174.693l.6,8.312c-2.579-1.153-6.11-3.142-7.042-5.74S372.49,174.49,375.856,174.693Z",
    transform: "translate(-199.077 -73.847)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239-2",
    "data-name": "Path 2239",
    d: "M371.091,257.3a1.511,1.511,0,0,1,0-1.267A14.242,14.242,0,0,1,365.6,249.7c-1.39-3.8,3.658-4.726,8.817-4.675l1.006,16.6A9.74,9.74,0,0,1,371.091,257.3Z",
    transform: "translate(-191.307 -55.052)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240-2",
    "data-name": "Path 2240",
    d: "M371.47,160.372l.311-7.6c2.624.19,4.606,1.733,4.573,3.56C376.354,158.345,374.067,159.6,371.47,160.372Z",
    transform: "translate(-202.79 -79.685)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241-2",
    "data-name": "Path 2241",
    d: "M375.642,205.488a10.121,10.121,0,0,1-2.616-2.534l.146,1.875c-2.579-1.09-6.713-3.206-7.719-6.031s3.494-2.8,6.933-2.534l.219,3.1.146-.165v.874c1.024-.836,3.366-.95,5.488-.849Z",
    transform: "translate(-193.835 -68.101)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242-2",
    "data-name": "Path 2242",
    d: "M377.247,189.423c0,2.534-3.366,3.8-6.548,4.511l-.311-2.686-.238-5.588C373.077,185.723,377.247,186.344,377.247,189.423Z",
    transform: "translate(-201.328 -70.902)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243-2",
    "data-name": "Path 2243",
    d: "M370.966,365.723c-1.482-.507-8.213-2.99-9.567-6.728-1.171-3.269,5.872-2.737,9.146-2.331Z",
    transform: "translate(-180.001 -25.32)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244-2",
    "data-name": "Path 2244",
    d: "M371.211,311.821a3.948,3.948,0,0,1-2.725,3.256l-.329-6.487C370.079,309.094,371.313,310.4,371.211,311.821Z",
    transform: "translate(-192.215 -38.076)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245-2",
    "data-name": "Path 2245",
    d: "M366.42,261.631c2.14-.139,9.256-.3,9.256,3.725,0,2.116-2.415,3.383-5.1,4.143a2.779,2.779,0,0,1,1.171,2.306c0,1.977-2.122,3.218-4.609,3.991Z",
    transform: "translate(-193.367 -50.63)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246-2",
    "data-name": "Path 2246",
    d: "M374.466,240.113c-.167,1.768-1.846,3.3-4.262,3.877l-.384-7.45c2.655.171,4.677,1.726,4.646,3.573Z",
    transform: "translate(-198.151 -57.316)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247-2",
    "data-name": "Path 2247",
    d: "M369.511,207.732l-.311-2.762c4.61.621,9.146,2.344,9.146,6.766,0,4.092-4.847,6.5-10.079,7.919l-.567-14.191Z",
    transform: "translate(-198.092 -65.746)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248-2",
    "data-name": "Path 2248",
    d: "M372.029,334.139c-.137,2.688-2.314,5.126-5.725,6.411l-.64-12.67c3.948.824,6.574,3.407,6.365,6.259Z",
    transform: "translate(-188.648 -32.925)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249-2",
    "data-name": "Path 2249",
    d: "M361.026,375.708l-.366-7.146c2.872-1.267,8.176-1.039,12.109-.659l.841,15.407A36.14,36.14,0,0,1,361.026,375.708Z",
    transform: "translate(-181.417 -22.318)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250-2",
    "data-name": "Path 2250",
    d: "M364.008,412.55c2.369.322,4.051,1.788,3.969,3.459-.113,1.6-1.533,3.017-3.658,3.649Z",
    transform: "translate(-181.965 -10.316)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251-2",
    "data-name": "Path 2251",
    d: "M369.468,387.828c0,1.989-2.158,3.231-4.664,4l-.384-7.6C366.926,384.509,369.468,385.421,369.468,387.828Z",
    transform: "translate(-184.075 -17.878)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252-2",
    "data-name": "Path 2252",
    d: "M235.9,227.146s29.358,5.638,45.016,29.851-9.6,43.244,2.6,67.355,46.79,36.25,15.877,55.091-70.149-10.82-90.892-8.286-22.371,28.6-78.783,17.384-38.413-44.688-16.792-59.867,4.829-40.216,19.517-73.8C143.73,229.1,195.441,216.414,235.9,227.146Z",
    transform: "translate(321.053 -60.845)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253-2",
    "data-name": "Path 2253",
    d: "M235.9,227.146s29.358,5.638,45.016,29.851-9.6,43.244,2.6,67.355,46.79,36.25,15.877,55.091-70.149-10.82-90.892-8.286-22.371,28.6-78.783,17.384-38.413-44.688-16.792-59.867,4.829-40.216,19.517-73.8C143.73,229.1,195.441,216.414,235.9,227.146Z",
    transform: "translate(321.053 -60.845)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254-2",
    "data-name": "Path 2254",
    d: "M182.99,526.52,173.4,334.692l66.015-32.031-66.747,25.683-.53-27.723,14.725-16.167L170.2,295.021l-4.536-36.541-3.494,55.293L115.31,295.731l46.26,27.52,1.262,34.083-38.212-9.87,38.852,17.8L169.307,526.1Z",
    transform: "translate(365.764 -51.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256-2",
    "data-name": "Path 2256",
    d: "M154.847,411.64l.238,4.764v1.026a38.021,38.021,0,0,1-6.53-3.345C146.543,412.654,150.933,411.969,154.847,411.64Z",
    transform: "translate(393.069 -10.559)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257-2",
    "data-name": "Path 2257",
    d: "M155.375,370.75l.256,5.347a35.094,35.094,0,0,1-5.652-2.978C148.058,371.789,151.717,371.067,155.375,370.75Z",
    transform: "translate(390.158 -21.478)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258-2",
    "data-name": "Path 2258",
    d: "M156.1,392.5a37.642,37.642,0,0,1-6.676-3.408c-2.1-1.457,2.451-2.141,6.384-2.458l.128,2.445Z",
    transform: "translate(390.652 -17.237)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259-2",
    "data-name": "Path 2259",
    d: "M157.513,303.529v2.534a32.064,32.064,0,0,1-5.048-2.711c-1.829-1.267,1.445-1.964,4.957-2.331Z",
    transform: "translate(384.089 -40.098)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261-2",
    "data-name": "Path 2261",
    d: "M157.243,382.1a13.066,13.066,0,0,1-3.878.735l-.183-5.068C156.2,379.088,160.115,381.115,157.243,382.1Z",
    transform: "translate(381.263 -19.603)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262-2",
    "data-name": "Path 2262",
    d: "M158.059,367.769A31.055,31.055,0,0,1,152,369.226l-.366-10.136C157.895,362.017,163.785,365.793,158.059,367.769Z",
    transform: "translate(381.794 -24.591)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263-2",
    "data-name": "Path 2263",
    d: "M157.527,399.689a17.648,17.648,0,0,1-5.744,1.026l-.256-7.1C155.7,395.369,161.57,398.283,157.527,399.689Z",
    transform: "translate(383.448 -15.371)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264-2",
    "data-name": "Path 2264",
    d: "M151.732,412.7l-.2-5.676c2.78,1.064,9.146,3.8,5.762,4.979a12.717,12.717,0,0,1-5.561.7Z",
    transform: "translate(384.053 -11.793)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265-2",
    "data-name": "Path 2265",
    d: "M156.533,351l.274,5.6a35.381,35.381,0,0,1-6.146-3.193C148.65,351.963,152.729,351.266,156.533,351Z",
    transform: "translate(387.853 -26.751)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266-2",
    "data-name": "Path 2266",
    d: "M173.75,464.625c.67-2.265,2.654-4.239,5.488-5.461,5.488-2.053,5.488,0,11.835-1.368,4.244-.9,3.4-7.6,3.75-9.807,1.061-6.931,6.6-12.924,16.828-14.723,10.364-1.939,21.439-.021,29.267,5.068,12.329,8.2,10.847,15.369,18.731,15.7s12.329-6.487,26.139-2.382a24.482,24.482,0,0,1,14.981,12.974Z",
    transform: "translate(208.11 -4.982)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267-2",
    "data-name": "Path 2267",
    d: "M173.75,464.625c.67-2.265,2.654-4.239,5.488-5.461,5.488-2.053,5.488,0,11.835-1.368,4.244-.9,3.4-7.6,3.75-9.807,1.061-6.931,6.6-12.924,16.828-14.723,10.364-1.939,21.439-.021,29.267,5.068,12.329,8.2,10.847,15.369,18.731,15.7s12.329-6.487,26.139-2.382a24.482,24.482,0,0,1,14.981,12.974Z",
    transform: "translate(208.11 -4.982)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270-2",
    "data-name": "Line 270",
    y1: 3.776,
    x2: 6,
    transform: "translate(478.738 455.741)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271-2",
    "data-name": "Line 271",
    x1: 16.115,
    y1: 22.68,
    transform: "translate(429.962 437.027)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268-2",
    "data-name": "Path 2268",
    d: "M228.213,441.35l-1.9,7.374-12.841-4.916",
    transform: "translate(210.566 -2.625)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269-2",
    "data-name": "Path 2269",
    d: "M227.171,447.32l-6.548,8.312L207.8,452.794",
    transform: "translate(221.261 -1.031)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270-2",
    "data-name": "Path 2270",
    d: "M33.07,485.6a20.167,20.167,0,0,1,12.164-12.113c12.036-4.549,12.036,0,26.249-3.028,9.42-2.015,7.555-16.712,8.323-21.742,2.36-15.394,14.633-28.7,37.352-32.664,22.974-4.029,47.559-.253,64.789,11.226,27.328,18.182,24.054,34.083,41.559,34.843s27.236-14.393,57.912-5.309c18.712,5.588,28.5,19.145,33.218,28.787Z",
    transform: "translate(426.226 -9.799)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272-2",
    "data-name": "Line 272",
    y1: 8.375,
    x2: 13.316,
    transform: "translate(678.504 467.144)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273-2",
    "data-name": "Line 273",
    x1: 35.724,
    y1: 50.326,
    transform: "translate(574.135 425.624)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274-2",
    "data-name": "Line 274",
    x1: 11.487,
    y1: 5.03,
    transform: "translate(512.61 469.653)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271-2",
    "data-name": "Path 2271",
    d: "M153.787,433.99l-4.244,16.357L121.1,439.438",
    transform: "translate(439.981 -4.591)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272-2",
    "data-name": "Path 2272",
    d: "M151.506,447.23l-14.542,18.448-28.444-6.284",
    transform: "translate(463.444 -1.055)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273-2",
    "data-name": "Path 2273",
    d: "M58.22,462.12l2.433,9.224,13.316-1.672",
    transform: "translate(620.888 2.921)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275-2",
    "data-name": "Line 275",
    y1: 4.612,
    x2: 1.811,
    transform: "translate(520.387 467.98)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33-2",
    "data-name": "Ellipse 33",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(591.234 427.461)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274-2",
    "data-name": "Path 2274",
    d: "M129.956,431.267c-.052.553.386,1.072,1.107,1.311a2.655,2.655,0,0,0,2.169-.224,1.1,1.1,0,0,0,.508-1.478,2.055,2.055,0,0,0-1.79-.877C130.9,429.978,130.015,430.54,129.956,431.267Z",
    transform: "translate(444.562 -5.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34-2",
    "data-name": "Ellipse 34",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(559.58 432.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275-2",
    "data-name": "Path 2275",
    d: "M131.53,456.923c-.007.551.467,1.05,1.2,1.263a2.625,2.625,0,0,0,2.141-.291,1.072,1.072,0,0,0,.421-1.483,2.113,2.113,0,0,0-1.823-.831C132.4,455.587,131.54,456.184,131.53,456.923Z",
    transform: "translate(440.339 1.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35-2",
    "data-name": "Ellipse 35",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(601.075 444.578)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36-2",
    "data-name": "Ellipse 36",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(520.129 466.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276-2",
    "data-name": "Path 2276",
    d: "M167.63,465.813c-.007.549.465,1.048,1.2,1.261a2.628,2.628,0,0,0,2.139-.286,1.075,1.075,0,0,0,.433-1.479,2.1,2.1,0,0,0-1.81-.84c-1.074,0-1.947.6-1.957,1.343Z",
    transform: "translate(343.714 3.548)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37-2",
    "data-name": "Ellipse 37",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(677.151 463.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277-2",
    "data-name": "Path 2277",
    d: "M58.46,463.506c0,.749.876,1.356,1.957,1.356s1.957-.607,1.957-1.356-.876-1.356-1.957-1.356S58.46,462.757,58.46,463.506Z",
    transform: "translate(632.044 2.929)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38-2",
    "data-name": "Ellipse 38",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(693.76 471.161)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280-2",
    "data-name": "Path 2280",
    d: "M424.8,385.218s29.651,2.167,71.759-25.923-40.553-127.5-73.313-149.1-99.928,116.681-74.868,142.617S399.849,384.141,424.8,385.218Z",
    transform: "translate(-267.051 -64.961)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281-2",
    "data-name": "Path 2281",
    d: "M438.409,489.536l-4.683-144.784,20.267-15.116-21.84,8.641V312.341l28.078-22.693-26.5,14.051,3.11-18.372-7.792,8.641-4.683-51.86-3.11,78.873L369.76,301.534l51.491,30.257V493.856",
    transform: "translate(-361.739 -55.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282-2",
    "data-name": "Path 2282",
    d: "M382.869,388.553c-1.317-2.281,7.079-2.534,9.311-2.623l.219,6.918C389.473,392.037,383.967,390.415,382.869,388.553Z",
    transform: "translate(-237.391 -17.424)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283-2",
    "data-name": "Path 2283",
    d: "M385.111,341.83c4.262.735,12.987,2.534,10.445,4.257-2.012,1.381-6.878,1.939-10.445,2.154Z",
    transform: "translate(-244.909 -29.2)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284-2",
    "data-name": "Path 2284",
    d: "M383.553,357.706c-1.335-2.306,8.67-2.306,8.67-2.306v.114l.2,6.082C390.065,361.013,384.6,359.505,383.553,357.706Z",
    transform: "translate(-238.635 -25.577)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285-2",
    "data-name": "Path 2285",
    d: "M384.081,334.011c-.988-1.723,4.3-2.167,7.061-2.281l.183,5.74C388.673,336.722,384.923,335.455,384.081,334.011Z",
    transform: "translate(-238.533 -31.897)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286-2",
    "data-name": "Path 2286",
    d: "M392.119,412.86l.658,3.206.128,3.978c-2.286-.532-9.384-2.357-10.646-4.561C380.741,412.86,392.119,412.86,392.119,412.86Z",
    transform: "translate(-236.8 -10.233)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-2",
    "data-name": "Path 2287",
    d: "M396.135,375.287c-2.268,1.571-7.737,2.192-11.8,2.458V370.46C389.221,371.309,399.007,373.3,396.135,375.287Z",
    transform: "translate(-244.158 -21.555)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288-2",
    "data-name": "Path 2288",
    d: "M395.853,322.421c-2.122,1.47-7.5,2-11.1,2.192V318.05C388.682,318.7,398.542,320.521,395.853,322.421Z",
    transform: "translate(-244.558 -35.55)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289-2",
    "data-name": "Path 2289",
    d: "M386.448,289c4.372.887,9.731,2.306,7.664,3.8-1.555,1.077-4.829,1.647-7.9,1.964Z",
    transform: "translate(-228.178 -43.307)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290-2",
    "data-name": "Path 2290",
    d: "M384.343,397.43c4.884.849,14.633,2.838,11.8,4.827-2.268,1.571-7.737,2.2-11.8,2.458Z",
    transform: "translate(-244.163 -14.353)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291-2",
    "data-name": "Path 2291",
    d: "M393.037,302.19v5.917c-2.652-.71-6.9-2.065-7.792-3.624C384.092,302.6,390.659,302.253,393.037,302.19Z",
    transform: "translate(-242.134 -39.785)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292-2",
    "data-name": "Path 2292",
    d: "M315.943,451.133c-1.354-8.552,8.689-17.738,21.4-18.182,11.414-.38,23.962,4.929,33.474.545,7.774-3.586,7.939-11.239,8.817-17.738s3.439-12.936,9.512-17.738,16.28-7.6,24.987-5.4c17.542,4.473,18.621,24.4,36.584,28.077,12.4,2.534,25.334-4.6,38.065-3.016,15.585,1.926,22.627,13.874,34.59,19.715,1.244.608,6.439,3.218,12.4,6.234,4.994,2.534,10.518,5.334,14.633,7.5Z",
    transform: "translate(-259.677 -15.841)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293-2",
    "data-name": "Path 2293",
    d: "M315.943,451.133c-1.354-8.552,8.689-17.738,21.4-18.182,11.414-.38,23.962,4.929,33.474.545,7.774-3.586,7.939-11.239,8.817-17.738s3.439-12.936,9.512-17.738,16.28-7.6,24.987-5.4c17.542,4.473,18.621,24.4,36.584,28.077,12.4,2.534,25.334-4.6,38.065-3.016,15.585,1.926,22.627,13.874,34.59,19.715,1.244.608,6.439,3.218,12.4,6.234,4.994,2.534,10.518,5.334,14.633,7.5Z",
    transform: "translate(-259.677 -15.841)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276-2",
    "data-name": "Line 276",
    y1: 19.918,
    x2: 9.841,
    transform: "translate(184.786 414.664)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277-2",
    "data-name": "Line 277",
    x1: 20.432,
    y1: 38.264,
    transform: "translate(134.022 396.849)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278-2",
    "data-name": "Line 278",
    x1: 12.109,
    y1: 7.868,
    transform: "translate(80.667 427.245)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279-2",
    "data-name": "Line 279",
    x1: 6.494,
    y1: 12.049,
    transform: "translate(181.388 417.819)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280-2",
    "data-name": "Line 280",
    y1: 3.877,
    x2: 22.517,
    transform: "translate(188.143 423.052)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281-2",
    "data-name": "Line 281",
    y1: 6.817,
    x2: 6.055,
    transform: "translate(152.553 401.563)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282-2",
    "data-name": "Line 282",
    x1: 21.932,
    y1: 8.375,
    transform: "translate(136.676 410.483)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283-2",
    "data-name": "Line 283",
    x1: 20.158,
    y1: 4.916,
    transform: "translate(132.654 427.245)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284-2",
    "data-name": "Line 284",
    y1: 15.724,
    x2: 12.859,
    transform: "translate(148.695 411.002)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294-2",
    "data-name": "Path 2294",
    d: "M393.59,408.586c0,.549.479,1.045,1.213,1.254a2.621,2.621,0,0,0,2.135-.3,1.07,1.07,0,0,0,.412-1.482,2.115,2.115,0,0,0-1.821-.828,2.436,2.436,0,0,0-1.378.4A1.173,1.173,0,0,0,393.59,408.586Z",
    transform: "translate(-249.03 -11.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295-2",
    "data-name": "Path 2295",
    d: "M386.86,412.216c0,.749.876,1.356,1.957,1.356s1.957-.607,1.957-1.356-.876-1.356-1.957-1.356a2.447,2.447,0,0,0-1.389.393A1.176,1.176,0,0,0,386.86,412.216Z",
    transform: "translate(-241.761 -10.767)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39-2",
    "data-name": "Ellipse 39",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(134.719 409.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40-2",
    "data-name": "Ellipse 40",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(158.84 409.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41-2",
    "data-name": "Ellipse 41",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(142.017 425.687)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42-2",
    "data-name": "Ellipse 42",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(79.478 426.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296-2",
    "data-name": "Path 2296",
    d: "M358.02,422.643c-.007.549.465,1.048,1.2,1.262a2.628,2.628,0,0,0,2.139-.286,1.075,1.075,0,0,0,.432-1.479,2.1,2.1,0,0,0-1.81-.84c-1.074,0-1.947.6-1.957,1.343Z",
    transform: "translate(-165.883 -7.979)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43-2",
    "data-name": "Ellipse 43",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(179.965 416.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44-2",
    "data-name": "Ellipse 44",
    cx: 1.957,
    cy: 1.356,
    rx: 1.957,
    ry: 1.356,
    transform: "translate(207.394 421.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297-2",
    "data-name": "Path 2297",
    d: "M390.09,461.789c.81-2.762,3.224-5.172,6.676-6.665,6.622-2.534,6.622,0,14.432-1.66,5.177-1.1,4.152-9.186,4.573-11.961,1.3-8.451,8.067-15.762,20.542-17.954,12.624-2.358,26.111-.024,35.651,6.17,15.036,10,13.225,18.739,22.846,19.158s15.036-7.906,31.864-2.914a29.685,29.685,0,0,1,18.292,15.825Z",
    transform: "translate(-390.09 -7.619)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285-2",
    "data-name": "Line 285",
    y1: 4.612,
    x2: 7.317,
    transform: "translate(120.543 449.406)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286-2",
    "data-name": "Line 286",
    x1: 19.645,
    y1: 27.659,
    transform: "translate(56.302 426.587)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298-2",
    "data-name": "Path 2298",
    d: "M456.483,433.41l-2.323,8.983L438.52,436.4",
    transform: "translate(-390.193 -4.746)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299-2",
    "data-name": "Path 2299",
    d: "M455.225,440.69l-7.975,10.136-15.639-3.459",
    transform: "translate(-376.296 -2.802)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-2-3",
    "data-name": "freepik--Trees--inject-2",
    transform: "translate(651.736 1155.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172-3",
    "data-name": "Path 2172",
    d: "M47.541,405.673c1.242-7.36,18.5,3.685,18.5,3.685a30.91,30.91,0,0,1-3.7-13.8c0-7.36,12.28,1.832,12.28,1.832s-8.637-11.961-7.409-24.839,19.743,1.843,19.743,1.843-7.409-19.342-8.637-24.849,34.533,6.444,34.533,6.444a137.282,137.282,0,0,1-3.7-16.563c-.641-4.235,5.458-2.474,11.625.265,1.364-3.685,5.007-3.94,9.06-2.789-.259-.916-.546-1.914-.86-2.983-1.364-4.958,8.1.631,15.977,5.914.952-6.438,4.856-12.433,11.052-16.97,5.962-4.449,12.389.509,17.737,7.472l8.855,2.036a38.885,38.885,0,0,1,.546-3.97c1.6-8.327,10.915.651,17.314,8.042l6.822,1.568a35.071,35.071,0,0,1,10.342-18.812c11.093-10.119,37,18.405,37,18.405s16.032-19.342,22.2-9.162-2.47,31.293-2.47,31.293,3.7-7.37,8.623-9.162,18.5,6.434,18.5,6.434-7.4-12.877,0-17.479c6.7-4.164,15.391,10.475,17,13.325-1.132-2.158-5.458-11.5-2.2-24.371,3.7-14.72,18.5,4.6,18.5,4.6s-2.47-18.405,11.093-21.164-6.167,0,7.409,18.405,8.623-12.877,28.366-11.045,14.79,57.058,14.79,57.058l77.812-33.207s3.7-5.528,16.223-7.2,4.735,12.735,4.735,12.735S512.489,336.7,519.884,336.7c1.924,0,7.832,6.383,15.527,15.83.559-.967,1.132-1.955,1.733-2.952,4.68-7.665,8.637,9.477,10.288,18.242l1.364,1.761c1-4.326,3.9-11.758,11.788-11.758,9.551,0,4.489,24.554,2.893,31.374v.081c1.228-3.878,4.762-13.234,10.615-13.977,7.4-.916,1.242,20.248,1.242,20.248s4.925-2.759,8.623-2.759c2.729,0-1.05,12.837-3.343,20.054,7.777,10.791,13.057,18.273,13.057,18.273L544.552,411.2H286.421L298.9,424.088H52.521S46.313,413.053,47.541,405.673Z",
    transform: "translate(-9.933 -91.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174-3",
    "data-name": "Path 2174",
    d: "M49.82,433.082c3.246-9.447,8.56-21.174,15.968-25.551,13.152-7.777,34.544,4.449,46.059-1.11S98.7,346.431,138.206,343.1s54.3,52.212,72.4,57.76,24.68-14.435,49.361-15.545c21.573-1.018,63.276,37.95,73.417,47.764Z",
    transform: "translate(246.965 -90.63)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175-3",
    "data-name": "Path 2175",
    d: "M49.82,433.082c3.246-9.447,8.56-21.174,15.968-25.551,13.152-7.777,34.544,4.449,46.059-1.11S98.7,346.431,138.206,343.1s54.3,52.212,72.4,57.76,24.68-14.435,49.361-15.545c21.573-1.018,63.276,37.95,73.417,47.764Z",
    transform: "translate(246.965 -90.63)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176-3",
    "data-name": "Path 2176",
    d: "M226.571,425.911h-9.115L211.907,278.3l-11.7-25.867,12.306,17.011L210.7,252.833,191,223.414l18.923,18.364,1.637-44.038,2.525,27.109,9.309-4.072-8.157,9.06,2.22,32.067,7.367-8.541-6.34,15.2Z",
    transform: "translate(161.402 -93.242)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177-3",
    "data-name": "Path 2177",
    d: "M138.175,425.911H129.06L123.511,278.3,111.83,252.487,124.149,269.5l-1.831-16.614-19.728-29.43,18.978,18.324,1.623-44.038,2.58,27.109,9.309-4.072-8.157,9.06,2.22,32.066,7.381-8.541-6.354,15.2Z",
    transform: "translate(370.502 -93.242)",
    fill: "#a8adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178-3",
    "data-name": "Path 2178",
    d: "M326.679,424.977h-9.115l-5.549-113.454-11.737-19.779L312.6,304.814l-1.817-12.766-19.7-22.7,18.978,14.15L311.7,249.66,314.3,270.5l9.3-3.115-8.157,6.953,2.234,24.645,7.367-6.566-6.34,11.676Z",
    transform: "translate(-75.341 -92.308)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179-3",
    "data-name": "Path 2179",
    d: "M249.939,424.977h-9.115l-5.549-113.454-11.723-19.779,12.305,13.071-1.817-12.766-19.7-22.7,18.979,14.15,1.637-33.838,2.58,20.838,9.309-3.115-8.171,6.953,2.234,24.645,7.367-6.566-6.34,11.676Z",
    transform: "translate(106.17 -92.308)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180-3",
    "data-name": "Path 2180",
    d: "M300.175,424.977h-9.1l-5.549-113.454-11.737-19.779,12.319,13.071-1.831-12.766-19.686-22.7,18.978,14.15,1.637-33.838,2.567,20.838,9.309-3.115-8.157,6.953,2.22,24.645,7.381-6.566-6.354,11.676Z",
    transform: "translate(-12.671 -92.308)",
    fill: "#c7cacb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181-3",
    "data-name": "Path 2181",
    d: "M445.627,425.911h-9.115L430.963,278.3l-11.681-25.816,12.305,17.01-1.817-16.613-19.7-29.42,18.978,18.324,1.637-44.038,2.553,27.1,9.309-4.072-8.157,9.06,2.22,32.066,7.367-8.541-6.34,15.2Z",
    transform: "translate(-355.882 -93.241)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182-3",
    "data-name": "Path 2182",
    d: "M405.946,425.911h-9.1L391.3,278.3l-11.7-25.816L391.921,269.5l-1.831-16.614-19.769-29.43L389.3,241.778l1.637-44.038,2.567,27.109,9.309-4.072-8.157,9.06,2.22,32.066,7.381-8.541-6.354,15.2Z",
    transform: "translate(-262.792 -93.242)",
    fill: "#8a9094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183-3",
    "data-name": "Path 2183",
    d: "M337.755,425.911h-9.1L323.1,278.3l-11.681-25.816L323.743,269.5l-1.831-16.614-19.741-29.43,18.978,18.324,1.582-44.038,2.566,27.109,9.309-4.072-8.157,9.06,2.22,32.066,7.38-8.541-6.354,15.2Z",
    transform: "translate(-101.558 -93.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184-3",
    "data-name": "Path 2184",
    d: "M224.27,433.082c2.775-9.447,7.408-21.174,13.8-25.551,11.39-7.777,29.911,4.449,39.871-1.11s-11.39-59.99,22.78-63.319,46.988,52.212,62.651,57.76,21.365-14.435,42.715-15.545c18.673-1.018,54.757,37.95,63.539,47.764Z",
    transform: "translate(-124.673 -90.63)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185-3",
    "data-name": "Path 2185",
    d: "M224.27,433.082c2.775-9.447,7.408-21.174,13.8-25.551,11.39-7.777,29.911,4.449,39.871-1.11s-11.39-59.99,22.78-63.319,46.988,52.212,62.651,57.76,21.365-14.435,42.715-15.545c18.673-1.018,54.757,37.95,63.539,47.764Z",
    transform: "translate(-124.673 -90.63)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186-3",
    "data-name": "Path 2186",
    d: "M321.745,202.44s19.714,0,25.457,23.505-9.031,29.522,9.045,41.595,20.532,20.5,11.5,25.928-13.97,11.452-2.469,20.492,13.152,22.3-27.927,30.743-72.293-12.053-73.944-25.918,12.333-22.915,13.152-34.367-27.941-22.3-24.653-37.971,32.866-9.65,41.078-21.7S302.031,202.44,321.745,202.44Z",
    transform: "translate(-66.83 -93.157)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187-3",
    "data-name": "Path 2187",
    d: "M321.745,202.44s19.714,0,25.457,23.505-9.031,29.522,9.045,41.595,20.532,20.5,11.5,25.928-13.97,11.452-2.469,20.492,13.152,22.3-27.927,30.743-72.293-12.053-73.944-25.918,12.333-22.915,13.152-34.367-27.941-22.3-24.653-37.971,32.866-9.65,41.078-21.7S302.031,202.44,321.745,202.44Z",
    transform: "translate(-66.83 -93.157)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188-3",
    "data-name": "Path 2188",
    d: "M311.864,430.592h-7.2L294.481,283.514l-9.24-20.36,9.711,13.448-1.387-13.132L278,240.2l15,14.527,1.3-34.815,2.025,21.378,7.367-3.2-6.451,7.126L299,270.565l5.827-6.749-5.022,12.012Z",
    transform: "translate(-42.685 -92.843)",
    fill: "#92989b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189-3",
    "data-name": "Path 2189",
    d: "M384.17,432.959c-2.109-8.714-5.549-19.545-10.391-23.577-8.574-7.177-22.488,4.072-29.994-1.018s8.574-55.358-17.133-58.432-35.349,48.181-47.169,53.312-16.065-13.336-32.13-14.354c-14.054-.9-41.189,35.029-47.793,44.079Z",
    transform: "translate(-6.606 -90.507)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190-3",
    "data-name": "Path 2190",
    d: "M384.17,432.959c-2.109-8.714-5.549-19.545-10.391-23.577-8.574-7.177-22.488,4.072-29.994-1.018s8.574-55.358-17.133-58.432-35.349,48.181-47.169,53.312-16.065-13.336-32.13-14.354c-14.054-.9-41.189,35.029-47.793,44.079Z",
    transform: "translate(-6.606 -90.507)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191-3",
    "data-name": "Path 2191",
    d: "M150.44,432.5c1.9-6.006,5.022-13.478,9.35-16.288,7.713-4.947,20.241,2.83,26.983-.7s-7.7-38.195,15.427-40.312,31.811,33.237,42.41,36.77,14.456-9.162,28.912-9.895c12.638-.621,37.069,24.167,43.007,30.407Z",
    transform: "translate(127.575 -90.052)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192-3",
    "data-name": "Path 2192",
    d: "M93.46,349.259s18.923,1.466,45.781-17.53S113.34,245.5,92.433,230.877,28.616,309.8,44.626,327.342,77.506,348.536,93.46,349.259Z",
    transform: "translate(445.717 -92.673)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193-3",
    "data-name": "Path 2193",
    d: "M93.46,349.259s18.923,1.466,45.781-17.53S113.34,245.5,92.433,230.877,28.616,309.8,44.626,327.342,77.506,348.536,93.46,349.259Z",
    transform: "translate(445.717 -92.673)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194-3",
    "data-name": "Path 2194",
    d: "M107.525,425.476l-3-97.92,12.958-10.231-13.943,5.843v-17.54l17.924-15.341-16.939,9.5,2-12.419-4.98,5.843-2.983-35.08-2,53.342L63.7,298.32l32.866,20.461V428.4",
    transform: "translate(439.628 -92.155)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195-3",
    "data-name": "Path 2195",
    d: "M425.191,268.949s18.923,1.456,45.781-17.54-25.915-86.233-46.725-100.852-63.816,78.924-47.807,96.464S409.265,268.216,425.191,268.949Z",
    transform: "translate(-337.18 -94.118)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196-2",
    "data-name": "Path 2196",
    d: "M446.629,422.737l-10.28-175.5,12.944-10.231-13.943,5.843v-17.54l17.938-15.341-16.939,9.5,2-12.419-4.98,5.843-3-35.08-1.984,53.353L395.52,218l32.866,20.462v9.508l7.283,177.689",
    transform: "translate(-343.357 -93.6)",
    fill: "#a8adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197-3",
    "data-name": "Path 2197",
    d: "M47.42,429.412a6.55,6.55,0,0,1,3.76-3.97c3.718-1.486,3.718,0,8.116-1.018,2.913-.662,2.331-5.477,2.567-7.126.735-5.039,4.537-9.4,11.542-10.7,7.085-1.367,14.63.041,19.963,3.726,8.449,5.955,7.436,11.2,12.847,11.412s8.449-4.713,17.91-1.741a17.045,17.045,0,0,1,10.28,9.427Z",
    transform: "translate(449.277 -89.495)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198-3",
    "data-name": "Path 2198",
    d: "M47.42,429.412a6.55,6.55,0,0,1,3.76-3.97c3.718-1.486,3.718,0,8.116-1.018,2.913-.662,2.331-5.477,2.567-7.126.735-5.039,4.537-9.4,11.542-10.7,7.085-1.367,14.63.041,19.963,3.726,8.449,5.955,7.436,11.2,12.847,11.412s8.449-4.713,17.91-1.741a17.045,17.045,0,0,1,10.28,9.427Z",
    transform: "translate(449.277 -89.495)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199-3",
    "data-name": "Path 2199",
    d: "M127.054,429.038a7.672,7.672,0,0,0-6.548-4.937c-5.05-.407-8.6,5.629-16.093.55S92.44,406.663,80.828,407.08s-11.418,10.709-10.1,14.964-6.368,4.072-9.711,3.563-7.3,2.2-7.3,3.848",
    transform: "translate(447.888 -89.477)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258-3",
    "data-name": "Line 258",
    y1: 2.738,
    x2: 4.106,
    transform: "translate(564.467 337.098)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259-3",
    "data-name": "Line 259",
    x1: 11.043,
    y1: 16.471,
    transform: "translate(528.356 323.508)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200-3",
    "data-name": "Path 2200",
    d: "M93.364,414.09l-1.318,5.355-8.8-3.573",
    transform: "translate(440.611 -89.351)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201-3",
    "data-name": "Path 2201",
    d: "M91.407,419.48l-4.495,6.047L78.13,423.46",
    transform: "translate(449.671 -89.254)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.904
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202-3",
    "data-name": "Path 2202",
    d: "M174.65,427.8a7.258,7.258,0,0,1,4.162-4.388c4.162-1.649,4.162,0,8.976-1.1,3.219-.723,2.58-6.047,2.844-7.869.8-5.579,5.008-10.394,12.763-11.839,7.861-1.544,16.251,0,22.2,4.072,9.351,6.586,8.227,12.348,14.206,12.623s9.351-5.212,19.825-1.924A18.985,18.985,0,0,1,270.985,427.8Z",
    transform: "translate(139.677 -89.568)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203-3",
    "data-name": "Path 2203",
    d: "M174.65,427.8a7.258,7.258,0,0,1,4.162-4.388c4.162-1.649,4.162,0,8.976-1.1,3.219-.723,2.58-6.047,2.844-7.869.8-5.579,5.008-10.394,12.763-11.839,7.861-1.544,16.251,0,22.2,4.072,9.351,6.586,8.227,12.348,14.206,12.623s9.351-5.212,19.825-1.924A18.985,18.985,0,0,1,270.985,427.8Z",
    transform: "translate(139.677 -89.568)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260-3",
    "data-name": "Line 260",
    y1: 3.034,
    x2: 4.55,
    transform: "translate(389.025 335.092)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261-3",
    "data-name": "Line 261",
    x1: 12.208,
    y1: 18.222,
    transform: "translate(349.618 320.057)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204-3",
    "data-name": "Path 2204",
    d: "M225.538,410.83l-1.443,5.925-9.725-3.95",
    transform: "translate(130.367 -89.409)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205-3",
    "data-name": "Path 2205",
    d: "M223.392,416.8l-4.967,6.688-9.725-2.28",
    transform: "translate(140.281 -89.302)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206-2",
    "data-name": "Path 2206",
    d: "M180.572,134.66s28.4,0,36.681,33.858-13.013,42.542,13.013,59.9,29.578,29.522,16.551,37.329-20.1,16.491-3.538,29.522S262.2,327.4,203.046,339.55,99,322.183,96.57,302.22s17.758-32.993,18.937-49.484S75.274,220.619,80.019,198.05s47.321-13.9,59.141-31.252S152.173,134.66,180.572,134.66Z",
    transform: "translate(284.814 -94.376)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207-2",
    "data-name": "Path 2207",
    d: "M180.572,134.66s28.4,0,36.681,33.858-13.013,42.542,13.013,59.9,29.578,29.522,16.551,37.329-20.1,16.491-3.538,29.522S262.2,327.4,203.046,339.55,99,322.183,96.57,302.22s17.758-32.993,18.937-49.484S75.274,220.619,80.019,198.05s47.321-13.9,59.141-31.252S152.173,134.66,180.572,134.66Z",
    transform: "translate(284.814 -94.376)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M166.346,463.222H156l-14.664-211.8L128.014,222.03l14.026,19.342-2.081-18.914-22.419-33.5,21.614,20.93,1.859-50.146,2.927,30.875,10.6-4.622-9.295,10.312,2.539,36.5,8.324-9.722-7.228,17.306Z",
    transform: "translate(321.964 -93.925)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209-3",
    "data-name": "Path 2209",
    d: "M381.8,154.25s28.371.723,35.044,34.774-15.011,42.175,10.169,60.193,28.162,30.254,14.789,37.726-20.879,15.972-4.939,29.41,17.383,32.576-42.3,43.213-103.23-20-104.645-40.017,19.3-32.514,21.268-48.965-38.678-33.115-32.879-55.511,47.946-12.674,60.6-29.725S353.429,153.528,381.8,154.25Z",
    transform: "translate(-178.421 -94.024)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_89-3",
    "data-name": "Group 89",
    transform: "translate(99.318 60.201)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210-3",
    "data-name": "Path 2210",
    d: "M381.8,154.25s28.371.723,35.044,34.774-15.011,42.175,10.169,60.193,28.162,30.254,14.789,37.726-20.879,15.972-4.939,29.41,17.383,32.576-42.3,43.213-103.23-20-104.645-40.017,19.3-32.514,21.268-48.965-38.678-33.115-32.879-55.511,47.946-12.674,60.6-29.725S353.429,153.528,381.8,154.25Z",
    transform: "translate(-277.739 -154.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211-3",
    "data-name": "Path 2211",
    d: "M359.318,442.8l-10.363-.265-7.519-171.693-11.9-29.745,13.1,19.708-1.179-18.955L320.64,207.8l20.6,21.459,4.245-50.075,1.471,30.926,10.807-4.337-9.781,10.068.8,36.556,8.851-9.508-8.033,17.1Z",
    transform: "translate(-148.304 -93.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212-3",
    "data-name": "Path 2212",
    d: "M296.47,432.812c2.469-7.839,6.534-17.581,12.195-21.215,10.044-6.454,26.359,3.7,35.182-.916S333.8,360.871,363.963,358.1s41.481,43.356,55.312,47.967,18.854-11.992,37.707-12.918c16.481-.8,48.334,31.557,56.089,39.7Z",
    transform: "translate(-265.727 -90.36)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213-3",
    "data-name": "Path 2213",
    d: "M60.691,434.582c-.943-5.375-1.457-15.27,5.924-20.665,10.474-7.686,26.179,4.795,30.1,4.795s5.244-7.676,17.022-14.4,26.179,1.924,34.031,0-6.548-31.69,15.7-32.647,30.1,40.333,45.781,40.333,18.326-7.686,34.031-.957c12.305,5.263,18.979,18.181,21.3,23.546Z",
    transform: "translate(301.422 -90.114)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214-3",
    "data-name": "Path 2214",
    d: "M60.691,434.582c-.943-5.375-1.457-15.27,5.924-20.665,10.474-7.686,26.179,4.795,30.1,4.795s5.244-7.676,17.022-14.4,26.179,1.924,34.031,0-6.548-31.69,15.7-32.647,30.1,40.333,45.781,40.333,18.326-7.686,34.031-.957c12.305,5.263,18.979,18.181,21.3,23.546Z",
    transform: "translate(301.422 -90.114)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262-3",
    "data-name": "Line 262",
    y1: 16.746,
    x2: 14.054,
    transform: "translate(523.764 326.429)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263-3",
    "data-name": "Line 263",
    x1: 7.02,
    y1: 48.527,
    transform: "translate(468.383 293.355)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264-3",
    "data-name": "Line 264",
    x1: 7.02,
    y1: 18.894,
    transform: "translate(428.61 323.854)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265-3",
    "data-name": "Line 265",
    x1: 7.034,
    y1: 13.315,
    transform: "translate(379.614 330.287)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215-3",
    "data-name": "Path 2215",
    d: "M74.58,416.17l7.02,9.019,16.384-4.723",
    transform: "translate(448.018 -89.313)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216-3",
    "data-name": "Path 2216",
    d: "M143.671,387.06l-8.185,10.74-11.126-9.885",
    transform: "translate(335.228 -89.837)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217-3",
    "data-name": "Path 2217",
    d: "M142.053,403.94l-10.544,9.447-10.53-6.016",
    transform: "translate(341.468 -89.533)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266-3",
    "data-name": "Line 266",
    x1: 14.04,
    y1: 6.006,
    transform: "translate(417.591 326.002)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267-3",
    "data-name": "Line 267",
    y1: 13.315,
    x2: 7.034,
    transform: "translate(432.64 322.133)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268-3",
    "data-name": "Line 268",
    y1: 8.592,
    x2: 3.524,
    transform: "translate(383.105 328.139)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269-3",
    "data-name": "Line 269",
    x1: 9.947,
    y1: 3.003,
    transform: "translate(374.408 335.449)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218-3",
    "data-name": "Path 2218",
    d: "M181.305,198.107a76.891,76.891,0,0,1,17.2-17.418c9.991-7.423,24.06-11.086,38.193-9.946,28.135,2.341,35.834,28.656,43.8,44.659,19.034,38.225,42.646,94.917-28.523,111.612-30.674,7.2-72.806,0-85.14-24.126-10.668-20.869-10.5-43.845-4.037-65.406C166.627,224.87,172.3,210.506,181.305,198.107Z",
    transform: "translate(133.139 -93.731)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219-3",
    "data-name": "Path 2219",
    d: "M242.454,462.169H232.077l-6.271-168.11L212.5,264.67l14.026,19.342-2.109-18.9L202,231.606l21.587,20.94,1.859-50.146,2.941,30.865,10.6-4.611-9.3,10.312,2.539,36.5,8.324-9.722-7.214,17.306Z",
    transform: "translate(130.533 -93.158)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220-3",
    "data-name": "Path 2220",
    d: "M209.764,354.378l-.194-4.968c1.651,0,4,.417,4,2.25C213.565,353.177,211.582,353.971,209.764,354.378Z",
    transform: "translate(148.853 -90.514)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221-3",
    "data-name": "Path 2221",
    d: "M215.156,298.4c0,1.619-2.234,2.4-4.162,2.789l-.194-5.09C212.451,296.151,215.156,296.436,215.156,298.4Z",
    transform: "translate(145.584 -91.473)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222-3",
    "data-name": "Path 2222",
    d: "M214.625,320.88c0,1.731-2.567,2.514-4.55,2.861l-.194-5.09C211.42,318.579,214.625,318.732,214.625,320.88Z",
    transform: "translate(147.375 -91.067)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223-3",
    "data-name": "Path 2223",
    d: "M209.593,267.918c-.541-1.608,2.053-1.67,4-1.507l.347,5.09C212.492,270.87,210.175,269.608,209.593,267.918Z",
    transform: "translate(148.554 -92.008)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224-3",
    "data-name": "Path 2224",
    d: "M211.776,428.93c0,1.893-3.066,2.657-5.091,2.952l-.194-5.161C207.6,426.629,211.776,426.487,211.776,428.93Z",
    transform: "translate(154.859 -89.124)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225-3",
    "data-name": "Path 2225",
    d: "M214.131,250.381l.347,4.988a7.664,7.664,0,0,1-4.065-3.461C209.9,250.381,212.175,250.248,214.131,250.381Z",
    transform: "translate(146.889 -92.296)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226-3",
    "data-name": "Path 2226",
    d: "M216.467,236.22c0,1.7-2.5,2.484-4.467,2.84l.194-5.09C213.79,234,216.467,234.275,216.467,236.22Z",
    transform: "translate(142.634 -92.59)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227-3",
    "data-name": "Path 2227",
    d: "M204.141,396.279c-1.04-3.054,4.356-2.973,7.838-2.616l.472,9.253C209.954,401.868,205.251,399.516,204.141,396.279Z",
    transform: "translate(157.591 -89.721)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228-3",
    "data-name": "Path 2228",
    d: "M206.9,405.8s5.549-.621,5.549,2.2c0,2.036-3.468,2.749-5.466,3.054l-.18-4.825Z",
    transform: "translate(153.767 -89.501)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229-3",
    "data-name": "Path 2229",
    d: "M213.727,367.783c0,2.433-2.775,3.879-5.674,4.713l-.333-8.846C210.564,363.915,213.727,364.861,213.727,367.783Z",
    transform: "translate(151.231 -90.258)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230-3",
    "data-name": "Path 2230",
    d: "M209.28,359.051l.25,4.958a7.541,7.541,0,0,1-4-3.431C205.007,359,207.393,358.918,209.28,359.051Z",
    transform: "translate(158.505 -90.341)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231-3",
    "data-name": "Path 2231",
    d: "M209.84,308.22l.222,4.255a5.741,5.741,0,0,1-2.608-2.7C207.052,308.6,208.356,308.261,209.84,308.22Z",
    transform: "translate(155.341 -91.255)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232-3",
    "data-name": "Path 2232",
    d: "M204.535,386.748c-.666-1.944,3.3-1.629,5.105-1.384l.277,5.4C209.085,390.453,205.3,388.977,204.535,386.748Z",
    transform: "translate(159.492 -89.871)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233-2",
    "data-name": "Path 2233",
    d: "M340.286,122.657a76.6,76.6,0,0,1,17.2-17.418c9.995-7.426,24.069-11.09,38.207-9.946,28.121,2.331,35.834,28.656,43.8,44.649,19.076,38.236,42.688,94.927-28.537,111.622-30.687,7.2-72.82,0-85.14-24.126-10.668-20.879-10.5-43.845-4.051-65.405C325.609,149.42,331.283,135.056,340.286,122.657Z",
    transform: "translate(-240.649 -95.088)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234-2",
    "data-name": "Path 2234",
    d: "M340.286,122.657a76.6,76.6,0,0,1,17.2-17.418c9.995-7.426,24.069-11.09,38.207-9.946,28.121,2.331,35.834,28.656,43.8,44.649,19.076,38.236,42.688,94.927-28.537,111.622-30.687,7.2-72.82,0-85.14-24.126-10.668-20.879-10.5-43.845-4.051-65.405C325.609,149.42,331.283,135.056,340.286,122.657Z",
    transform: "translate(-240.649 -95.088)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M402.58,434.431H392.2L381.95,218.619l-13.3-29.389,14.012,19.342-2.095-18.894-22.433-33.5,21.614,20.92,1.831-50.1,2.941,30.865,10.585-4.611-9.281,10.312,2.525,36.5,8.393-9.722-7.214,17.306Z",
    transform: "translate(-242.671 -94.514)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236-3",
    "data-name": "Path 2236",
    d: "M366.243,235.967c-.527-1.517,1.054-2.036,2.941-2.1l.319,5.568a7.545,7.545,0,0,1-3.26-3.471Z",
    transform: "translate(-221.03 -92.592)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237-3",
    "data-name": "Path 2237",
    d: "M367.763,321.151l.347,6.688c-1.956-.916-4.675-2.535-5.4-4.632S365.2,321,367.763,321.151Z",
    transform: "translate(-214.79 -91.023)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238-3",
    "data-name": "Path 2238",
    d: "M374.267,174.681l.458,6.678c-1.956-.926-4.634-2.525-5.341-4.611S371.715,174.518,374.267,174.681Z",
    transform: "translate(-230.519 -93.657)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239-3",
    "data-name": "Path 2239",
    d: "M369.709,254.884a1.28,1.28,0,0,1,0-1.018,11.286,11.286,0,0,1-4.162-5.09c-1.054-3.054,2.775-3.8,6.687-3.756L373,258.356A7.626,7.626,0,0,1,369.709,254.884Z",
    transform: "translate(-223.424 -92.391)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240-3",
    "data-name": "Path 2240",
    d: "M371.47,158.878l.236-6.108c1.99.152,3.493,1.393,3.468,2.861C375.174,157.249,373.44,158.257,371.47,158.878Z",
    transform: "translate(-233.981 -94.05)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241-3",
    "data-name": "Path 2241",
    d: "M373.146,203.653a7.9,7.9,0,0,1-1.984-2.036l.111,1.507c-1.956-.875-5.091-2.575-5.854-4.846s2.65-2.25,5.258-2.036l.166,2.494.111-.132v.7c.777-.672,2.553-.763,4.162-.682Z",
    transform: "translate(-225.435 -93.27)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242-3",
    "data-name": "Path 2242",
    d: "M375.533,188.683c0,2.036-2.553,3.054-4.967,3.624l-.236-2.158-.18-4.489C372.37,185.711,375.533,186.21,375.533,188.683Z",
    transform: "translate(-232.516 -93.459)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243-3",
    "data-name": "Path 2243",
    d: "M368.624,363.883c-1.124-.407-6.229-2.4-7.256-5.406-.888-2.626,4.453-2.2,6.937-1.873Z",
    transform: "translate(-213.452 -90.389)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244-3",
    "data-name": "Path 2244",
    d: "M370.474,311.186a3.138,3.138,0,0,1-2.067,2.616l-.25-5.212A2.753,2.753,0,0,1,370.474,311.186Z",
    transform: "translate(-224.773 -91.248)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245-3",
    "data-name": "Path 2245",
    d: "M366.42,261.621c1.623-.112,7.02-.244,7.02,2.993,0,1.7-1.831,2.718-3.871,3.329a2.28,2.28,0,0,1,.888,1.853c0,1.588-1.609,2.586-3.5,3.207Z",
    transform: "translate(-225.308 -92.093)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246-3",
    "data-name": "Path 2246",
    d: "M373.344,239.411c-.127,1.421-1.4,2.648-3.232,3.115l-.291-5.986c2.014.138,3.547,1.387,3.524,2.871Z",
    transform: "translate(-229.898 -92.544)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247-3",
    "data-name": "Path 2247",
    d: "M369.073,207.189l-.236-2.219c3.5.5,6.937,1.883,6.937,5.436,0,3.288-3.676,5.222-7.644,6.362l-.43-11.4Z",
    transform: "translate(-229.379 -93.112)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248-3",
    "data-name": "Path 2248",
    d: "M370.492,332.909c-.1,2.16-1.755,4.119-4.342,5.151l-.486-10.18C368.658,328.542,370.65,330.617,370.492,332.909Z",
    transform: "translate(-221.36 -90.901)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249-3",
    "data-name": "Path 2249",
    d: "M360.937,374.115l-.277-5.741c2.178-1.018,6.2-.835,9.184-.529l.638,12.379A27.177,27.177,0,0,1,360.937,374.115Z",
    transform: "translate(-214.448 -90.187)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250-3",
    "data-name": "Path 2250",
    d: "M364.008,412.55c1.8.259,3.072,1.436,3.01,2.779a3.591,3.591,0,0,1-2.775,2.932Z",
    transform: "translate(-215.64 -89.378)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251-3",
    "data-name": "Path 2251",
    d: "M368.249,387.121c0,1.6-1.637,2.6-3.538,3.217l-.291-6.108C366.321,384.454,368.249,385.187,368.249,387.121Z",
    transform: "translate(-217.421 -89.888)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252-3",
    "data-name": "Path 2252",
    d: "M201.155,226.394s22.266,4.53,34.142,23.984-7.283,34.744,1.97,54.116,35.488,29.125,12.042,44.262-53.2-8.694-68.936-6.658-16.967,22.976-59.752,13.967-29.134-35.9-12.736-48.1,3.663-32.311,14.8-59.3C131.249,227.962,170.468,217.772,201.155,226.394Z",
    transform: "translate(262.954 -92.781)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253-3",
    "data-name": "Path 2253",
    d: "M201.155,226.394s22.266,4.53,34.142,23.984-7.283,34.744,1.97,54.116,35.488,29.125,12.042,44.262-53.2-8.694-68.936-6.658-16.967,22.976-59.752,13.967-29.134-35.9-12.736-48.1,3.663-32.311,14.8-59.3C131.249,227.962,170.468,217.772,201.155,226.394Z",
    transform: "translate(262.954 -92.781)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254-3",
    "data-name": "Path 2254",
    d: "M166.641,473.835l-7.27-154.123,50.068-25.735-50.623,20.634-.4-22.273,11.168-12.989-12.638,8.49L153.5,258.48l-2.65,44.425-35.543-14.5L150.4,310.519l.957,27.384-28.981-7.93,29.467,14.3L156.264,473.5Z",
    transform: "translate(282.076 -92.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256-3",
    "data-name": "Path 2256",
    d: "M153.205,411.64l.18,3.828v.825a28.269,28.269,0,0,1-4.953-2.687C146.907,412.454,150.237,411.9,153.205,411.64Z",
    transform: "translate(293.1 -89.395)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257-3",
    "data-name": "Path 2257",
    d: "M153.944,370.75l.194,4.3a26.14,26.14,0,0,1-4.287-2.392C148.394,371.585,151.169,371,153.944,370.75Z",
    transform: "translate(290.432 -90.13)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258-3",
    "data-name": "Path 2258",
    d: "M154.357,391.343a27.982,27.982,0,0,1-5.064-2.738c-1.6-1.171,1.859-1.72,4.842-1.975l.1,1.965Z",
    transform: "translate(290.981 -89.844)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259-3",
    "data-name": "Path 2259",
    d: "M156.166,303.036v2.036a23.912,23.912,0,0,1-3.829-2.179c-1.387-1.018,1.1-1.578,3.76-1.873Z",
    transform: "translate(284.999 -91.384)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261-3",
    "data-name": "Path 2261",
    d: "M156.262,381.252a9.421,9.421,0,0,1-2.941.59l-.139-4.072C155.471,378.829,158.44,380.458,156.262,381.252Z",
    transform: "translate(282.444 -90.004)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262-3",
    "data-name": "Path 2262",
    d: "M156.508,366.063a22.464,22.464,0,0,1-4.592,1.171l-.277-8.144C156.383,361.442,160.851,364.475,156.508,366.063Z",
    transform: "translate(283.315 -90.34)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263-3",
    "data-name": "Path 2263",
    d: "M156.078,398.5a12.718,12.718,0,0,1-4.356.825l-.194-5.7C154.691,395.025,159.144,397.366,156.078,398.5Z",
    transform: "translate(284.627 -89.719)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264-3",
    "data-name": "Path 2264",
    d: "M151.684,411.581l-.153-4.561c2.109.855,6.937,3.054,4.37,4a9.145,9.145,0,0,1-4.217.56Z",
    transform: "translate(285.093 -89.478)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265-3",
    "data-name": "Path 2265",
    d: "M154.987,351l.208,4.5a26.331,26.331,0,0,1-4.661-2.565C149.007,351.774,152.1,351.214,154.987,351Z",
    transform: "translate(288.448 -90.485)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266-3",
    "data-name": "Path 2266",
    d: "M173.75,458.316a7.2,7.2,0,0,1,4.162-4.388c4.162-1.649,4.162,0,8.976-1.1,3.219-.723,2.58-6.108,2.844-7.879.8-5.568,5.008-10.383,12.763-11.829,7.861-1.558,16.26-.017,22.2,4.072,9.35,6.586,8.227,12.348,14.206,12.613s9.351-5.212,19.825-1.914a18.986,18.986,0,0,1,11.362,10.424Z",
    transform: "translate(141.804 -89.019)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267-3",
    "data-name": "Path 2267",
    d: "M173.75,458.316a7.2,7.2,0,0,1,4.162-4.388c4.162-1.649,4.162,0,8.976-1.1,3.219-.723,2.58-6.108,2.844-7.879.8-5.568,5.008-10.383,12.763-11.829,7.861-1.558,16.26-.017,22.2,4.072,9.35,6.586,8.227,12.348,14.206,12.613s9.351-5.212,19.825-1.914a18.986,18.986,0,0,1,11.362,10.424Z",
    transform: "translate(141.804 -89.019)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270-3",
    "data-name": "Line 270",
    y1: 3.034,
    x2: 4.55,
    transform: "translate(390.255 366.161)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271-3",
    "data-name": "Line 271",
    x1: 12.222,
    y1: 18.222,
    transform: "translate(350.834 351.126)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268-3",
    "data-name": "Path 2268",
    d: "M224.652,441.35l-1.443,5.925-9.739-3.95",
    transform: "translate(132.483 -88.86)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269-3",
    "data-name": "Path 2269",
    d: "M222.492,447.32,217.525,454l-9.725-2.28",
    transform: "translate(142.411 -88.753)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270-3",
    "data-name": "Path 2270",
    d: "M33.07,471.619a15.829,15.829,0,0,1,9.226-9.732c9.129-3.655,9.129,0,19.908-2.433,7.145-1.619,5.73-13.427,6.312-17.469,1.79-12.369,11.1-23.057,28.329-26.244,17.425-3.237,36.07-.2,49.139,9.019,20.727,14.608,18.243,27.384,31.52,27.995s20.657-11.564,43.922-4.265c14.192,4.489,21.614,15.382,25.194,23.129Z",
    transform: "translate(356.97 -89.344)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272-3",
    "data-name": "Line 272",
    y1: 6.729,
    x2: 10.1,
    transform: "translate(556.296 375.323)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273-3",
    "data-name": "Line 273",
    x1: 27.094,
    y1: 40.434,
    transform: "translate(469.393 341.964)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274-3",
    "data-name": "Line 274",
    x1: 8.712,
    y1: 4.041,
    transform: "translate(418.085 377.339)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271-3",
    "data-name": "Path 2271",
    d: "M145.891,433.99l-3.219,13.142L121.1,438.367",
    transform: "translate(337.478 -88.993)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272-3",
    "data-name": "Path 2272",
    d: "M141.122,447.23l-11.029,14.822L108.52,457",
    transform: "translate(359.45 -88.755)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273-3",
    "data-name": "Path 2273",
    d: "M58.22,462.12l1.845,7.411,10.1-1.344",
    transform: "translate(498.534 -88.487)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275-3",
    "data-name": "Line 275",
    y1: 3.705,
    x2: 1.373,
    transform: "translate(424.038 375.995)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33-3",
    "data-name": "Ellipse 33",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(481.863 343.44)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274-3",
    "data-name": "Path 2274",
    d: "M129.955,431.018a1.091,1.091,0,0,0,.84,1.053,1.915,1.915,0,0,0,1.645-.18.9.9,0,0,0,.385-1.187,1.533,1.533,0,0,0-1.358-.7A1.365,1.365,0,0,0,129.955,431.018Z",
    transform: "translate(338.284 -89.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34-3",
    "data-name": "Ellipse 34",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(456.065 347.817)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275-3",
    "data-name": "Path 2275",
    d: "M131.53,456.659a1.138,1.138,0,0,0,.91,1.014,1.9,1.9,0,0,0,1.624-.234.889.889,0,0,0,.319-1.192A1.57,1.57,0,0,0,133,455.58C132.192,455.586,131.538,456.065,131.53,456.659Z",
    transform: "translate(334.551 -88.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35-3",
    "data-name": "Ellipse 35",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(497.571 357.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36-3",
    "data-name": "Ellipse 36",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(423.912 374.906)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276-3",
    "data-name": "Path 2276",
    d: "M167.63,465.549a1.137,1.137,0,0,0,.907,1.014,1.9,1.9,0,0,0,1.622-.23.891.891,0,0,0,.328-1.188,1.561,1.561,0,0,0-1.373-.675c-.815,0-1.477.482-1.484,1.079Z",
    transform: "translate(249.122 -88.445)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37-3",
    "data-name": "Ellipse 37",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(555.27 372.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277-3",
    "data-name": "Path 2277",
    d: "M58.46,463.239c0,.6.665,1.089,1.484,1.089s1.484-.488,1.484-1.089-.665-1.089-1.484-1.089S58.46,462.638,58.46,463.239Z",
    transform: "translate(506.937 -88.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38-3",
    "data-name": "Ellipse 38",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(567.866 378.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280-3",
    "data-name": "Path 2280",
    d: "M405.014,350.367s22.488,1.741,54.424-20.828-30.757-102.44-55.6-119.8-75.789,93.746-56.783,114.584S386.091,349.5,405.014,350.367Z",
    transform: "translate(-285.372 -93.059)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281-3",
    "data-name": "Path 2281",
    d: "M421.826,440.9l-3.552-116.325,15.371-12.145-16.564,6.943V298.537l21.3-18.232-20.1,11.289,2.358-14.761-5.91,6.943-3.552-41.666-2.358,63.37L369.76,289.853l39.053,24.309v130.21",
    transform: "translate(-292.708 -92.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282-3",
    "data-name": "Path 2282",
    d: "M382.836,388.037c-1-1.832,5.369-2.036,7.061-2.107l.166,5.558C387.844,390.837,383.668,389.534,382.836,388.037Z",
    transform: "translate(-264.212 -89.857)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283-3",
    "data-name": "Path 2283",
    d: "M385.111,341.83c3.232.59,9.85,2.036,7.922,3.42-1.526,1.11-5.216,1.557-7.922,1.731Z",
    transform: "translate(-270.768 -90.65)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284-3",
    "data-name": "Path 2284",
    d: "M383.523,357.253C382.51,355.4,390.1,355.4,390.1,355.4v.092l.152,4.886C388.462,359.91,384.314,358.7,383.523,357.253Z",
    transform: "translate(-265.363 -90.406)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285-3",
    "data-name": "Path 2285",
    d: "M384.052,333.562c-.749-1.384,3.26-1.741,5.355-1.832l.139,4.611C387.534,335.741,384.69,334.723,384.052,333.562Z",
    transform: "translate(-265.396 -90.832)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286-3",
    "data-name": "Path 2286",
    d: "M389.7,412.86l.5,2.575.1,3.2c-1.734-.428-7.117-1.893-8.074-3.665C381.074,412.86,389.7,412.86,389.7,412.86Z",
    transform: "translate(-263.605 -89.373)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-3",
    "data-name": "Path 2287",
    d: "M393.285,374.339c-1.72,1.262-5.868,1.761-8.948,1.975V370.46C388.041,371.142,395.463,372.74,393.285,374.339Z",
    transform: "translate(-269.997 -90.135)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288-3",
    "data-name": "Path 2288",
    d: "M393.171,321.562c-1.609,1.181-5.688,1.608-8.421,1.761V318.05C387.732,318.569,395.21,320.035,393.171,321.562Z",
    transform: "translate(-270.409 -91.078)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289-3",
    "data-name": "Path 2289",
    d: "M386.39,289c3.316.713,7.381,1.853,5.813,3.054-1.179.865-3.662,1.323-5.993,1.578Z",
    transform: "translate(-257.358 -91.6)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290-3",
    "data-name": "Path 2290",
    d: "M384.343,397.43c3.7.682,11.1,2.28,8.948,3.879-1.72,1.262-5.868,1.771-8.948,1.975Z",
    transform: "translate(-270.003 -89.65)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291-3",
    "data-name": "Path 2291",
    d: "M391.122,302.19v4.754c-2.012-.57-5.23-1.659-5.91-2.911C384.338,302.516,389.318,302.241,391.122,302.19Z",
    transform: "translate(-268.539 -91.363)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292-3",
    "data-name": "Path 2292",
    d: "M315.913,439.481c-1.027-6.871,6.59-14.252,16.232-14.608,8.657-.305,18.174,3.96,25.388.438,5.9-2.881,6.021-9.03,6.687-14.252s2.608-10.394,7.214-14.252,12.347-6.108,18.951-4.337c13.3,3.594,14.123,19.606,27.746,22.559,9.406,2.036,19.214-3.7,28.87-2.423,11.82,1.547,17.161,11.147,26.234,15.84.943.489,4.883,2.586,9.406,5.009,3.787,2.036,7.977,4.286,11.1,6.026Z",
    transform: "translate(-273.239 -89.751)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293-3",
    "data-name": "Path 2293",
    d: "M315.913,439.481c-1.027-6.871,6.59-14.252,16.232-14.608,8.657-.305,18.174,3.96,25.388.438,5.9-2.881,6.021-9.03,6.687-14.252s2.608-10.394,7.214-14.252,12.347-6.108,18.951-4.337c13.3,3.594,14.123,19.606,27.746,22.559,9.406,2.036,19.214-3.7,28.87-2.423,11.82,1.547,17.161,11.147,26.234,15.84.943.489,4.883,2.586,9.406,5.009,3.787,2.036,7.977,4.286,11.1,6.026Z",
    transform: "translate(-273.239 -89.751)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276-3",
    "data-name": "Line 276",
    y1: 16.003,
    x2: 7.464,
    transform: "translate(150.688 333.158)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277-3",
    "data-name": "Line 277",
    x1: 15.496,
    y1: 30.743,
    transform: "translate(109.403 318.845)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278-3",
    "data-name": "Line 278",
    x1: 9.184,
    y1: 6.322,
    transform: "translate(61.181 343.267)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279-3",
    "data-name": "Line 279",
    x1: 4.925,
    y1: 9.681,
    transform: "translate(147.869 335.693)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280-3",
    "data-name": "Line 280",
    y1: 3.115,
    x2: 17.078,
    transform: "translate(153.615 339.897)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281-3",
    "data-name": "Line 281",
    y1: 5.477,
    x2: 4.592,
    transform: "translate(124.358 322.632)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282-3",
    "data-name": "Line 282",
    x1: 16.634,
    y1: 6.729,
    transform: "translate(111.587 329.799)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283-3",
    "data-name": "Line 283",
    x1: 15.288,
    y1: 3.95,
    transform: "translate(108.284 343.267)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284-3",
    "data-name": "Line 284",
    y1: 12.633,
    x2: 9.753,
    transform: "translate(121.292 330.216)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294-3",
    "data-name": "Path 2294",
    d: "M393.59,408.319a1.146,1.146,0,0,0,.92,1.007,1.893,1.893,0,0,0,1.619-.241.888.888,0,0,0,.313-1.191,1.572,1.572,0,0,0-1.381-.665,1.774,1.774,0,0,0-1.045.32A.955.955,0,0,0,393.59,408.319Z",
    transform: "translate(-275.772 -89.474)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295-3",
    "data-name": "Path 2295",
    d: "M386.86,411.949c0,.6.665,1.089,1.484,1.089s1.484-.488,1.484-1.089-.665-1.089-1.484-1.089a1.78,1.78,0,0,0-1.054.316A.957.957,0,0,0,386.86,411.949Z",
    transform: "translate(-268.602 -89.409)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39-3",
    "data-name": "Ellipse 39",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(102.176 328.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40-3",
    "data-name": "Ellipse 40",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(129.457 329.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41-3",
    "data-name": "Ellipse 41",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(107.711 342.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42-3",
    "data-name": "Ellipse 42",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(60.279 342.442)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296-3",
    "data-name": "Path 2296",
    d: "M358.02,422.379a1.137,1.137,0,0,0,.907,1.014,1.9,1.9,0,0,0,1.622-.23.891.891,0,0,0,.328-1.188,1.561,1.561,0,0,0-1.373-.675c-.814,0-1.477.482-1.484,1.079Z",
    transform: "translate(-201.425 -89.221)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43-3",
    "data-name": "Ellipse 43",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(146.674 334.634)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44-3",
    "data-name": "Ellipse 44",
    cx: 1.484,
    cy: 1.089,
    rx: 1.484,
    ry: 1.089,
    transform: "translate(169.029 338.808)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297-3",
    "data-name": "Path 2297",
    d: "M390.09,454.1a8.765,8.765,0,0,1,5.064-5.355c5.022-2.036,5.022,0,10.946-1.334,3.926-.886,3.149-7.38,3.468-9.61.985-6.79,6.118-12.664,15.58-14.425,9.575-1.895,19.8-.019,27.039,4.958,11.4,8.032,10.03,15.056,17.328,15.392s11.4-6.352,24.167-2.341A23.019,23.019,0,0,1,507.554,454.1Z",
    transform: "translate(-390.09 -89.197)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285-3",
    "data-name": "Line 285",
    y1: 3.705,
    x2: 5.549,
    transform: "translate(91.424 361.071)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286-3",
    "data-name": "Line 286",
    x1: 14.9,
    y1: 22.223,
    transform: "translate(42.702 342.737)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298-3",
    "data-name": "Path 2298",
    d: "M452.143,433.41l-1.762,7.217-11.862-4.815",
    transform: "translate(-401.867 -89.003)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299-3",
    "data-name": "Path 2299",
    d: "M449.52,440.69l-6.049,8.144-11.862-2.779",
    transform: "translate(-389.658 -88.872)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 2009,
    height: 230,
    transform: "translate(-35 1423)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M0,0,36.659-6.714l1.485,130.726-66.644-16.3S-12.539,83.2-5.414,56.271,0,0,0,0Z",
    transform: "translate(1776 1391.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M-39.188-56.42-80.577-88.484l46.124-3.169L-7.109-27.681,41.31-2.27l-4.65,53.5L19.213,70.667Z",
    transform: "translate(1686 1133.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M45.913-130.19-14.854-238-55.906-282.04v-12.252l38.343,37.761,7.013-51.65,6.55-7.1-6.55,63.191,27.833,44.626,6.985-79.126,6.822,7.052v92.766l24.14,42.091,9.98,11.133-31.9,60.721L17.283-35.343,13.416-2.206l8,53.748L-13.1,58.882l2.009-67.2L5.8-60.818Z",
    transform: "translate(104 1445.104)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M531.41,430.3l-10.592-5.816-11.33,6.027-11.33-6.027-11.33,6.027-11.345-6.027-11.33,6.027-11.33-6.027-11.33,6.027-11.33-6.027-11.33,6.027L407.5,424.48l-11.33,6.027-11.33-6.027-11.556,6.7-11.089-6.7-11.33,6.027-11.33-6.027-11.33,6.027v7.988H553.873v-8.2l-9.37-5.816Z",
    transform: "translate(1269.398 411.857)",
    fill: "#f0f0f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M328.206,430.507l-11.315-6.027-11.33,6.027-11.315-6.027-11.33,6.027L271.6,424.48l-11.33,6.027-11.33-6.027-11.33,6.027-11.33-6.027-11.315,6.027v7.988l113.241-2.549Z",
    transform: "translate(1076.707 411.857)",
    fill: "#f0f0f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M210.5,430.507l11.315-6.027,11.33,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.315,6.027,11.33-6.027,11.315,6.027,11.33-6.027",
    transform: "translate(1082.242 411.857)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(63.219)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(282.965 -924.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-758",
    transform: "translate(1142.957 1116.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M398.19,662.988c11.484-20.3,35.425-66.876,38.946-79.263,15.162-53.31,6.592-102.11,0-125.981s-24.738-62.643-54.351-112S329.267,227.988,318.6,207.4s-113.647-76.574-136.7-89.758L158.84,104.47",
    transform: "translate(-158.84 -21.599)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M454.69,84.53s-46.128,46.944-70.832,78.239S294.1,325.84,294.1,325.84s39.536,62.592,56,97.149,34.592,82.333,34.592,125.166.815,84,.815,104.573c0,8.969,2.966,18.406,6.315,26.2",
    transform: "translate(-59.451 -36.251)",
    fill: "rgba(0,0,0,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M354.021,96.344,351.09,245.172l-2.411,3.8-37.159,59.573s-7.546-11.849-22.153-43.613c-16.862-36.691-42.26-97.149-41.427-104.556S315.717,84.6,319.846,78.84",
    transform: "translate(-93.385 -40.432)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M165.94,115.732S286.994,183.251,295.217,184.9s-43.63-98-43.63-98",
    transform: "translate(-153.623 -34.509)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M222.43,93.058s31.226,43.647,35.407,47.759S327,77.41,327,77.41",
    transform: "translate(-112.114 -41.482)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M345.84,63.17l10.7,82.351L418.32,84.577",
    transform: "translate(-21.433 -51.946)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M313.82,100.261,323.6,226.571l45.348-71.63L362.637,56.7",
    transform: "translate(-44.961 -56.7)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M335.926,488.039s-1.405-10.6,4.961-35.355,10.6-69.305,7.061-102.544",
    transform: "translate(-28.815 154.634)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M339.634,360.33a240.43,240.43,0,0,1-2.134,45.261",
    transform: "translate(-27.561 166.406)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M339.836,381.94a168.935,168.935,0,0,1-4.962,36.778c-4.944,19.794-9.194,28.277-9.194,28.277",
    transform: "translate(-36.246 182.285)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M334.65,308.15s9.194,31.833,11.311,46.683",
    transform: "translate(-29.655 128.065)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M336.28,337.1s2.116,20.505,2.828,26.161",
    transform: "translate(-28.458 149.337)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x1: 31.122,
    y1: 55.878,
    transform: "translate(253.367 328.015)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x1: 28.295,
    y1: 43.838,
    transform: "translate(232.151 306.105)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-758",
    transform: "translate(990.26 1147.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M173.76,229.263a10.409,10.409,0,0,0,7.564,6.245c5.6.954,12.855-2.845,12.855-2.845a36.431,36.431,0,0,0-11.346-6.349,9.42,9.42,0,0,0-9.073,2.949Z",
    transform: "translate(4.82 43.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M220.842,143.531s-6.939-6.939-16.307-4.285-18.025,13.74-18.025,13.74,12.872,3.47,22.327,1.735S220.842,143.531,220.842,143.531Z",
    transform: "translate(14.189 -21.074)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M289.929,288.141s-6.939-6.939-16.307-4.285S255.58,297.6,255.58,297.6s12.89,3.47,22.327,1.735S289.929,288.141,289.929,288.141Z",
    transform: "translate(64.941 85.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M173.451,131.17s-9.16,3.227-10.895,12.872,4.632,22.188,4.632,22.188,8.674-10.149,11.172-19.412S173.451,131.17,173.451,131.17Z",
    transform: "translate(-3.632 -26.564)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M202.412,323.84s-9.16,3.244-10.912,12.872,4.562,22.188,4.562,22.188,8.674-10.149,11.172-19.412S202.412,323.84,202.412,323.84Z",
    transform: "translate(17.63 115.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M264.14,133.073a10.409,10.409,0,0,0,7.564,6.245c5.6.954,12.872-2.845,12.872-2.845a36.622,36.622,0,0,0-11.363-6.349,9.42,9.42,0,0,0-9.073,2.949Z",
    transform: "translate(71.231 -27.495)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M220.56,123.232a10.409,10.409,0,0,0,7.546,6.245c5.621.954,12.872-2.845,12.872-2.845a36.43,36.43,0,0,0-11.363-6.349,9.4,9.4,0,0,0-9.056,2.949Z",
    transform: "translate(39.208 -34.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M130.6,324.157a10.409,10.409,0,0,0,7.546,6.245c5.621.937,12.872-2.845,12.872-2.845s-5.95-4.962-11.363-6.367A9.437,9.437,0,0,0,130.6,324.157Z",
    transform: "translate(-26.894 112.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M283.28,106.838s2.672,9.333,12.144,11.658,22.431-3.279,22.431-3.279-9.611-9.246-18.7-12.317S283.28,106.838,283.28,106.838Z",
    transform: "translate(85.295 -47.908)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M200.62,95.024s2.672,9.333,12.144,11.658,22.431-3.261,22.431-3.261-9.628-9.333-18.649-12.4S200.62,95.024,200.62,95.024Z",
    transform: "translate(24.557 -56.635)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M320.77,81.83s-1.058,9.645,6.939,15.405,22,5.465,22,5.465-5.378-12.144-12.629-18.493S320.77,81.83,320.77,81.83Z",
    transform: "translate(112.808 -63.721)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M148.123,190.609s-2-9.507-11.311-12.525-22.552,1.6-22.552,1.6,8.9,9.94,17.73,13.67S148.123,190.609,148.123,190.609Z",
    transform: "translate(-38.9 7.156)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M314.1,84.435s-1.978-9.524-11.294-12.543-22.552,1.613-22.552,1.613,8.882,9.94,17.73,13.67S314.1,84.435,314.1,84.435Z",
    transform: "translate(83.069 -70.871)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M146.143,145.068s-2-9.507-11.311-12.525-22.552,1.613-22.552,1.613,8.9,9.923,17.73,13.67S146.143,145.068,146.143,145.068Z",
    transform: "translate(-40.355 -26.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M146.143,145.068s-2-9.507-11.311-12.525-22.552,1.613-22.552,1.613,8.9,9.923,17.73,13.67S146.143,145.068,146.143,145.068Z",
    transform: "translate(-40.355 -26.306)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M276.536,216.078s-1.978-9.507-11.294-12.525-22.552,1.613-22.552,1.613,8.882,9.923,17.73,13.67S276.536,216.078,276.536,216.078Z",
    transform: "translate(55.47 25.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M276.536,216.078s-1.978-9.507-11.294-12.525-22.552,1.613-22.552,1.613,8.882,9.923,17.73,13.67S276.536,216.078,276.536,216.078Z",
    transform: "translate(55.47 25.872)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M216.369,178.09s-8.674-4.528-16.845.711-13.184,18.458-13.184,18.458,13.323-.52,21.841-4.944S216.369,178.09,216.369,178.09Z",
    transform: "translate(14.064 6.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M216.369,178.09s-8.674-4.528-16.845.711-13.184,18.458-13.184,18.458,13.323-.52,21.841-4.944S216.369,178.09,216.369,178.09Z",
    transform: "translate(14.064 6.578)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M363.38,273.135s8.049,5.447,16.845,1.128,15.093-16.914,15.093-16.914-13.306-.937-22.24,2.55S363.38,273.135,363.38,273.135Z",
    transform: "translate(144.152 66.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M363.38,273.135s8.049,5.447,16.845,1.128,15.093-16.914,15.093-16.914-13.306-.937-22.24,2.55S363.38,273.135,363.38,273.135Z",
    transform: "translate(144.152 66.068)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M382.13,129.4s8.049,5.447,16.845,1.128,15.093-16.914,15.093-16.914-13.306-.937-22.24,2.55S382.13,129.4,382.13,129.4Z",
    transform: "translate(157.93 -39.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M382.13,129.4s8.049,5.447,16.845,1.128,15.093-16.914,15.093-16.914-13.306-.937-22.24,2.55S382.13,129.4,382.13,129.4Z",
    transform: "translate(157.93 -39.552)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M256.639,80.2s-8.587-4.545-16.862.711S226.61,99.355,226.61,99.355s13.306-.52,21.824-4.944S256.639,80.2,256.639,80.2Z",
    transform: "translate(43.654 -65.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M256.639,80.2s-8.587-4.545-16.862.711S226.61,99.355,226.61,99.355s13.306-.52,21.824-4.944S256.639,80.2,256.639,80.2Z",
    transform: "translate(43.654 -65.355)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M222.419,107.963s-8.587-4.545-16.845.711-13.184,18.441-13.184,18.441,13.323-.52,21.841-4.944S222.419,107.963,222.419,107.963Z",
    transform: "translate(18.509 -44.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M222.419,107.963s-8.587-4.545-16.845.711-13.184,18.441-13.184,18.441,13.323-.52,21.841-4.944S222.419,107.963,222.419,107.963Z",
    transform: "translate(18.509 -44.957)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M188.262,98.6s-6.662,7.078-3.8,16.446,14.277,17.608,14.277,17.608,3.036-12.976,1.041-22.362S188.262,98.6,188.262,98.6Z",
    transform: "translate(12.159 -50.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M188.262,98.6s-6.662,7.078-3.8,16.446,14.277,17.608,14.277,17.608,3.036-12.976,1.041-22.362S188.262,98.6,188.262,98.6Z",
    transform: "translate(12.159 -50.496)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M128,91.509s.087,9.715,8.674,14.5,22.552,2.828,22.552,2.828-6.939-11.467-14.833-16.776S128,91.509,128,91.509Z",
    transform: "translate(-28.804 -57.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M128,91.509s.087,9.715,8.674,14.5,22.552,2.828,22.552,2.828-6.939-11.467-14.833-16.776S128,91.509,128,91.509Z",
    transform: "translate(-28.804 -57.145)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M131.723,126.067s9.385,2.5,16.255-4.458,8.674-20.939,8.674-20.939-12.872,3.47-20.176,9.715S131.723,126.067,131.723,126.067Z",
    transform: "translate(-26.386 -48.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M131.723,126.067s9.385,2.5,16.255-4.458,8.674-20.939,8.674-20.939-12.872,3.47-20.176,9.715S131.723,126.067,131.723,126.067Z",
    transform: "translate(-26.386 -48.975)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M350.065,156.018s8.587-4.545,8.9-14.329-7.841-21.269-7.841-21.269-7.061,11.294-8.188,20.818S350.065,156.018,350.065,156.018Z",
    transform: "translate(129.051 -34.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M350.065,156.018s8.587-4.545,8.9-14.329-7.841-21.269-7.841-21.269-7.061,11.294-8.188,20.818S350.065,156.018,350.065,156.018Z",
    transform: "translate(129.051 -34.463)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M381.6,132.1s-2.1-9.489-11.45-12.386-22.552,1.908-22.552,1.908,9.021,9.819,17.9,13.445S381.6,132.1,381.6,132.1Z",
    transform: "translate(132.557 -35.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M381.6,132.1s-2.1-9.489-11.45-12.386-22.552,1.908-22.552,1.908,9.021,9.819,17.9,13.445S381.6,132.1,381.6,132.1Z",
    transform: "translate(132.557 -35.664)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M320.79,94.447s.1,9.715,8.674,14.486,22.552,2.845,22.552,2.845-6.783-11.484-14.728-16.88S320.79,94.447,320.79,94.447Z",
    transform: "translate(112.857 -55.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M320.79,94.447s.1,9.715,8.674,14.486,22.552,2.845,22.552,2.845-6.783-11.484-14.728-16.88S320.79,94.447,320.79,94.447Z",
    transform: "translate(112.857 -55.069)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M324.515,128.94s9.4,2.515,16.272-4.458,8.674-20.922,8.674-20.922-12.872,3.47-20.193,9.7S324.515,128.94,324.515,128.94Z",
    transform: "translate(115.274 -46.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M324.515,128.94s9.4,2.515,16.272-4.458,8.674-20.922,8.674-20.922-12.872,3.47-20.193,9.7S324.515,128.94,324.515,128.94Z",
    transform: "translate(115.274 -46.851)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M221.67,128.947s.087,9.715,8.674,14.486,22.552,2.845,22.552,2.845-6.783-11.484-14.728-16.88S221.67,128.947,221.67,128.947Z",
    transform: "translate(40.024 -29.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M221.67,128.947s.087,9.715,8.674,14.486,22.552,2.845,22.552,2.845-6.783-11.484-14.728-16.88S221.67,128.947,221.67,128.947Z",
    transform: "translate(40.024 -29.718)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M225.39,163.44s9.385,2.5,16.272-4.458,8.674-20.922,8.674-20.922-12.872,3.47-20.176,9.7S225.39,163.44,225.39,163.44Z",
    transform: "translate(42.445 -21.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M225.39,163.44s9.385,2.5,16.272-4.458,8.674-20.922,8.674-20.922-12.872,3.47-20.176,9.7S225.39,163.44,225.39,163.44Z",
    transform: "translate(42.445 -21.501)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M287.689,144.594s-2.741-9.316-12.282-11.571-22.4,3.47-22.4,3.47,9.663,9.177,18.771,12.144S287.689,144.594,287.689,144.594Z",
    transform: "translate(63.053 -25.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M287.689,144.594s-2.741-9.316-12.282-11.571-22.4,3.47-22.4,3.47,9.663,9.177,18.771,12.144S287.689,144.594,287.689,144.594Z",
    transform: "translate(63.053 -25.589)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M270.254,116.76s-9.715.156-14.434,8.674-2.637,22.552-2.637,22.552,11.415-6.939,16.741-14.867S270.254,116.76,270.254,116.76Z",
    transform: "translate(62.844 -37.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M270.254,116.76s-9.715.156-14.434,8.674-2.637,22.552-2.637,22.552,11.415-6.939,16.741-14.867S270.254,116.76,270.254,116.76Z",
    transform: "translate(62.844 -37.152)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M268.919,114.131s-2.741-9.333-12.265-11.588-22.414,3.47-22.414,3.47,9.663,9.177,18.788,12.144S268.919,114.131,268.919,114.131Z",
    transform: "translate(49.261 -47.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M268.919,114.131s-2.741-9.333-12.265-11.588-22.414,3.47-22.414,3.47,9.663,9.177,18.788,12.144S268.919,114.131,268.919,114.131Z",
    transform: "translate(49.261 -47.985)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M251.5,86.29s-9.715.173-14.416,8.674-2.654,22.552-2.654,22.552,11.415-6.939,16.741-14.85S251.5,86.29,251.5,86.29Z",
    transform: "translate(49.073 -59.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M251.5,86.29s-9.715.173-14.416,8.674-2.654,22.552-2.654,22.552,11.415-6.939,16.741-14.85S251.5,86.29,251.5,86.29Z",
    transform: "translate(49.073 -59.541)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M290.33,159.287S290.417,169,299,173.772s22.552,2.845,22.552,2.845-6.783-11.484-14.728-16.88S290.33,159.287,290.33,159.287Z",
    transform: "translate(90.475 -7.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M290.33,159.287S290.417,169,299,173.772s22.552,2.845,22.552,2.845-6.783-11.484-14.728-16.88S290.33,159.287,290.33,159.287Z",
    transform: "translate(90.475 -7.424)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M294.05,193.75s9.385,2.5,16.272-4.458S319,168.37,319,168.37s-12.872,3.47-20.176,9.7S294.05,193.75,294.05,193.75Z",
    transform: "translate(92.897 0.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M294.05,193.75s9.385,2.5,16.272-4.458S319,168.37,319,168.37s-12.872,3.47-20.176,9.7S294.05,193.75,294.05,193.75Z",
    transform: "translate(92.897 0.771)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M376.719,206.08s-8.587-4.528-16.845.711-13.184,18.458-13.184,18.458,13.323-.52,21.841-4.944S376.719,206.08,376.719,206.08Z",
    transform: "translate(131.888 27.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M376.719,206.08s-8.587-4.528-16.845.711-13.184,18.458-13.184,18.458,13.323-.52,21.841-4.944S376.719,206.08,376.719,206.08Z",
    transform: "translate(131.888 27.145)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M342.552,196.73s-6.662,7.078-3.8,16.446,14.277,17.608,14.277,17.608,3.053-12.976,1.041-22.379S342.552,196.73,342.552,196.73Z",
    transform: "translate(125.531 21.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M342.552,196.73s-6.662,7.078-3.8,16.446,14.277,17.608,14.277,17.608,3.053-12.976,1.041-22.379S342.552,196.73,342.552,196.73Z",
    transform: "translate(125.531 21.61)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M312.4,134.273c5.4,7.945,7.46,21.113,7.46,21.113s-13.67-3.331-19.846-10.929-2.672-16.671-2.672-16.671S307.022,126.327,312.4,134.273Zm-14.867,22.691c-9.09,3.088-10.253,12.8-10.253,12.8s7.807,5.794,16.758,1.856,15.821-16.238,15.821-16.238S306.623,153.876,297.533,156.964Z",
    transform: "translate(88.234 -29.128)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M338.492,154.282c-9.472,1.579-22.292-2.047-22.292-2.047s8.674-11.033,18.233-13.462S350.67,143.3,350.67,143.3,347.964,152.7,338.492,154.282Zm-14.4-23.073c1.006-9.541-7.338-14.659-7.338-14.659s-8.518,4.667-8.674,14.451,8.136,21.165,8.136,21.165S323.1,140.837,324.093,131.209Z",
    transform: "translate(103.517 -37.306)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M286.481,97.159c-4.58,8.448-15.336,16.324-15.336,16.324s-3.314-13.688.59-22.656S285.3,80.8,285.3,80.8,291.061,88.728,286.481,97.159Zm-26.993-2.793c-6.939-6.662-16.082-3.227-16.082-3.227s-1.561,9.593,6.054,15.752,21.685,6.592,21.685,6.592S266.409,101.028,259.488,94.366Z",
    transform: "translate(55.899 -63.575)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M240.391,126.849c-4.58,8.431-15.336,16.324-15.336,16.324s-3.313-13.687.59-22.674,13.566-10.01,13.566-10.01S244.971,118.418,240.391,126.849ZM213.4,124.056c-6.939-6.662-16.082-3.227-16.082-3.227s-1.561,9.576,6.054,15.735,21.685,6.61,21.685,6.61S220.319,130.718,213.4,124.056Z",
    transform: "translate(22.032 -41.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M173.35,95.207c5.4,7.945,7.46,21.112,7.46,21.112s-13.67-3.331-19.863-10.929-2.672-16.654-2.672-16.654S167.955,87.261,173.35,95.207ZM158.483,117.9c-9.09,3.088-10.253,12.8-10.253,12.8s7.789,5.794,16.758,1.856,15.821-16.238,15.821-16.238S167.573,114.81,158.483,117.9Z",
    transform: "translate(-13.939 -57.824)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M325.818,184.746c-2.325-9.333.295-22.4.295-22.4s11.675,7.859,14.85,17.122-3.244,16.55-3.244,16.55S328.125,194.062,325.818,184.746ZM347.659,168.6c9.611.243,14.052-8.466,14.052-8.466s-5.309-8.136-15.093-7.546-20.453,9.767-20.453,9.767S338.013,168.335,347.659,168.6Z",
    transform: "translate(115.845 -10.852)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M192.512,120.365c-9.489-1.457-20.557-8.882-20.557-8.882s11.762-7.772,21.529-7.13,14.034,9.351,14.034,9.351S202.019,121.8,192.512,120.365ZM185.989,94.03c3.921-8.674-2.429-16.22-2.429-16.22s-9.541,1.735-12.751,11.033,1.145,22.552,1.145,22.552,10.114-8.6,14.035-17.365Z",
    transform: "translate(1.785 -65.772)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M81.836,192.155c9.264-2.515,22.4-.191,22.4-.191s-7.6,11.849-16.793,15.232-16.619-2.9-16.619-2.9S72.572,194.671,81.836,192.155Zm16.619,21.407c0,9.611,8.778,13.878,8.778,13.878s8.015-5.5,7.217-15.249-10.218-20.245-10.218-20.245S98.507,204,98.455,213.563Z",
    transform: "translate(-70.82 17.389)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M391.249,85.065c-.156,9.593-6.02,21.564-6.02,21.564s-9.281-10.582-9.975-20.349S382.627,71.1,382.627,71.1,391.422,75.472,391.249,85.065ZM366.042,95.11c-9.212-2.706-15.752,4.6-15.752,4.6s3.071,9.212,12.664,11.137,22.275-4.216,22.275-4.216S375.254,97.8,366.042,95.11Z",
    transform: "translate(134.534 -70.703)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M113.934,232.5a11.294,11.294,0,0,0-8.847,6c-2.724,5.586-.971,14.347-.971,14.347s6.939-4.719,10.131-9.94a10.3,10.3,0,0,0-.312-10.409Z",
    transform: "translate(-46.763 47.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M113.934,232.5a11.294,11.294,0,0,0-8.847,6c-2.724,5.586-.971,14.347-.971,14.347s6.939-4.719,10.131-9.94a10.3,10.3,0,0,0-.312-10.409Z",
    transform: "translate(-46.763 47.893)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M283.728,252.52a11.294,11.294,0,0,0-8.865,5.985c-2.706,5.586-.971,14.347-.971,14.347s6.939-4.719,10.149-9.94A10.287,10.287,0,0,0,283.728,252.52Z",
    transform: "translate(77.994 62.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M283.728,252.52a11.294,11.294,0,0,0-8.865,5.985c-2.706,5.586-.971,14.347-.971,14.347s6.939-4.719,10.149-9.94A10.287,10.287,0,0,0,283.728,252.52Z",
    transform: "translate(77.994 62.604)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M86.084,333.55a11.294,11.294,0,0,0-8.847,6c-2.724,5.586-.971,14.347-.971,14.347s6.939-4.719,10.131-9.94A10.409,10.409,0,0,0,86.084,333.55Z",
    transform: "translate(-67.227 122.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M86.084,333.55a11.294,11.294,0,0,0-8.847,6c-2.724,5.586-.971,14.347-.971,14.347s6.939-4.719,10.131-9.94A10.409,10.409,0,0,0,86.084,333.55Z",
    transform: "translate(-67.227 122.145)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M296.6,164.479a11.294,11.294,0,0,0-10.686.451c-5.2,3.331-8.362,11.693-8.362,11.693s8.449-.33,13.878-3.14A10.27,10.27,0,0,0,296.6,164.479Z",
    transform: "translate(81.085 -2.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M296.6,164.479a11.294,11.294,0,0,0-10.686.451c-5.2,3.331-8.362,11.693-8.362,11.693s8.449-.33,13.878-3.14A10.27,10.27,0,0,0,296.6,164.479Z",
    transform: "translate(81.085 -2.919)",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Flying_kite-bro",
    "data-name": "Flying kite-bro",
    transform: "translate(561.498 325.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-122",
    transform: "translate(374.191 439.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M241.163,404.344a19.433,19.433,0,0,0,5.151-2.466s-2.119-1.827-2.265-1.827c-1.735-1.1-5.717-2.229-7.489-.767a2.722,2.722,0,0,0,0,4.055A5.7,5.7,0,0,0,241.163,404.344Z",
    transform: "translate(-12.941 -349.808)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M260.794,396s-.8-2.667-.859-2.813c-.84-1.827-3.544-5.023-5.827-4.767a2.7,2.7,0,0,0-2.283,3.324,5.7,5.7,0,0,0,3.306,3.471,19.33,19.33,0,0,0,5.662.785Z",
    transform: "translate(0.362 -358.229)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M276.066,444.488q1.187,1.443,2.137,2.74h1.626C279.007,446.187,278,445,277,443.721c-.621-.749-1.315-1.534-2.009-2.32a25.075,25.075,0,0,0,1.827-2.466,17.754,17.754,0,0,0,4.767.329c.11.95.219,1.827.292,2.74.183,1.991.292,3.745.384,5.224h1.3c-.091-1.516-.256-3.306-.493-5.334-.11-.968-.237-1.991-.384-3.05a16.44,16.44,0,0,0,4.512-2.046,4.987,4.987,0,0,0,1.918-3.653,2.393,2.393,0,0,0-2.74-2.265c-1.991.365-3.489,3.653-3.745,5.48v1.991a7.987,7.987,0,0,0-.183-1.279c-.146-.877-.292-1.827-.457-2.685-.11-.457-.2-.913-.311-1.37s-.237-.932-.347-1.388c-.292-1.1-.658-2.174-1.041-3.251a16.024,16.024,0,0,0,4.621-1.315,5.006,5.006,0,0,0,2.484-3.4,2.411,2.411,0,0,0-2.375-2.649c-2.028,0-4.018,3.105-4.53,4.822,0,.11-.256,1.406-.365,2.1-.219-.639-.457-1.3-.712-1.936-.749-1.827-1.571-3.745-2.375-5.626l-.712-1.717a16.438,16.438,0,0,0,4.786-1.333,4.987,4.987,0,0,0,2.466-3.4,2.393,2.393,0,0,0-2.375-2.649c-2.009,0-4,3.087-4.512,4.822,0,.128-.365,1.973-.42,2.448-.53-1.26-1.041-2.521-1.5-3.8a40.416,40.416,0,0,1-1.553-5.224,16.9,16.9,0,0,0,4.822-1.333,4.987,4.987,0,0,0,2.466-3.4,2.393,2.393,0,0,0-2.375-2.649c-2.009,0-4,3.087-4.512,4.822,0,.11-.274,1.516-.384,2.192h-.11a30.193,30.193,0,0,1-.585-5.48V400.76a15.507,15.507,0,0,0,4.822-.8,4.986,4.986,0,0,0,2.831-3.087,2.393,2.393,0,0,0-2.064-2.9c-2.009-.164-4.329,2.649-5.023,4.311,0,.091-.311,1.041-.511,1.827a6.034,6.034,0,0,1,.091-1.279c.128-1.516.329-2.9.53-4.128.11-.694.237-1.315.347-1.827a15.645,15.645,0,0,0,3.891-2.923,5.042,5.042,0,0,0,1.1-4.055,2.393,2.393,0,0,0-3.178-1.607c-1.827.767-2.63,4.329-2.466,6.119,0,.164.493,2.557.53,2.539h0c-.128.566-.256,1.169-.384,1.827-.219,1.224-.475,2.612-.621,4.128a41.746,41.746,0,0,0-.292,4.95,30.7,30.7,0,0,0,.475,5.48h0c-.274-.511-1.1-1.954-1.169-2.064-1.059-1.443-3.964-3.653-5.882-3a2.374,2.374,0,0,0-1.333,3.288,5.06,5.06,0,0,0,3.471,2.356,16.443,16.443,0,0,0,4.968-.365,40.89,40.89,0,0,0,1.48,5.48c.347,1.041.731,2.064,1.133,3.105l-.511-.9c-1.059-1.443-3.982-3.653-5.9-3a2.393,2.393,0,0,0-1.333,3.288,5.041,5.041,0,0,0,3.489,2.356,15.6,15.6,0,0,0,4.822-.347c.146.4.311.785.475,1.187.749,1.826,1.534,3.781,2.228,5.644.237.658.457,1.315.676,1.973l-.438-.767c-1.078-1.461-3.982-3.653-5.9-3.014a2.411,2.411,0,0,0-1.333,3.306,5.042,5.042,0,0,0,3.489,2.356,15.341,15.341,0,0,0,4.694-.329c.2.694.4,1.37.566,2.027s.238.9.329,1.37.183.913.256,1.37c.146.877.292,1.827.4,2.63s.146,1.169.219,1.827c-.237-.676-.731-1.954-.785-2.046a9.134,9.134,0,0,0-3.27-3.361,2.189,2.189,0,0,0-.274-.438,2.393,2.393,0,0,0-3.544-.365c-1.461,1.388-.9,4.987-.11,6.594a19.465,19.465,0,0,0,1.078,1.7l-.877-.968-1.827-1.991-1-.968c-.329-.347-.712-.639-1.059-.968-.858-.749-1.827-1.443-2.667-2.137a15.71,15.71,0,0,0,3.142-3.653,5.041,5.041,0,0,0,.183-4.2,2.393,2.393,0,0,0-3.434-.895c-1.644,1.169-1.644,4.8-1.114,6.521,0,.11.566,1.3.859,1.954-.548-.42-1.1-.822-1.681-1.224-1.644-1.151-3.361-2.265-5.06-3.379l-1.571-1.041a16.563,16.563,0,0,0,3.27-3.763,5,5,0,0,0,.183-4.183,2.393,2.393,0,0,0-3.434-.913c-1.644,1.169-1.644,4.8-1.114,6.521l1,2.283c-1.132-.767-2.265-1.534-3.343-2.338a44.2,44.2,0,0,1-4.183-3.507,16.441,16.441,0,0,0,3.288-3.781,5.041,5.041,0,0,0,.183-4.2,2.393,2.393,0,0,0-3.434-.895c-1.662,1.151-1.644,4.8-1.114,6.521,0,.11.6,1.425.895,2.028h0a29.572,29.572,0,0,1-3.489-4.238c-.584-.822-1.1-1.644-1.571-2.448a16.056,16.056,0,0,0,3.653-3.324,4.987,4.987,0,0,0,.639-4.146,2.393,2.393,0,0,0-3.306-1.279c-1.827.968-2.155,4.585-1.827,6.357,0,.11.311,1.059.548,1.827l-.639-1.1c-.731-1.352-1.315-2.612-1.827-3.744-.292-.639-.53-1.242-.749-1.827a15.853,15.853,0,0,0,1.626-4.567,5.041,5.041,0,0,0-1.333-4,2.393,2.393,0,0,0-3.525.4c-1.133,1.68.2,5.078,1.315,6.484.091.128,1.827,1.827,1.827,1.827h0c.2.53.42,1.114.676,1.735a38.763,38.763,0,0,0,1.827,3.781,39.56,39.56,0,0,0,2.484,4.292,30.743,30.743,0,0,0,3.434,4.329h0c-.511-.292-1.991-1.041-2.1-1.078-1.7-.621-5.334-.84-6.576.749a2.374,2.374,0,0,0,.712,3.47,5.042,5.042,0,0,0,4.2,0,16.839,16.839,0,0,0,3.927-3.05,41.744,41.744,0,0,0,4.238,3.653c.859.676,1.827,1.315,2.667,1.954l-.932-.457c-1.7-.621-5.315-.84-6.576.749a2.393,2.393,0,0,0,.712,3.489,4.969,4.969,0,0,0,4.2,0,15.58,15.58,0,0,0,3.836-2.941l1.041.731c1.68,1.151,3.361,2.3,4.968,3.47.585.42,1.114.84,1.662,1.279l-.8-.4c-1.68-.621-5.315-.84-6.557.749a2.411,2.411,0,0,0,.694,3.489,5.041,5.041,0,0,0,4.2,0,15.729,15.729,0,0,0,3.653-2.849c.548.457,1.1.895,1.607,1.37s.694.6,1.023.95l.968,1,1.827,1.973,1.133,1.333-1.827-1.26c-1.589-.877-5.133-1.644-6.612-.256a2.393,2.393,0,0,0,.164,3.544,5.023,5.023,0,0,0,4.146.676,16.242,16.242,0,0,0,4.329-2.393Q275.244,443.447,276.066,444.488Z",
    transform: "translate(-10.618 -361.768)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M458.314,397.533a17.092,17.092,0,0,1-4.514-2.15s1.865-1.556,2-1.639c1.509-.974,4.989-1.96,6.546-.677a2.376,2.376,0,0,1,0,3.564A4.966,4.966,0,0,1,458.314,397.533Z",
    transform: "translate(232.812 -350.181)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M433.94,385.442s.689-2.376.748-2.471c.725-1.639,3.1-4.383,5.1-4.17a2.376,2.376,0,0,1,2,2.922,4.965,4.965,0,0,1-2.887,3.017,16.917,16.917,0,0,1-4.954.7Z",
    transform: "translate(229.08 -352.749)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M433.016,425c-.689.855-1.307,1.663-1.877,2.376h-1.414c.713-.915,1.544-1.948,2.483-3.065.546-.642,1.188-1.331,1.758-2.031a22.744,22.744,0,0,1-1.568-2.15,15.222,15.222,0,0,1-4.182.285c-.095.832-.178,1.639-.249,2.376-.155,1.722-.261,3.255-.321,4.55h-1.188c.1-1.319.226-2.887.44-4.657.1-.843.2-1.746.333-2.673a14.255,14.255,0,0,1-3.932-1.782,4.36,4.36,0,0,1-1.7-3.267,2.091,2.091,0,0,1,2.376-1.972c1.746.309,3.065,3.207,3.279,4.752v1.746a7.386,7.386,0,0,1,.166-1.129c.119-.772.249-1.532.4-2.376l.25-1.188c.083-.4.214-.82.321-1.188.261-.95.57-1.9.9-2.839a13.7,13.7,0,0,1-4.039-1.188,4.36,4.36,0,0,1-2.174-2.97,2.1,2.1,0,0,1,2.079-2.316c1.758,0,3.5,2.708,3.956,4.229,0,.1.226,1.188.321,1.829.2-.57.4-1.188.63-1.7.653-1.639,1.366-3.279,2.067-4.918.214-.5.428-1,.63-1.509a14.681,14.681,0,0,1-4.182-1.188,4.348,4.348,0,0,1-2.162-2.97,2.079,2.079,0,0,1,2.067-2.376c1.77,0,3.564,2.708,3.956,4.217,0,.119.309,1.734.368,2.15.463-1.1.915-2.209,1.319-3.326a36.938,36.938,0,0,0,1.342-4.573,14.6,14.6,0,0,1-4.205-1.188,4.324,4.324,0,0,1-2.162-2.958,2.079,2.079,0,0,1,2.067-2.316c1.77,0,3.564,2.708,3.956,4.217,0,.095.238,1.33.333,1.912h.1a25.923,25.923,0,0,0,.511-4.752v-2.554a13.472,13.472,0,0,1-4.217-.7,4.36,4.36,0,0,1-2.471-2.708,2.091,2.091,0,0,1,1.806-2.53c1.758-.143,3.778,2.3,4.383,3.766,0,.083.285.915.451,1.532a5.7,5.7,0,0,0-.071-1.1c-.107-1.331-.3-2.542-.463-3.564-.107-.606-.2-1.188-.309-1.675a13.519,13.519,0,0,1-3.4-2.542,4.336,4.336,0,0,1-.95-3.564,2.091,2.091,0,0,1,2.768-1.414c1.627.677,2.293,3.789,2.162,5.357,0,.143-.428,2.245-.463,2.221h0c.107.487.214,1.01.321,1.592.2,1.069.416,2.281.546,3.564a32.966,32.966,0,0,1,.25,4.324,26.125,26.125,0,0,1-.4,4.823v.059c.238-.451.962-1.711,1.022-1.806.927-1.271,3.481-3.184,5.156-2.625a2.1,2.1,0,0,1,1.188,2.887,4.43,4.43,0,0,1-3.041,2.055,15.028,15.028,0,0,1-4.348-.321A37.633,37.633,0,0,1,434.7,398.9c-.309.915-.653,1.817-1,2.72.214-.392.416-.737.451-.784.927-1.271,3.481-3.172,5.156-2.625A2.1,2.1,0,0,1,440.5,401.1a4.359,4.359,0,0,1-3.041,2.055,13.872,13.872,0,0,1-4.217-.3l-.475,1.236c-.665,1.651-1.342,3.3-1.948,4.942-.214.57-.416,1.188-.606,1.722l.392-.677c.938-1.271,3.481-3.184,5.156-2.625a2.091,2.091,0,0,1,1.188,2.887,4.4,4.4,0,0,1-2.994,2.067,13.554,13.554,0,0,1-4.1-.273c-.19.594-.368,1.188-.511,1.77-.1.4-.214.784-.285,1.188s-.154.808-.226,1.188c-.119.772-.249,1.556-.344,2.3-.071.523-.131,1.022-.19,1.521.2-.57.641-1.687.689-1.782a8.042,8.042,0,0,1,2.851-2.934,3.562,3.562,0,0,1,.249-.392,2.091,2.091,0,0,1,3.089-.321c1.271,1.188.784,4.36.1,5.785a16.476,16.476,0,0,1-.938,1.473c.261-.285.5-.558.772-.843.511-.582,1.045-1.188,1.627-1.734l.867-.855c.285-.3.63-.57.938-.855.737-.641,1.521-1.259,2.317-1.865a13.694,13.694,0,0,1-2.732-3.184,4.371,4.371,0,0,1-.166-3.671,2.079,2.079,0,0,1,3.005-.784c1.449,1.01,1.437,4.193.962,5.7,0,.083-.475,1.129-.737,1.7.487-.356.962-.725,1.461-1.069,1.449-1.01,2.946-1.984,4.443-2.958l1.354-.9a14.823,14.823,0,0,1-2.851-3.291,4.407,4.407,0,0,1-.166-3.671,2.091,2.091,0,0,1,3.005-.784c1.449,1.01,1.437,4.193.974,5.7a21.351,21.351,0,0,1-.879,1.984c1-.665,1.984-1.33,2.934-2.043a35.523,35.523,0,0,0,3.647-3.065,14.6,14.6,0,0,1-2.863-3.3,4.371,4.371,0,0,1-.166-3.671,2.079,2.079,0,0,1,3.005-.784c1.449,1.01,1.437,4.193.962,5.7,0,.095-.523,1.188-.772,1.782l.083.06a28.041,28.041,0,0,0,3.053-3.706c.511-.713.95-1.437,1.378-2.138a14.256,14.256,0,0,1-3.136-2.91,4.4,4.4,0,0,1-.57-3.635,2.079,2.079,0,0,1,2.9-1.1c1.556.843,1.889,4,1.592,5.559,0,.083-.273.915-.463,1.521l.546-.962c.641-1.188,1.188-2.281,1.6-3.267.249-.57.463-1.081.653-1.568a14.122,14.122,0,0,1-1.426-4,4.407,4.407,0,0,1,1.188-3.481,2.091,2.091,0,0,1,3.089.356c.986,1.461-.166,4.419-1.188,5.666-.083.107-1.592,1.627-1.6,1.592h0c-.178.475-.368.974-.594,1.521-.428,1-.927,2.126-1.544,3.314a39.566,39.566,0,0,1-2.174,3.742,27.18,27.18,0,0,1-3.005,3.8h0c.451-.25,1.746-.9,1.841-.939,1.485-.546,4.657-.736,5.75.653a2.079,2.079,0,0,1-.618,3.041,4.36,4.36,0,0,1-3.671,0,14.446,14.446,0,0,1-3.445-2.661,36.474,36.474,0,0,1-3.706,3.255,27.651,27.651,0,0,1-2.376,1.723l.808-.4c1.485-.546,4.657-.737,5.75.653a2.079,2.079,0,0,1-.618,3.041,4.312,4.312,0,0,1-3.671,0,13.923,13.923,0,0,1-3.35-2.566l-.915.63c-1.473,1.01-2.946,2.02-4.36,3.041-.5.368-.974.737-1.449,1.117l.7-.344c1.473-.546,4.657-.737,5.75.641a2.1,2.1,0,0,1-.618,3.053,4.383,4.383,0,0,1-3.682,0,13.568,13.568,0,0,1-3.267-2.495c-.475.4-.95.8-1.4,1.188a9.2,9.2,0,0,0-.891.843l-.855.867c-.511.57-1.057,1.188-1.556,1.734l-1,1.188c.5-.368,1.473-1.057,1.556-1.1,1.378-.772,4.49-1.437,5.785-.238a2.1,2.1,0,0,1-.154,3.112,4.371,4.371,0,0,1-3.623.594,14.767,14.767,0,0,1-3.825-2.055C434.014,423.78,433.491,424.409,433.016,425Z",
    transform: "translate(226.761 -354.047)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M327.9,403.855a21.608,21.608,0,0,1-5.608-2.667s2.32-1.936,2.466-2.046c1.827-1.206,6.21-2.429,8.128-.84a2.941,2.941,0,0,1,0,4.384,6.174,6.174,0,0,1-4.987,1.169Z",
    transform: "translate(58.672 -350.671)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M306.26,394.737s.858-2.886.932-3.069c.913-2.027,3.854-5.48,6.32-5.169A2.941,2.941,0,0,1,316,390.152a6.228,6.228,0,0,1-3.653,3.763A21.512,21.512,0,0,1,306.26,394.737Z",
    transform: "translate(28.422 -359.819)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M202.576,404.207a20.383,20.383,0,0,0,5.48-2.612s-2.247-1.827-2.411-1.973c-1.827-1.169-6.028-2.356-7.909-.822a2.868,2.868,0,0,0,0,4.274A6.027,6.027,0,0,0,202.576,404.207Z",
    transform: "translate(-73.971 -350.237)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M190.738,395.365s-.84-2.813-.913-2.977c-.877-1.973-3.653-5.3-6.137-5.041a2.849,2.849,0,0,0-2.411,3.525,5.973,5.973,0,0,0,3.47,3.653A20.245,20.245,0,0,0,190.738,395.365Z",
    transform: "translate(-28.178 -359.114)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M211.6,445.957c.84,1.023,1.589,1.991,2.265,2.886h1.717c-.858-1.1-1.827-2.356-3-3.653-.658-.785-1.388-1.626-2.119-2.466a27.206,27.206,0,0,0,1.827-2.594,19.179,19.179,0,0,0,5.041.347c.128,1,.219,1.973.311,2.9.2,2.082.311,3.945.4,5.48h1.37c-.11-1.589-.274-3.489-.511-5.626-.11-1.023-.256-2.119-.42-3.233a16.82,16.82,0,0,0,4.767-2.155,5.279,5.279,0,0,0,2.046-3.927,2.539,2.539,0,0,0-2.9-2.393c-2.1.384-3.653,3.872-3.945,5.772v2.1a9.187,9.187,0,0,0-.2-1.37c-.146-.913-.311-1.827-.475-2.831-.11-.475-.219-.95-.311-1.443s-.256-.968-.384-1.461c-.311-1.151-.694-2.3-1.1-3.434a16.807,16.807,0,0,0,4.877-1.388,5.225,5.225,0,0,0,2.612-3.653,2.5,2.5,0,0,0-2.5-2.795c-2.119,0-4.238,3.27-4.767,5.1,0,.11-.274,1.461-.384,2.21-.256-.694-.493-1.37-.767-2.064-.785-1.973-1.644-3.945-2.5-5.936l-.767-1.827a17.482,17.482,0,0,0,5.06-1.407,5.3,5.3,0,0,0,2.612-3.653,2.521,2.521,0,0,0-2.5-2.795c-2.137,0-4.238,3.27-4.767,5.1,0,.146-.384,2.082-.438,2.594-.566-1.333-1.114-2.667-1.589-4.019a42.95,42.95,0,0,1-1.644-5.48,17.806,17.806,0,0,0,5-1.242,5.279,5.279,0,0,0,2.612-3.653,2.521,2.521,0,0,0-2.5-2.795c-2.137,0-4.238,3.27-4.786,5.1,0,.128-.292,1.607-.4,2.32h-.11a32.19,32.19,0,0,1-.621-5.772v-3.069a16.884,16.884,0,0,0,5.1-.84,5.279,5.279,0,0,0,3-3.288,2.521,2.521,0,0,0-2.174-3.05c-2.137-.183-4.585,2.795-5.315,4.548,0,.091-.329,1.114-.548,1.827a6.553,6.553,0,0,1,.091-1.333c.146-1.607.365-3.069.566-4.366.128-.731.256-1.388.384-2.009a16.641,16.641,0,0,0,4.092-3.087,5.243,5.243,0,0,0,1.151-4.274,2.521,2.521,0,0,0-3.343-1.717c-1.973.822-2.776,4.585-2.612,6.484,0,.164.511,2.7.548,2.685h0c-.128.6-.256,1.242-.384,1.936-.237,1.3-.493,2.758-.676,4.366a46.391,46.391,0,0,0-.292,5.224,32.456,32.456,0,0,0,.493,5.827h0c-.292-.548-1.169-2.064-1.242-2.174-1.114-1.534-4.2-3.836-6.229-3.178a2.539,2.539,0,0,0-1.406,3.489,5.352,5.352,0,0,0,3.653,2.484,17.514,17.514,0,0,0,5.242-.384,42.486,42.486,0,0,0,1.553,5.736c.365,1.114.785,2.192,1.206,3.288l-.548-.932c-1.132-1.553-4.2-3.854-6.229-3.178a2.5,2.5,0,0,0-1.406,3.471,5.242,5.242,0,0,0,3.653,2.484,16.785,16.785,0,0,0,5.1-.347l.493,1.242c.822,2.009,1.626,4,2.356,5.973.274.694.493,1.388.731,2.082l-.475-.822c-1.133-1.534-4.2-3.836-6.229-3.16A2.521,2.521,0,0,0,206.6,428.2a5.3,5.3,0,0,0,3.653,2.484,16.439,16.439,0,0,0,4.95-.329c.219.712.438,1.443.621,2.137s.237.95.329,1.443l.274,1.443c.146.932.292,1.827.42,2.795.091.621.146,1.224.219,1.827-.237-.694-.767-2.046-.822-2.155a9.919,9.919,0,0,0-3.452-3.544,2.563,2.563,0,0,0-.292-.475,2.521,2.521,0,0,0-3.653-.383c-1.553,1.479-.95,5.279-.128,6.978,0,.11.712,1.151,1.133,1.827l-.913-1.023-1.973-2.1L205.9,438.1c-.347-.365-.749-.676-1.133-1.023-.9-.785-1.827-1.534-2.795-2.265a16.714,16.714,0,0,0,3.306-3.854,5.279,5.279,0,0,0,.2-4.42,2.5,2.5,0,0,0-3.653-.95c-1.735,1.224-1.735,5.06-1.169,6.886,0,.11.585,1.37.9,2.046l-1.827-1.279c-1.735-1.224-3.544-2.393-5.352-3.653l-1.644-1.1a17.187,17.187,0,0,0,3.434-3.964,5.26,5.26,0,0,0,.219-4.439,2.539,2.539,0,0,0-3.653-.95c-1.827,1.224-1.735,5.078-1.169,6.886a24.726,24.726,0,0,0,1.059,2.411c-1.206-.8-2.393-1.626-3.544-2.466a46.538,46.538,0,0,1-4.42-3.653,17.775,17.775,0,0,0,3.47-4,5.279,5.279,0,0,0,.2-4.42,2.5,2.5,0,0,0-3.653-.95c-1.735,1.224-1.735,5.06-1.169,6.886,0,.11.639,1.5.95,2.137h-.11a32.879,32.879,0,0,1-3.653-4.457c-.6-.877-1.151-1.735-1.662-2.594a16.714,16.714,0,0,0,3.781-3.525,5.279,5.279,0,0,0,.694-4.384A2.521,2.521,0,0,0,180,405.681c-1.827,1.023-2.283,4.841-1.918,6.7,0,.11.329,1.114.566,1.827-.219-.4-.457-.785-.658-1.169-.767-1.425-1.388-2.758-1.936-3.945-.311-.694-.566-1.315-.8-1.827a16.658,16.658,0,0,0,1.827-4.822,5.315,5.315,0,0,0-1.425-4.22,2.521,2.521,0,0,0-3.653.42c-1.187,1.827.219,5.352,1.388,6.85.11.128,1.936,1.973,1.954,1.936h0c.219.566.457,1.169.731,1.827.511,1.206,1.114,2.557,1.827,4a45.639,45.639,0,0,0,2.612,4.512,31.984,31.984,0,0,0,3.653,4.585h0l-2.247-1.133c-1.827-.658-5.608-.9-6.923.785a2.5,2.5,0,0,0,.731,3.653,5.241,5.241,0,0,0,4.439,0,17.932,17.932,0,0,0,4.165-3.215,42.478,42.478,0,0,0,4.475,3.927c.913.712,1.827,1.406,2.813,2.082l-.986-.493c-1.827-.658-5.626-.877-6.941.785a2.539,2.539,0,0,0,.749,3.653,5.3,5.3,0,0,0,4.438,0,17.132,17.132,0,0,0,4.055-3.105l1.1.767c1.827,1.224,3.562,2.429,5.261,3.653.6.438,1.187.9,1.827,1.352l-.84-.42c-1.827-.658-5.626-.9-6.941.785a2.521,2.521,0,0,0,.749,3.653,5.3,5.3,0,0,0,4.439,0,17.085,17.085,0,0,0,3.945-3.014c.566.475,1.151.95,1.7,1.443a11.826,11.826,0,0,1,1.059,1.023l1.041,1.041c.621.694,1.279,1.406,1.827,2.1l1.206,1.406-1.827-1.352c-1.662-.913-5.48-1.717-6.978-.274a2.521,2.521,0,0,0,.183,3.763,5.242,5.242,0,0,0,4.366.712,17.594,17.594,0,0,0,4.585-2.539A26.2,26.2,0,0,0,211.6,445.957Z",
    transform: "translate(-62.739 -363.548)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M185.249,445.957c-.84,1.023-1.589,1.991-2.265,2.886h-1.717c.858-1.1,1.827-2.356,3-3.653.658-.785,1.388-1.626,2.119-2.466a27.206,27.206,0,0,1-1.827-2.594,19.179,19.179,0,0,1-5.041.347c-.128,1-.219,1.973-.311,2.9-.2,2.082-.311,3.945-.4,5.48h-1.37c.11-1.589.274-3.489.511-5.626.11-1.023.256-2.119.42-3.233a16.82,16.82,0,0,1-4.767-2.155,5.279,5.279,0,0,1-2.046-3.927,2.539,2.539,0,0,1,2.9-2.393c2.1.384,3.653,3.872,3.945,5.772v2.1a9.187,9.187,0,0,1,.2-1.37c.146-.913.311-1.827.475-2.831.11-.475.219-.95.311-1.443s.256-.968.384-1.461c.311-1.151.694-2.3,1.1-3.434a16.807,16.807,0,0,1-4.877-1.388,5.225,5.225,0,0,1-2.612-3.653,2.5,2.5,0,0,1,2.5-2.795c2.119,0,4.238,3.27,4.767,5.1,0,.11.274,1.461.384,2.21.256-.694.493-1.37.767-2.064.785-1.973,1.644-3.945,2.5-5.936l.767-1.827a17.482,17.482,0,0,1-5.06-1.407,5.3,5.3,0,0,1-2.612-3.653,2.521,2.521,0,0,1,2.5-2.795c2.137,0,4.238,3.27,4.767,5.1,0,.146.384,2.082.438,2.594.566-1.333,1.114-2.667,1.589-4.019a42.95,42.95,0,0,0,1.644-5.48,17.806,17.806,0,0,1-5-1.242,5.279,5.279,0,0,1-2.612-3.653,2.521,2.521,0,0,1,2.5-2.795c2.137,0,4.238,3.27,4.786,5.1,0,.128.292,1.607.4,2.32h.11a32.189,32.189,0,0,0,.621-5.772v-3.069a16.885,16.885,0,0,1-5.1-.84,5.279,5.279,0,0,1-3-3.288,2.521,2.521,0,0,1,2.174-3.05c2.137-.183,4.585,2.795,5.315,4.548,0,.091.329,1.114.548,1.827a6.553,6.553,0,0,0-.091-1.333c-.146-1.607-.365-3.069-.566-4.366-.128-.731-.256-1.388-.384-2.009a16.641,16.641,0,0,1-4.092-3.087,5.243,5.243,0,0,1-1.151-4.274,2.521,2.521,0,0,1,3.343-1.717c1.973.822,2.776,4.585,2.612,6.484,0,.164-.511,2.7-.548,2.685h0c.128.6.256,1.242.384,1.936.237,1.3.493,2.758.676,4.366a46.39,46.39,0,0,1,.292,5.224,32.456,32.456,0,0,1-.493,5.827h0c.292-.548,1.169-2.064,1.242-2.174,1.114-1.534,4.2-3.836,6.229-3.178a2.539,2.539,0,0,1,1.406,3.489,5.352,5.352,0,0,1-3.653,2.484,17.515,17.515,0,0,1-5.242-.384,42.488,42.488,0,0,1-1.553,5.736c-.365,1.114-.785,2.192-1.206,3.288l.548-.932c1.132-1.553,4.2-3.854,6.229-3.178a2.5,2.5,0,0,1,1.406,3.471,5.242,5.242,0,0,1-3.653,2.484,16.785,16.785,0,0,1-5.1-.347l-.493,1.242c-.822,2.009-1.626,4-2.356,5.973-.274.694-.493,1.388-.731,2.082l.475-.822c1.133-1.534,4.2-3.836,6.229-3.16a2.521,2.521,0,0,1,1.406,3.471,5.3,5.3,0,0,1-3.653,2.484,16.44,16.44,0,0,1-4.95-.329c-.219.712-.438,1.443-.621,2.137s-.237.95-.329,1.443l-.274,1.443c-.146.932-.292,1.827-.42,2.795-.091.621-.146,1.224-.219,1.827.237-.694.767-2.046.822-2.155a9.919,9.919,0,0,1,3.452-3.544,2.563,2.563,0,0,1,.292-.475,2.521,2.521,0,0,1,3.653-.383c1.553,1.479.95,5.279.128,6.978,0,.11-.712,1.151-1.133,1.827l.913-1.023,1.973-2.1,1.059-1.023c.347-.365.749-.676,1.133-1.023.9-.785,1.827-1.534,2.795-2.265a16.715,16.715,0,0,1-3.306-3.854,5.279,5.279,0,0,1-.2-4.42,2.5,2.5,0,0,1,3.653-.95c1.735,1.224,1.735,5.06,1.169,6.886,0,.11-.585,1.37-.9,2.046l1.827-1.279c1.735-1.224,3.544-2.393,5.352-3.653l1.644-1.1a17.187,17.187,0,0,1-3.434-3.964,5.26,5.26,0,0,1-.219-4.439,2.539,2.539,0,0,1,3.653-.95c1.827,1.224,1.735,5.078,1.169,6.886a24.726,24.726,0,0,1-1.059,2.411c1.206-.8,2.393-1.626,3.544-2.466a46.537,46.537,0,0,0,4.42-3.653,17.775,17.775,0,0,1-3.47-4,5.279,5.279,0,0,1-.2-4.42,2.5,2.5,0,0,1,3.653-.95c1.735,1.224,1.735,5.06,1.169,6.886,0,.11-.639,1.5-.95,2.137h.11a32.879,32.879,0,0,0,3.653-4.457c.6-.877,1.151-1.735,1.662-2.594a16.714,16.714,0,0,1-3.781-3.525,5.279,5.279,0,0,1-.694-4.384,2.521,2.521,0,0,1,3.507-1.333c1.827,1.023,2.283,4.841,1.918,6.7,0,.11-.329,1.114-.566,1.827.219-.4.457-.785.658-1.169.767-1.425,1.388-2.758,1.936-3.945.311-.694.566-1.315.8-1.827a16.658,16.658,0,0,1-1.827-4.822,5.315,5.315,0,0,1,1.425-4.219,2.521,2.521,0,0,1,3.653.42c1.187,1.827-.219,5.352-1.388,6.85-.11.128-1.936,1.973-1.954,1.936h0c-.219.566-.457,1.169-.731,1.827-.511,1.206-1.114,2.557-1.827,4a45.64,45.64,0,0,1-2.612,4.512,31.984,31.984,0,0,1-3.653,4.585h0l2.247-1.133c1.827-.658,5.608-.9,6.923.785a2.5,2.5,0,0,1-.731,3.653,5.241,5.241,0,0,1-4.439,0,17.932,17.932,0,0,1-4.165-3.215,42.48,42.48,0,0,1-4.475,3.927c-.913.712-1.827,1.406-2.813,2.082l.986-.493c1.827-.658,5.626-.877,6.941.785a2.539,2.539,0,0,1-.749,3.653,5.3,5.3,0,0,1-4.439,0,17.131,17.131,0,0,1-4.055-3.105l-1.1.767c-1.827,1.224-3.562,2.429-5.261,3.653-.6.438-1.187.9-1.827,1.352l.84-.42c1.827-.658,5.626-.9,6.941.785a2.521,2.521,0,0,1-.749,3.653,5.3,5.3,0,0,1-4.439,0,17.085,17.085,0,0,1-3.945-3.014c-.566.475-1.151.95-1.7,1.443a11.826,11.826,0,0,0-1.059,1.023l-1.041,1.041c-.621.694-1.279,1.406-1.827,2.1l-1.206,1.406,1.827-1.352c1.662-.913,5.48-1.717,6.978-.274a2.521,2.521,0,0,1-.183,3.763,5.242,5.242,0,0,1-4.366.712,17.594,17.594,0,0,1-4.585-2.539A26.2,26.2,0,0,1,185.249,445.957Z",
    transform: "translate(659.68 -366.548)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M176.949,408.563a13.954,13.954,0,0,1-3.653-1.735s1.5-1.26,1.607-1.333c1.224-.767,4.037-1.571,5.279-.53a1.826,1.826,0,0,1,0,2.849A3.963,3.963,0,0,1,176.949,408.563Z",
    transform: "translate(-3.886 -344.949)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M184.67,402.657s.566-1.827.6-1.991c.6-1.315,2.5-3.544,4.11-3.361a1.918,1.918,0,0,1,1.626,2.356,4,4,0,0,1-2.338,2.429A13.623,13.623,0,0,1,184.67,402.657Z",
    transform: "translate(-34.859 -350.879)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M332.215,405.7a18.975,18.975,0,0,1-4.9-2.338s2.009-1.7,2.155-1.827c1.644-1.059,5.48-2.119,7.105-.731a2.557,2.557,0,0,1,0,3.836,5.369,5.369,0,0,1-4.366,1.059Z",
    transform: "translate(62.83 -348.53)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M313.33,397.73s.749-2.521.822-2.685c.785-1.827,3.361-4.749,5.48-4.53a2.575,2.575,0,0,1,2.174,3.178,5.37,5.37,0,0,1-3.142,3.288,18.269,18.269,0,0,1-5.334.749Z",
    transform: "translate(8.266 -369.77)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M316.979,443.3c-.731.932-1.425,1.827-2.028,2.594h-1.534c.767-.986,1.68-2.1,2.685-3.324.6-.694,1.242-1.443,1.918-2.192a24.159,24.159,0,0,1-1.7-2.356,16.865,16.865,0,0,1-4.548.329c-.091.895-.2,1.827-.274,2.612-.164,1.827-.274,3.544-.347,4.932h-1.242c.091-1.425.237-3.123.475-5.06a22.254,22.254,0,0,1,.365-2.886,15.582,15.582,0,0,1-4.274-1.936,4.712,4.712,0,0,1-1.827-3.544,2.283,2.283,0,0,1,2.612-2.155c1.827.347,3.324,3.489,3.544,5.188v1.827a9.425,9.425,0,0,1,.183-1.224c.128-.84.274-1.662.438-2.557l.274-1.3c.091-.42.237-.877.347-1.315.292-1.041.621-2.064.986-3.087a14.778,14.778,0,0,1-4.384-1.242,4.731,4.731,0,0,1-2.356-3.233,2.283,2.283,0,0,1,2.247-2.521c1.827,0,3.818,2.941,4.292,4.585,0,.11.256,1.333.347,1.991.219-.6.438-1.224.694-1.827.712-1.827,1.48-3.562,2.247-5.334.237-.548.457-1.1.676-1.626a15.548,15.548,0,0,1-4.53-1.279,4.731,4.731,0,0,1-2.356-3.215,2.265,2.265,0,0,1,2.247-2.521c1.918,0,3.818,2.941,4.292,4.585,0,.128.347,1.827.4,2.32.493-1.206.986-2.393,1.425-3.653a40.3,40.3,0,0,0,1.48-4.968,15.927,15.927,0,0,1-4.585-1.279,4.749,4.749,0,0,1-2.356-3.215,2.283,2.283,0,0,1,2.265-2.521c1.918,0,3.8,2.941,4.293,4.585,0,.11.256,1.443.347,2.082h.183a28.862,28.862,0,0,0,.566-5.188v-2.758a14.817,14.817,0,0,1-4.567-.767,4.658,4.658,0,0,1-2.685-2.941,2.246,2.246,0,0,1,1.954-2.74c1.827-.164,4.11,2.5,4.767,4.073,0,.091.311,1,.493,1.681v-1.206c-.128-1.443-.329-2.758-.511-3.927-.11-.658-.237-1.26-.347-1.827a14.939,14.939,0,0,1-3.653-2.776,4.713,4.713,0,0,1-1.023-3.854,2.265,2.265,0,0,1,3-1.534c1.827.749,2.5,4.128,2.356,5.827,0,.146-.475,2.429-.493,2.411h0c.11.53.237,1.114.347,1.735.219,1.169.457,2.484.6,3.927a37.546,37.546,0,0,1,.274,4.694,30.71,30.71,0,0,1-.438,5.224h0c.256-.493,1.041-1.827,1.114-1.954,1-1.388,3.763-3.471,5.589-2.868a2.265,2.265,0,0,1,1.26,3.142,4.785,4.785,0,0,1-3.306,2.229,15.525,15.525,0,0,1-4.712-.347,39.584,39.584,0,0,1-1.407,5.169c-.329.986-.694,1.973-1.078,2.941l.493-.84c1.023-1.388,3.781-3.452,5.608-2.849a2.283,2.283,0,0,1,1.26,3.123,4.713,4.713,0,0,1-3.306,2.228,15.363,15.363,0,0,1-4.585-.311l-.438,1.114c-.731,1.827-1.461,3.653-2.119,5.37-.237.621-.457,1.242-.658,1.827.219-.384.4-.694.42-.749,1.023-1.37,3.781-3.452,5.608-2.849a2.265,2.265,0,0,1,1.26,3.124,4.749,4.749,0,0,1-3.306,2.247,14.373,14.373,0,0,1-4.457-.31c-.2.658-.384,1.3-.548,1.936s-.219.84-.311,1.3l-.237,1.3c-.128.822-.274,1.681-.384,2.5s-.128,1.114-.2,1.644c.219-.621.694-1.827.749-1.936a8.641,8.641,0,0,1,3.087-3.178,2.083,2.083,0,0,1,.274-.42,2.265,2.265,0,0,1,3.361-.365c1.388,1.333.84,4.749.091,6.283a17.628,17.628,0,0,1-1,1.607c.274-.31.548-.6.822-.932a24.609,24.609,0,0,1,1.827-1.827l.95-.913c.311-.329.676-.621,1.023-.932q1.206-1.041,2.521-2.027a14.759,14.759,0,0,1-2.977-3.452,4.749,4.749,0,0,1-.183-3.982,2.247,2.247,0,0,1,3.27-.859c1.571,1.1,1.553,4.548,1.041,6.192,0,.091-.511,1.224-.8,1.827.53-.384,1.041-.785,1.589-1.169,1.571-1.078,3.2-2.137,4.822-3.2l1.48-.986a16.129,16.129,0,0,1-3.105-3.653,4.75,4.75,0,0,1-.183-3.982,2.283,2.283,0,0,1,3.27-.858c1.571,1.114,1.553,4.566,1.059,6.192a17.872,17.872,0,0,1-.95,2.155c1.078-.712,2.155-1.443,3.178-2.21a39.354,39.354,0,0,0,3.964-3.325,16.143,16.143,0,0,1-3.105-3.653,4.621,4.621,0,0,1-.183-3.982,2.265,2.265,0,0,1,3.251-.859c1.571,1.114,1.553,4.567,1.059,6.192,0,.11-.584,1.352-.859,1.936h.091a28.915,28.915,0,0,0,3.324-4.019c.548-.785,1.041-1.571,1.5-2.338a14.611,14.611,0,0,1-3.4-3.16,4.694,4.694,0,0,1-.621-3.927,2.265,2.265,0,0,1,3.142-1.224c1.68.932,2.046,4.366,1.735,6.046,0,0-.31,1-.511,1.662l.585-1.041c.694-1.279,1.26-2.484,1.826-3.562.274-.6.493-1.169.712-1.7a14.742,14.742,0,0,1-1.553-4.347,4.676,4.676,0,0,1,1.279-3.781,2.265,2.265,0,0,1,3.343.384c1.078,1.589-.183,4.8-1.242,6.156-.091.11-1.827,1.827-1.827,1.735h0l-.658,1.644c-.457,1.078-1,2.3-1.662,3.653a42.159,42.159,0,0,1-2.375,4.055,29.222,29.222,0,0,1-3.251,4.128h0c.493-.274,1.827-.986,2.009-1.023,1.607-.6,5.06-.8,6.247.694a2.265,2.265,0,0,1-.676,3.306,4.732,4.732,0,0,1-3.982,0,15.965,15.965,0,0,1-3.653-2.9A39.771,39.771,0,0,1,337.8,425.4c-.822.639-1.68,1.26-2.539,1.827l.9-.438c1.589-.584,5.041-.785,6.229.712a2.247,2.247,0,0,1-.676,3.306,4.676,4.676,0,0,1-3.982,0,15.1,15.1,0,0,1-3.653-2.795c-.329.237-.658.475-1,.694-1.589,1.1-3.178,2.192-4.713,3.306-.548.384-1.059.8-1.589,1.206l.767-.384c1.607-.585,5.06-.785,6.247.712a2.283,2.283,0,0,1-1.1,3.891,4.713,4.713,0,0,1-4,0,14.339,14.339,0,0,1-3.544-2.7c-.512.438-1.041.858-1.516,1.3s-.658.585-.968.913l-.932.95-1.7,1.827c-.365.438-.712.859-1.078,1.26.53-.383,1.589-1.151,1.7-1.206,1.5-.822,4.877-1.553,6.265-.237a2.247,2.247,0,0,1-.164,3.361,4.731,4.731,0,0,1-3.927.658,15.437,15.437,0,0,1-4.11-2.283C318.075,441.965,317.509,442.641,316.979,443.3Z",
    transform: "translate(1.091 -373.783)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M238.435,408.148a15.2,15.2,0,0,1-3.945-1.827s1.626-1.37,1.735-1.443c1.333-.84,4.384-1.717,5.736-.585a2.064,2.064,0,0,1,0,3.087,4.365,4.365,0,0,1-3.525.767Z",
    transform: "translate(-13.903 -345.539)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M223.17,401.771s.6-2.046.658-2.174c.639-1.425,2.7-3.836,4.457-3.653a2.082,2.082,0,0,1,1.827,2.557,4.311,4.311,0,0,1-2.521,2.649A14.612,14.612,0,0,1,223.17,401.771Z",
    transform: "translate(-23.26 -352.003)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M226.14,438.565l-1.626,2.1H223.2c.621-.785,1.352-1.7,2.174-2.667.475-.585.986-1.187,1.534-1.827a18.522,18.522,0,0,1-1.37-1.827,14.321,14.321,0,0,1-3.653.256,19.461,19.461,0,0,1-.219,2.1c-.128,1.516-.219,2.849-.274,3.982h-1c0-1.151.2-2.521.365-4.073.091-.749.2-1.534.31-2.338a12.126,12.126,0,0,1-3.452-1.571,3.8,3.8,0,0,1-1.48-2.849,1.827,1.827,0,0,1,2.1-1.735c1.516.274,2.685,2.813,2.868,4.183v1.534a2.32,2.32,0,0,1,.146-.986c.091-.676.219-1.352.347-2.064l.219-1.041a4.917,4.917,0,0,1,.274-1.078c.237-.822.511-1.662.8-2.484a11.688,11.688,0,0,1-3.544-1,3.8,3.8,0,0,1-1.827-2.612,1.827,1.827,0,0,1,1.827-2.028c1.553,0,3.087,2.375,3.471,3.653,0,0,.2,1.059.274,1.607.183-.493.365-1,.566-1.5.566-1.425,1.187-2.868,1.827-4.311l.548-1.315a12.167,12.167,0,0,1-3.653-1.023,3.8,3.8,0,0,1-1.827-2.594,1.826,1.826,0,0,1,1.827-2.027c1.553,0,3.069,2.375,3.471,3.653,0,.11.274,1.516.311,1.827.4-.968.8-1.936,1.151-2.9a31.224,31.224,0,0,0,1.187-4.018,13.282,13.282,0,0,1-3.653-1.023,3.909,3.909,0,0,1-1.827-2.612,1.827,1.827,0,0,1,1.827-2.027c1.534,0,3.069,2.375,3.452,3.653,0,.091.219,1.169.292,1.68h0a22.517,22.517,0,0,0,.457-4.183c0-.767,0-1.516,0-2.229a11.836,11.836,0,0,1-3.653-.621,3.781,3.781,0,0,1-2.174-2.375,1.827,1.827,0,0,1,1.571-2.21c1.553-.128,3.324,2.028,3.854,3.288,0,0,.256.8.4,1.352v-.968c-.091-1.169-.256-2.228-.4-3.16-.091-.548-.183-1.023-.274-1.461a12.217,12.217,0,0,1-2.977-2.247,3.872,3.872,0,0,1-.84-3.105,1.827,1.827,0,0,1,2.429-1.242c1.425.6,2.009,3.324,1.827,4.694,0,.128-.384,1.973-.4,1.954h0c.11.438.2.895.292,1.406a31.579,31.579,0,0,1,.475,3.16,30.574,30.574,0,0,1,.219,3.781,22.852,22.852,0,0,1-.347,4.238h0c.219-.4.84-1.5.9-1.571.822-1.114,3.05-2.795,4.512-2.3a1.827,1.827,0,0,1,1.023,2.521,3.818,3.818,0,0,1-2.667,1.826,12.987,12.987,0,0,1-3.8-.292,33.117,33.117,0,0,1-1.133,4.183c-.274.785-.566,1.589-.877,2.375l.4-.676c.822-1.114,3.05-2.795,4.512-2.3a1.827,1.827,0,0,1,1.023,2.521,3.781,3.781,0,0,1-2.667,1.827,12.05,12.05,0,0,1-3.653-.256l-.365.913c-.585,1.443-1.169,2.886-1.7,4.329-.2.493-.365,1-.53,1.516a5.552,5.552,0,0,1,.347-.6c.8-1.114,3.05-2.776,4.512-2.3a1.827,1.827,0,0,1,1.023,2.521,3.854,3.854,0,0,1-2.667,1.827,11.8,11.8,0,0,1-3.653-.237c-.164.511-.31,1.041-.438,1.553s-.183.694-.256,1.041-.128.712-.2,1.059c-.11.657-.219,1.352-.292,2.009s-.128.9-.164,1.333c.183-.493.548-1.48.585-1.553a7.307,7.307,0,0,1,2.5-2.576l.219-.347a1.827,1.827,0,0,1,2.722-.274c1.114,1.059.676,3.818,0,5.06l-.822,1.3.676-.749c.457-.511.913-.986,1.425-1.516l.767-.749c.256-.256.548-.493.822-.749.639-.566,1.333-1.1,2.028-1.626a12.165,12.165,0,0,1-2.393-2.795,3.818,3.818,0,0,1-.146-3.215,1.827,1.827,0,0,1,2.63-.694c1.26.877,1.26,3.653.84,4.987,0,.091-.42,1-.639,1.5l1.279-.932c1.279-.877,2.576-1.735,3.891-2.594l1.187-.785a13.038,13.038,0,0,1-2.5-2.886,3.89,3.89,0,0,1-.146-3.215,1.826,1.826,0,0,1,2.648-.694c1.26.9,1.242,3.653.84,5,0,0-.6,1.407-.767,1.735a24.909,24.909,0,0,0,2.575-1.827,35.459,35.459,0,0,0,3.2-2.685,12.953,12.953,0,0,1-2.521-2.9,3.872,3.872,0,0,1-.146-3.215,1.827,1.827,0,0,1,2.63-.676c1.279.877,1.26,3.653.859,4.987a16.737,16.737,0,0,1-.676,1.553h0a24.064,24.064,0,0,0,2.667-3.233c.457-.639.84-1.26,1.206-1.827a12.255,12.255,0,0,1-2.74-2.557,3.781,3.781,0,0,1-.493-3.178,1.826,1.826,0,0,1,2.539-.968c1.352.749,1.644,3.507,1.388,4.877,0,0-.237.8-.42,1.333.164-.274.347-.566.493-.84.548-1.023,1-2.009,1.406-2.868.219-.493.4-.95.566-1.37a12.165,12.165,0,0,1-1.242-3.507,3.781,3.781,0,0,1,1.023-3.05,1.827,1.827,0,0,1,2.7.292c.858,1.3-.146,3.891-1,4.968a14.715,14.715,0,0,1-1.425,1.407h0c-.164.42-.329.858-.53,1.333-.384.877-.8,1.827-1.352,2.9a37.438,37.438,0,0,1-1.827,3.288,25.571,25.571,0,0,1-2.63,3.324h0c.384-.219,1.516-.8,1.607-.822,1.3-.493,4.092-.657,5.041.566a1.827,1.827,0,0,1-.548,2.667,3.872,3.872,0,0,1-3.215,0,12.9,12.9,0,0,1-3.014-2.338,30.762,30.762,0,0,1-3.251,2.85c-.658.511-1.352,1.023-2.046,1.516l.712-.365c1.3-.475,4.092-.639,5.041.585a1.827,1.827,0,0,1-.548,2.667,3.872,3.872,0,0,1-3.215,0,12.353,12.353,0,0,1-3.05-1.936l-.8.566c-1.279.877-2.576,1.827-3.8,2.667-.438.311-.859.639-1.279.968l.621-.31c1.279-.475,4.073-.639,5.023.566a1.826,1.826,0,0,1-.53,2.685,3.854,3.854,0,0,1-3.233,0,11.342,11.342,0,0,1-2.85-2.174l-1.242,1.041c-.256.256-.53.475-.767.749l-.749.749c-.457.511-.932,1.023-1.37,1.534s-.585.676-.877,1c.438-.311,1.279-.932,1.37-.968,1.206-.676,3.927-1.26,5.06-.2a1.827,1.827,0,0,1-.128,2.722,3.818,3.818,0,0,1-3.178.512,12.366,12.366,0,0,1-3.324-1.827Z",
    transform: "translate(-29.079 -355.278)",
    fill: "#eceff1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-122-2",
    "data-name": "freepik--Plants--inject-122",
    transform: "translate(-583.224 439.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027-2",
    "data-name": "Path 2027",
    d: "M240.8,404.344a19.433,19.433,0,0,1-5.151-2.466s2.119-1.827,2.265-1.827c1.735-1.1,5.717-2.229,7.489-.767a2.722,2.722,0,0,1,0,4.055A5.7,5.7,0,0,1,240.8,404.344Z",
    transform: "translate(311.516 -359.811)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028-2",
    "data-name": "Path 2028",
    d: "M251.748,397.431s.956-3.17,1.021-3.344c1-2.172,4.213-5.972,6.927-5.667a3.214,3.214,0,0,1,2.714,3.952,6.775,6.775,0,0,1-3.93,4.126,22.979,22.979,0,0,1-6.732.934Z",
    transform: "translate(256.967 -367.09)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029-2",
    "data-name": "Path 2029",
    d: "M283.165,455.886q1.412,1.715,2.541,3.257h1.933c-.977-1.238-2.172-2.649-3.366-4.169-.738-.89-1.563-1.824-2.389-2.758a29.819,29.819,0,0,0,2.171-2.932,21.107,21.107,0,0,0,5.667.391c.13,1.129.261,2.171.348,3.257.217,2.367.347,4.451.456,6.21h1.542c-.109-1.8-.3-3.93-.586-6.341-.13-1.151-.282-2.367-.456-3.626a19.544,19.544,0,0,0,5.363-2.432,5.929,5.929,0,0,0,2.28-4.343,2.845,2.845,0,0,0-3.257-2.693c-2.367.434-4.147,4.343-4.451,6.514v2.367a9.494,9.494,0,0,0-.217-1.52c-.174-1.042-.347-2.171-.543-3.192-.13-.543-.239-1.086-.369-1.628s-.282-1.108-.413-1.65c-.347-1.3-.782-2.584-1.238-3.865a19.047,19.047,0,0,0,5.494-1.563,5.951,5.951,0,0,0,2.953-4.039,2.866,2.866,0,0,0-2.823-3.149c-2.41,0-4.777,3.692-5.385,5.733,0,.13-.3,1.672-.434,2.5-.261-.76-.543-1.542-.847-2.3-.89-2.172-1.867-4.451-2.823-6.688l-.847-2.041a19.542,19.542,0,0,0,5.689-1.585,5.928,5.928,0,0,0,2.931-4.039,2.845,2.845,0,0,0-2.823-3.149c-2.389,0-4.756,3.67-5.364,5.733,0,.152-.434,2.345-.5,2.91-.63-1.5-1.238-3-1.781-4.517a48.048,48.048,0,0,1-1.846-6.21,20.092,20.092,0,0,0,5.733-1.585,5.928,5.928,0,0,0,2.932-4.039,2.845,2.845,0,0,0-2.823-3.149c-2.389,0-4.756,3.67-5.364,5.733,0,.13-.326,1.8-.456,2.606h-.13a35.893,35.893,0,0,1-.695-6.514V403.9a18.437,18.437,0,0,0,5.733-.955,5.928,5.928,0,0,0,3.366-3.67,2.845,2.845,0,0,0-2.454-3.453c-2.389-.2-5.146,3.149-5.972,5.125,0,.109-.369,1.238-.608,2.171a7.173,7.173,0,0,1,.108-1.52c.152-1.8.391-3.453.63-4.908.13-.825.282-1.563.413-2.171a18.6,18.6,0,0,0,4.625-3.474,5.993,5.993,0,0,0,1.3-4.821,2.845,2.845,0,0,0-3.778-1.911c-2.172.912-3.127,5.146-2.932,7.274,0,.2.586,3.04.63,3.018h0c-.152.673-.3,1.39-.456,2.171-.261,1.455-.565,3.105-.738,4.908a49.624,49.624,0,0,0-.347,5.885,36.5,36.5,0,0,0,.565,6.514h0c-.326-.608-1.3-2.323-1.39-2.454-1.259-1.716-4.712-4.343-6.992-3.561a2.823,2.823,0,0,0-1.585,3.909,6.015,6.015,0,0,0,4.126,2.8,19.548,19.548,0,0,0,5.906-.434,48.6,48.6,0,0,0,1.759,6.514c.413,1.238.869,2.454,1.346,3.691l-.608-1.064c-1.259-1.715-4.734-4.343-7.014-3.561a2.845,2.845,0,0,0-1.585,3.909,5.993,5.993,0,0,0,4.148,2.8,18.54,18.54,0,0,0,5.733-.413c.174.478.369.934.565,1.411.89,2.171,1.824,4.495,2.649,6.71.282.782.543,1.564.8,2.345l-.521-.912c-1.281-1.737-4.734-4.343-7.014-3.583a2.867,2.867,0,0,0-1.585,3.93,5.993,5.993,0,0,0,4.147,2.8,18.238,18.238,0,0,0,5.581-.391c.239.825.478,1.629.673,2.41s.282,1.064.391,1.629.217,1.086.3,1.629c.174,1.042.347,2.171.478,3.127s.174,1.39.261,2.171c-.282-.8-.869-2.323-.934-2.432a10.858,10.858,0,0,0-3.887-4,2.6,2.6,0,0,0-.326-.521,2.845,2.845,0,0,0-4.213-.434c-1.737,1.65-1.064,5.928-.13,7.839a23.139,23.139,0,0,0,1.281,2.019l-1.042-1.151-2.171-2.367-1.194-1.151c-.391-.413-.847-.76-1.259-1.151-1.021-.89-2.172-1.715-3.17-2.541a18.677,18.677,0,0,0,3.735-4.343,5.993,5.993,0,0,0,.217-4.994,2.845,2.845,0,0,0-4.082-1.064c-1.954,1.39-1.954,5.711-1.325,7.752,0,.13.673,1.542,1.021,2.323-.652-.5-1.3-.977-2-1.455-1.954-1.368-4-2.693-6.015-4.017l-1.867-1.238a19.69,19.69,0,0,0,3.887-4.473,5.95,5.95,0,0,0,.217-4.973,2.845,2.845,0,0,0-4.082-1.086c-1.954,1.39-1.954,5.711-1.325,7.752l1.194,2.714c-1.346-.912-2.693-1.824-3.974-2.779a52.546,52.546,0,0,1-4.973-4.169,19.545,19.545,0,0,0,3.909-4.5,5.992,5.992,0,0,0,.217-4.994,2.845,2.845,0,0,0-4.082-1.064c-1.976,1.368-1.954,5.711-1.325,7.752,0,.13.717,1.694,1.064,2.41h0a35.157,35.157,0,0,1-4.148-5.038c-.695-.977-1.3-1.954-1.867-2.91a19.087,19.087,0,0,0,4.343-3.952,5.928,5.928,0,0,0,.76-4.929,2.845,2.845,0,0,0-3.93-1.52c-2.172,1.151-2.562,5.45-2.172,7.557,0,.13.369,1.259.651,2.171l-.76-1.3c-.869-1.607-1.563-3.105-2.171-4.451-.347-.76-.63-1.477-.89-2.171a18.846,18.846,0,0,0,1.933-5.429,5.993,5.993,0,0,0-1.585-4.755,2.845,2.845,0,0,0-4.191.478c-1.346,2,.239,6.037,1.563,7.708.109.152,2.172,2.172,2.172,2.172h0c.239.63.5,1.325.8,2.063a46.087,46.087,0,0,0,2.171,4.495,47.028,47.028,0,0,0,2.953,5.1,36.546,36.546,0,0,0,4.082,5.146h0c-.608-.347-2.367-1.238-2.5-1.281-2.019-.738-6.341-1-7.817.89a2.823,2.823,0,0,0,.847,4.126,5.994,5.994,0,0,0,4.994,0,20.019,20.019,0,0,0,4.669-3.626,49.623,49.623,0,0,0,5.038,4.343c1.021.8,2.172,1.563,3.17,2.323l-1.107-.543c-2.019-.738-6.319-1-7.817.89a2.845,2.845,0,0,0,.847,4.148,5.907,5.907,0,0,0,4.994,0,18.522,18.522,0,0,0,4.56-3.5l1.238.868c2,1.368,4,2.736,5.906,4.126.695.5,1.325,1,1.976,1.52l-.955-.478c-2-.738-6.319-1-7.8.89a2.866,2.866,0,0,0,.825,4.148,5.993,5.993,0,0,0,4.994,0,18.7,18.7,0,0,0,4.343-3.387c.651.543,1.3,1.064,1.911,1.628s.825.717,1.216,1.129l1.151,1.194,2.171,2.345,1.346,1.585-2.171-1.5c-1.889-1.042-6.1-1.954-7.861-.3a2.845,2.845,0,0,0,.2,4.213,5.971,5.971,0,0,0,4.929.8,19.308,19.308,0,0,0,5.146-2.845Q282.188,454.648,283.165,455.886Z",
    transform: "translate(228.123 -382.04)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030-2",
    "data-name": "Path 2030",
    d: "M461.229,400.263a26.28,26.28,0,0,0,6.941-3.306s-2.868-2.393-3.069-2.521c-2.32-1.5-7.672-3.014-10.065-1.041a3.653,3.653,0,0,0,0,5.48A7.635,7.635,0,0,0,461.229,400.263Z",
    transform: "translate(-476.34 -366.755)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031-2",
    "data-name": "Path 2031",
    d: "M446.1,389.019s-1.059-3.653-1.151-3.8c-1.114-2.521-4.767-6.74-7.836-6.411a3.653,3.653,0,0,0-3.069,4.493,7.635,7.635,0,0,0,4.439,4.64,26.011,26.011,0,0,0,7.617,1.078Z",
    transform: "translate(-395.455 -366.175)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032-2",
    "data-name": "Path 2032",
    d: "M472.537,453.562c1.059,1.315,2.009,2.557,2.886,3.653H477.6c-1.1-1.406-2.375-3-3.818-4.713-.84-.986-1.827-2.046-2.7-3.123a34.967,34.967,0,0,0,2.411-3.306,23.407,23.407,0,0,0,6.43.438c.146,1.279.274,2.521.383,3.653.238,2.649.4,5,.493,7h1.827c-.146-2.027-.347-4.439-.676-7.16-.146-1.3-.311-2.685-.511-4.11a21.917,21.917,0,0,0,6.046-2.74,6.7,6.7,0,0,0,2.612-5.023,3.215,3.215,0,0,0-3.653-3.032c-2.685.475-4.713,4.932-5.041,7.306v2.685a11.363,11.363,0,0,0-.256-1.735c-.183-1.187-.384-2.356-.621-3.653l-.384-1.827c-.128-.621-.329-1.26-.493-1.827-.4-1.461-.877-2.923-1.388-4.366a21.064,21.064,0,0,0,6.21-1.827,6.7,6.7,0,0,0,3.342-4.567,3.233,3.233,0,0,0-3.2-3.562c-2.7,0-5.388,4.165-6.083,6.5,0,.146-.347,1.827-.493,2.813-.311-.877-.621-1.827-.968-2.612-1-2.521-2.1-5.041-3.178-7.562-.329-.767-.658-1.534-.968-2.32a22.575,22.575,0,0,0,6.43-1.827,6.685,6.685,0,0,0,3.324-4.567A3.2,3.2,0,0,0,479.5,408.5c-2.722,0-5.48,4.165-6.082,6.484,0,.183-.475,2.667-.566,3.306-.712-1.7-1.406-3.4-2.028-5.114a56.812,56.812,0,0,1-2.064-7.032,22.451,22.451,0,0,0,6.466-1.827,6.649,6.649,0,0,0,3.324-4.548,3.2,3.2,0,0,0-3.178-3.562c-2.722,0-5.48,4.165-6.083,6.484,0,.146-.365,2.046-.511,2.941h-.146a39.859,39.859,0,0,1-.785-7.306V394.4a20.714,20.714,0,0,0,6.484-1.078,6.7,6.7,0,0,0,3.8-4.165,3.215,3.215,0,0,0-2.776-3.891c-2.7-.219-5.809,3.544-6.74,5.79,0,.128-.438,1.406-.694,2.356a8.756,8.756,0,0,1,.11-1.7c.164-2.046.457-3.909.712-5.48.164-.932.311-1.827.475-2.576a20.787,20.787,0,0,0,5.224-3.909,6.668,6.668,0,0,0,1.461-5.48,3.215,3.215,0,0,0-4.256-2.174c-2.5,1.041-3.525,5.827-3.324,8.238,0,.219.658,3.452.712,3.416h0c-.164.749-.329,1.553-.493,2.448-.311,1.644-.639,3.507-.84,5.48a50.71,50.71,0,0,0-.384,6.649,40.183,40.183,0,0,0,.621,7.416v.091c-.365-.694-1.479-2.63-1.571-2.776-1.425-1.954-5.352-4.9-7.927-4.037a3.233,3.233,0,0,0-1.827,4.439,6.813,6.813,0,0,0,4.676,3.16,23.106,23.106,0,0,0,6.685-.493,57.854,57.854,0,0,0,1.973,7.307c.475,1.406,1,2.795,1.534,4.183-.329-.6-.639-1.132-.694-1.206-1.425-1.954-5.352-4.877-7.927-4.037a3.233,3.233,0,0,0-1.827,4.439,6.7,6.7,0,0,0,4.676,3.16,21.33,21.33,0,0,0,6.484-.457l.731,1.9c1.023,2.539,2.064,5.078,3,7.6.329.877.639,1.827.932,2.649l-.6-1.041c-1.443-1.954-5.352-4.9-7.927-4.037a3.215,3.215,0,0,0-1.827,4.439,6.758,6.758,0,0,0,4.6,3.178,20.841,20.841,0,0,0,6.3-.42c.292.913.566,1.827.785,2.722.146.621.329,1.206.438,1.826s.237,1.242.347,1.827c.183,1.187.384,2.393.53,3.544.11.8.2,1.571.292,2.338-.311-.877-.986-2.594-1.059-2.74a12.365,12.365,0,0,0-4.384-4.512,5.463,5.463,0,0,0-.384-.6,3.215,3.215,0,0,0-4.749-.493c-1.954,1.827-1.206,6.7-.146,8.9a25.344,25.344,0,0,0,1.443,2.265c-.4-.438-.767-.858-1.187-1.3-.785-.9-1.607-1.827-2.5-2.667l-1.333-1.315c-.438-.457-.968-.877-1.443-1.315-1.133-.986-2.338-1.936-3.562-2.868a21.057,21.057,0,0,0,4.2-4.9,6.721,6.721,0,0,0,.256-5.644,3.2,3.2,0,0,0-4.621-1.206c-2.229,1.553-2.21,6.448-1.479,8.768,0,.128.731,1.735,1.132,2.612-.749-.548-1.48-1.114-2.247-1.644-2.228-1.553-4.53-3.05-6.831-4.548l-2.082-1.388a22.8,22.8,0,0,0,4.384-5.06,6.776,6.776,0,0,0,.256-5.644,3.215,3.215,0,0,0-4.621-1.206c-2.228,1.553-2.21,6.448-1.5,8.768a32.828,32.828,0,0,0,1.352,3.05c-1.534-1.023-3.051-2.046-4.512-3.142a54.627,54.627,0,0,1-5.608-4.713,22.451,22.451,0,0,0,4.4-5.078,6.721,6.721,0,0,0,.256-5.644,3.2,3.2,0,0,0-4.621-1.206c-2.228,1.553-2.21,6.448-1.479,8.768,0,.146.8,1.827,1.187,2.74l-.128.091a43.108,43.108,0,0,1-4.694-5.7c-.786-1.1-1.461-2.21-2.119-3.288a21.921,21.921,0,0,0,4.822-4.475,6.758,6.758,0,0,0,.877-5.589,3.2,3.2,0,0,0-4.457-1.7c-2.393,1.3-2.9,6.156-2.448,8.548,0,.128.42,1.406.712,2.338l-.84-1.479c-.986-1.827-1.827-3.507-2.466-5.023-.384-.877-.712-1.662-1-2.411a21.715,21.715,0,0,0,2.192-6.156,6.776,6.776,0,0,0-1.827-5.352,3.215,3.215,0,0,0-4.749.548c-1.516,2.247.256,6.795,1.826,8.713.128.164,2.448,2.5,2.466,2.448h0c.274.731.566,1.5.913,2.338.658,1.534,1.425,3.27,2.375,5.1a60.831,60.831,0,0,0,3.343,5.754,41.794,41.794,0,0,0,4.621,5.845h0c-.694-.384-2.685-1.388-2.831-1.443-2.283-.84-7.16-1.132-8.841,1a3.2,3.2,0,0,0,.95,4.676,6.7,6.7,0,0,0,5.644,0,22.212,22.212,0,0,0,5.3-4.092,56.094,56.094,0,0,0,5.7,5,42.513,42.513,0,0,0,3.653,2.649l-1.242-.621c-2.283-.84-7.16-1.133-8.841,1a3.2,3.2,0,0,0,.95,4.676,6.63,6.63,0,0,0,5.644,0,21.41,21.41,0,0,0,5.151-3.946l1.406.968c2.265,1.553,4.53,3.105,6.7,4.676.767.566,1.5,1.133,2.228,1.717l-1.078-.53c-2.265-.84-7.16-1.133-8.841.986a3.233,3.233,0,0,0,.95,4.694,6.74,6.74,0,0,0,5.662,0,20.862,20.862,0,0,0,5.023-3.836c.731.621,1.461,1.224,2.155,1.827a14.148,14.148,0,0,1,1.37,1.3l1.315,1.333c.785.877,1.626,1.827,2.393,2.667l1.534,1.827c-.767-.566-2.265-1.626-2.393-1.7-2.119-1.187-6.9-2.21-8.9-.365a3.233,3.233,0,0,0,.237,4.786,6.722,6.722,0,0,0,5.571.913,22.708,22.708,0,0,0,5.882-3.16C471,451.681,471.806,452.649,472.537,453.562Z",
    transform: "translate(-451.605 -383.76)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033-2",
    "data-name": "Path 2033",
    d: "M328.257,403.855a21.608,21.608,0,0,0,5.608-2.667s-2.32-1.936-2.466-2.046c-1.827-1.206-6.21-2.429-8.128-.84a2.941,2.941,0,0,0,0,4.384,6.174,6.174,0,0,0,4.987,1.169Z",
    transform: "translate(8.462 -350.671)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034-2",
    "data-name": "Path 2034",
    d: "M316.089,394.737s-.858-2.886-.932-3.069c-.913-2.027-3.854-5.48-6.32-5.169a2.941,2.941,0,0,0-2.484,3.653,6.228,6.228,0,0,0,3.653,3.763A21.512,21.512,0,0,0,316.089,394.737Z",
    transform: "translate(66.444 -359.819)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M330.729,436.37c.723.892,1.369,1.739,1.954,2.508h1.538c-.738-.954-1.538-2.031-2.585-3.2-.569-.677-1.2-1.4-1.846-2.123a22.917,22.917,0,0,0,1.646-2.262,15.38,15.38,0,0,0,4.369.308c.092.877.185,1.723.262,2.523.169,1.8.262,3.4.339,4.754h1.2c-.092-1.385-.246-3.077-.461-4.877-.092-.877-.215-1.815-.354-2.785a15.383,15.383,0,0,0,4.123-1.862,4.615,4.615,0,0,0,1.769-3.415,2.2,2.2,0,0,0-2.508-2.062c-1.815.339-3.2,3.354-3.415,4.985v1.831a8.139,8.139,0,0,0-.169-1.185c-.123-.8-.277-1.539-.431-2.446a6,6,0,0,0-.262-1.246c-.092-.415-.215-.846-.323-1.277-.277-.985-.6-1.985-.954-2.969a14.613,14.613,0,0,0,4.231-1.2,4.615,4.615,0,0,0,2.262-3.077,2.2,2.2,0,0,0-2.169-2.415c-1.846,0-3.662,2.831-4.139,4.415,0,.092-.231,1.262-.323,1.908-.215-.585-.431-1.185-.662-1.769-.692-1.723-1.431-3.431-2.169-5.139l-.662-1.538a15.591,15.591,0,0,0,4.385-1.231,4.616,4.616,0,0,0,2.262-3.077,2.2,2.2,0,0,0-2.169-2.431c-1.846,0-3.677,2.831-4.139,4.415,0,.123-.323,1.8-.369,2.231-.492-1.154-.969-2.308-1.385-3.462a38.291,38.291,0,0,1-1.415-4.785,15.265,15.265,0,0,0,4.4-1.231,4.615,4.615,0,0,0,2.262-3.077,2.169,2.169,0,0,0-2.169-2.415c-1.831,0-3.662,2.831-4.123,4.4,0,.108-.262,1.385-.354,2h-.092a27.247,27.247,0,0,1-.539-4.985v-2.662a15.086,15.086,0,0,0,4.4-.738,4.615,4.615,0,0,0,2.585-2.831,2.185,2.185,0,0,0-1.892-2.646c-1.831-.154-3.954,2.415-4.616,3.923,0,.092-.292.969-.477,1.615v-1.154c.123-1.4.308-2.662.492-3.785.108-.631.215-1.2.323-1.738a14.2,14.2,0,0,0,3.554-2.677,4.615,4.615,0,0,0,1-3.708,2.2,2.2,0,0,0-2.908-1.539c-1.692.723-2.4,3.969-2.262,5.616,0,.139.462,2.339.492,2.323h0c-.108.523-.231,1.077-.354,1.677-.2,1.108-.415,2.385-.569,3.769a41.222,41.222,0,0,0-.262,4.523,28.917,28.917,0,0,0,.431,5.046h0c-.246-.477-1-1.785-1.077-1.877-.969-1.339-3.631-3.323-5.369-2.754a2.2,2.2,0,0,0-1.231,3.077,4.616,4.616,0,0,0,3.185,2.154,15.386,15.386,0,0,0,4.539-.338,37.9,37.9,0,0,0,1.354,4.969c.323.954.677,1.908,1.031,2.846-.231-.4-.431-.769-.477-.815-.969-1.323-3.631-3.323-5.385-2.754a2.185,2.185,0,0,0-1.215,3.077,4.616,4.616,0,0,0,3.185,2.154,14.937,14.937,0,0,0,4.415-.308l.415,1.077c.708,1.723,1.415,3.446,2.046,5.169.231.6.431,1.2.631,1.8l-.415-.708c-.969-1.323-3.631-3.323-5.385-2.754a2.185,2.185,0,0,0-1.215,3.077,4.615,4.615,0,0,0,3.185,2.154,13.97,13.97,0,0,0,4.277-.292c.2.631.385,1.246.539,1.862s.215.815.292,1.246.154.831.246,1.246c.123.8.246,1.631.354,2.415a11.633,11.633,0,0,0,.2,1.539c-.215-.6-.677-1.769-.723-1.862a8.415,8.415,0,0,0-2.985-3.077,1.54,1.54,0,0,0-.262-.415,2.185,2.185,0,0,0-3.231-.338c-1.323,1.277-.815,4.616-.092,6.046,0,.092.615.985.969,1.539l-.785-.892c-.554-.6-1.108-1.185-1.708-1.8l-.908-.892c-.308-.308-.662-.6-.985-.892a28.691,28.691,0,0,0-2.431-1.954,14.047,14.047,0,0,0,2.862-3.323,4.615,4.615,0,0,0,.185-3.846,2.185,2.185,0,0,0-3.077-.815c-1.539,1.062-1.539,4.385-1.015,5.954,0,.108.508,1.185.769,1.785-.508-.369-1-.754-1.539-1.123-1.539-1.046-3.077-2.062-4.615-3.077l-1.416-.938a15.382,15.382,0,0,0,2.969-3.431,4.615,4.615,0,0,0,.185-3.846,2.185,2.185,0,0,0-3.077-.815c-1.538,1.062-1.538,4.385-1.015,5.954,0,.123.723,1.692.908,2.077-1.031-.692-2.062-1.4-3.077-2.139a38.865,38.865,0,0,1-3.816-3.2,15.383,15.383,0,0,0,3-3.446,4.616,4.616,0,0,0,.123-3.939,2.169,2.169,0,0,0-3.077-.815c-1.539,1.062-1.539,4.385-1.015,5.954,0,.108.554,1.308.815,1.861h0a26.29,26.29,0,0,1-3.2-3.862c-.538-.754-1-1.538-1.431-2.246a14.093,14.093,0,0,0,3.262-3.077,4.616,4.616,0,0,0,.6-3.785,2.185,2.185,0,0,0-3.077-1.169c-1.615.892-1.969,4.2-1.662,5.816,0,.092.292.969.492,1.539-.185-.339-.4-.677-.569-1-.677-1.231-1.215-2.4-1.677-3.431-.262-.585-.492-1.123-.692-1.631a14.567,14.567,0,0,0,1.538-4.185,4.616,4.616,0,0,0-1.215-3.631,2.185,2.185,0,0,0-3.231.354c-1.031,1.539.185,4.616,1.2,5.923.092.123,1.662,1.708,1.692,1.677h0c.185.477.385,1.015.631,1.538.446,1.046.954,2.231,1.538,3.477a39.694,39.694,0,0,0,2.277,3.908,28.155,28.155,0,0,0,3.077,3.969h0c-.477-.261-1.831-.954-1.939-.985-1.538-.569-4.862-.769-6,.677a2.185,2.185,0,0,0,.646,3.185,4.616,4.616,0,0,0,3.831,0,14.835,14.835,0,0,0,3.6-2.785,39.677,39.677,0,0,0,3.877,3.415c.785.615,1.539,1.2,2.431,1.785l-.846-.415c-1.539-.569-4.862-.769-6,.677a2.169,2.169,0,0,0,.646,3.185,4.508,4.508,0,0,0,3.831,0,14.893,14.893,0,0,0,3.508-2.692l.954.662c1.539,1.062,3.077,2.108,4.616,3.185.508.369,1.015.769,1.539,1.154l-.723-.354c-1.539-.569-4.877-.769-6.016.677a2.185,2.185,0,0,0,.646,3.185,4.615,4.615,0,0,0,3.846,0,14.017,14.017,0,0,0,3.415-2.6c.492.415,1,.831,1.462,1.261s.631.554.938.877l.892.908c.539.6,1.108,1.215,1.631,1.815s.692.815,1.031,1.215c-.508-.385-1.538-1.108-1.615-1.169-1.446-.8-4.692-1.539-6.046-.231a2.185,2.185,0,0,0,.154,3.246,4.616,4.616,0,0,0,3.785.615,14.864,14.864,0,0,0,3.969-2.2Z",
    transform: "translate(-180.113 -363.299)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036-2",
    "data-name": "Path 2036",
    d: "M202.576,404.207a20.383,20.383,0,0,0,5.48-2.612s-2.247-1.827-2.411-1.973c-1.827-1.169-6.028-2.356-7.909-.822a2.868,2.868,0,0,0,0,4.274A6.028,6.028,0,0,0,202.576,404.207Z",
    transform: "translate(446.327 -350.237)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037-2",
    "data-name": "Path 2037",
    d: "M190.738,395.365s-.84-2.813-.913-2.977c-.877-1.973-3.653-5.3-6.137-5.041a2.849,2.849,0,0,0-2.411,3.525,5.973,5.973,0,0,0,3.47,3.653A20.245,20.245,0,0,0,190.738,395.365Z",
    transform: "translate(502.521 -359.114)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043-2",
    "data-name": "Path 2043",
    d: "M184.67,402.657s.566-1.827.6-1.991c.6-1.315,2.5-3.544,4.11-3.361a1.918,1.918,0,0,1,1.626,2.356,4,4,0,0,1-2.338,2.429A13.623,13.623,0,0,1,184.67,402.657Z",
    transform: "translate(493.785 -350.879)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M184.4,436.92c-.566.676-1.059,1.333-1.516,1.936h-1.132c.566-.749,1.242-1.571,1.991-2.484.438-.511.913-1.078,1.425-1.644a16.225,16.225,0,0,1-1.279-1.826,11.818,11.818,0,0,1-3.361.237c0,.676-.146,1.315-.2,1.936-.128,1.406-.219,2.649-.274,3.653h-.913a35.939,35.939,0,0,1,.347-3.763,15.13,15.13,0,0,1,.274-2.155,12.07,12.07,0,0,1-3.178-1.443,3.544,3.544,0,0,1-1.37-2.63,1.7,1.7,0,0,1,1.936-1.607c1.407.256,2.466,2.594,2.649,3.854v1.406a5.9,5.9,0,0,1,.146-.913c.055-.329.2-1.224.311-1.827l.219-.968a9.776,9.776,0,0,1,.256-.986c.2-.767.457-1.534.731-2.3a10.957,10.957,0,0,1-3.27-.913,3.526,3.526,0,0,1-1.827-2.393,1.7,1.7,0,0,1,1.68-1.826c1.425,0,2.831,2.192,3.2,3.416,0,0,.183.968.256,1.479.164-.457.329-.913.511-1.37.53-1.333,1.1-2.649,1.662-3.982.183-.4.347-.8.511-1.206a11.948,11.948,0,0,1-3.379-.95,3.544,3.544,0,0,1-1.827-2.393,1.681,1.681,0,0,1,1.68-1.827c1.425,0,2.831,2.174,3.2,3.4,0,0,.256,1.406.292,1.735.365-.895.731-1.826,1.059-2.685a28.248,28.248,0,0,0,1.1-3.653,12.345,12.345,0,0,1-3.4-.95,3.489,3.489,0,0,1-1.827-2.393,1.7,1.7,0,0,1,1.68-1.827c1.425,0,2.831,2.192,3.2,3.416,0,0,.183,1.078.256,1.553h.091a22.1,22.1,0,0,0,.4-3.854c0-.712,0-1.388,0-2.064a10.96,10.96,0,0,1-3.4-.566,3.507,3.507,0,0,1-1.991-2.174,1.681,1.681,0,0,1,1.443-2.046c1.425-.128,3.069,1.827,3.653,3.032l.365,1.242V404.7c-.091-1.078-.237-2.046-.365-2.923a5.759,5.759,0,0,0-.256-1.333,11.306,11.306,0,0,1-2.74-2.064,3.507,3.507,0,0,1-.767-2.868,1.68,1.68,0,0,1,2.228-1.151c1.315.548,1.827,3.069,1.827,4.329,0,.11-.347,1.827-.384,1.827h0c.091.4.183.822.274,1.279.146.877.329,1.827.438,2.923a34.237,34.237,0,0,1,.2,3.489,24.149,24.149,0,0,1-.329,3.891h0l.822-1.461c.767-1.023,2.813-2.576,4.165-2.119a1.68,1.68,0,0,1,.95,2.32,3.471,3.471,0,0,1-2.466,1.662,11.947,11.947,0,0,1-3.507-.256,27.213,27.213,0,0,1-1.041,3.836c-.237.749-.511,1.479-.8,2.21l.365-.639c.749-1.023,2.813-2.576,4.165-2.119a1.7,1.7,0,0,1,.95,2.32,3.47,3.47,0,0,1-2.466,1.662,10.812,10.812,0,0,1-3.4-.237c-.128.274-.219.566-.347.84-.53,1.333-1.078,2.667-1.571,3.982-.164.475-.329.932-.475,1.406.146-.292.292-.511.311-.548.749-1.041,2.813-2.576,4.165-2.119a1.681,1.681,0,0,1,.932,2.32,3.544,3.544,0,0,1-2.448,1.662,11.3,11.3,0,0,1-3.324-.219c-.146.475-.292.95-.4,1.425s-.164.639-.219.968-.128.639-.2.968l-.274,1.827c0,.42-.11.822-.146,1.224.164-.475.511-1.37.548-1.443a6.6,6.6,0,0,1,2.3-2.375,1.832,1.832,0,0,1,.2-.311,1.68,1.68,0,0,1,2.5-.256c1.023.986.621,3.525,0,4.658l-.749,1.206.6-.694,1.333-1.406.694-.676.749-.694c.6-.511,1.242-1.023,1.827-1.5a11.454,11.454,0,0,1-2.21-2.576,3.507,3.507,0,0,1-.128-2.959,1.662,1.662,0,0,1,2.429-.639c1.151.8,1.151,3.379.767,4.6,0,0-.384.913-.6,1.37l1.187-.858c1.169-.822,2.375-1.607,3.653-2.393l1.1-.731a11.65,11.65,0,0,1-2.283-2.648,3.507,3.507,0,0,1-.146-2.959,1.7,1.7,0,0,1,2.429-.639c1.169.822,1.151,3.379.785,4.6,0,.091-.566,1.3-.712,1.607.8-.548,1.607-1.1,2.375-1.662a29.994,29.994,0,0,0,2.941-2.466,11.981,11.981,0,0,1-2.32-2.667,3.507,3.507,0,0,1-.128-2.959,1.662,1.662,0,0,1,2.429-.639c1.169.8,1.151,3.379.785,4.6,0,0-.438,1-.639,1.425h0a22.907,22.907,0,0,0,2.466-2.977,17.981,17.981,0,0,0,1.114-1.826,11.65,11.65,0,0,1-2.484-2.246,3.544,3.544,0,0,1-.457-2.923,1.68,1.68,0,0,1,2.338-.895c1.26.676,1.534,3.233,1.3,4.475,0,0-.237.749-.384,1.242.146-.256.311-.53.438-.785.511-.932.932-1.827,1.3-2.63.2-.457.365-.877.53-1.26a11.4,11.4,0,0,1-1.151-3.233,3.507,3.507,0,0,1,.95-2.813,1.662,1.662,0,0,1,2.484.274c.8,1.187-.146,3.653-.932,4.585,0,0-1.279,1.315-1.3,1.279h0c-.146.384-.292.785-.475,1.224-.347.8-.749,1.717-1.242,2.667a34.021,34.021,0,0,1-1.827,3.032,22.721,22.721,0,0,1-2.411,3.069h0l1.5-.749c1.187-.438,3.653-.6,4.64.53a1.68,1.68,0,0,1-.511,2.448,3.489,3.489,0,0,1-2.959,0,11.928,11.928,0,0,1-2.776-2.155,27.8,27.8,0,0,1-3,2.63c-.6.475-1.242.932-1.827,1.388l.658-.329c1.187-.438,3.763-.585,4.64.53a1.7,1.7,0,0,1-.493,2.466,3.525,3.525,0,0,1-2.977,0,10.959,10.959,0,0,1-2.7-2.064l-.731.511c-1.187.8-2.375,1.626-3.525,2.448l-1.169.895.566-.274c1.187-.438,3.763-.6,4.64.53a1.68,1.68,0,0,1-.493,2.448,3.525,3.525,0,0,1-2.977,0,10.705,10.705,0,0,1-2.63-2.009c-.384.311-.785.639-1.133.968l-.731.676-.676.694-1.26,1.406-.8.95c.384-.311,1.187-.859,1.26-.913,1.1-.6,3.653-1.151,4.658-.183a1.7,1.7,0,0,1-.128,2.521,3.653,3.653,0,0,1-2.923.475,11.619,11.619,0,0,1-3.05-1.7C185.2,435.915,184.784,436.427,184.4,436.92Z",
    transform: "translate(495.23 -353.396)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045-2",
    "data-name": "Path 2045",
    d: "M332.551,405.7a18.975,18.975,0,0,0,4.9-2.338s-2.009-1.7-2.155-1.827c-1.644-1.059-5.48-2.119-7.105-.731a2.557,2.557,0,0,0,0,3.836,5.369,5.369,0,0,0,4.366,1.059Z",
    transform: "translate(-7.299 -348.53)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046-2",
    "data-name": "Path 2046",
    d: "M321.882,397.73s-.749-2.521-.822-2.685c-.785-1.827-3.361-4.749-5.48-4.53a2.575,2.575,0,0,0-2.174,3.178,5.37,5.37,0,0,0,3.142,3.288,18.269,18.269,0,0,0,5.334.749Z",
    transform: "translate(43.354 -356.492)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047-2",
    "data-name": "Path 2047",
    d: "M315.035,434.206c-.615.785-1.2,1.539-1.708,2.185h-1.292c.646-.831,1.415-1.769,2.262-2.8.508-.585,1.046-1.215,1.615-1.846a20.346,20.346,0,0,1-1.431-1.985,14.2,14.2,0,0,1-3.831.277c-.077.754-.169,1.538-.231,2.2-.138,1.538-.231,2.985-.292,4.154h-1.046c.077-1.2.2-2.631.4-4.262a18.742,18.742,0,0,1,.308-2.431,13.124,13.124,0,0,1-3.6-1.631,3.969,3.969,0,0,1-1.539-2.985,1.923,1.923,0,0,1,2.2-1.815c1.538.292,2.8,2.939,2.985,4.369v1.538a7.937,7.937,0,0,1,.154-1.031c.108-.708.231-1.4.369-2.154l.231-1.092c.077-.354.2-.738.292-1.108.246-.877.523-1.738.831-2.6a12.448,12.448,0,0,1-3.692-1.046,3.985,3.985,0,0,1-1.985-2.723,1.923,1.923,0,0,1,1.892-2.123c1.538,0,3.215,2.477,3.615,3.862,0,.092.216,1.123.292,1.677.185-.508.369-1.031.585-1.539.6-1.539,1.246-3,1.892-4.492.2-.462.385-.923.569-1.369a13.1,13.1,0,0,1-3.815-1.077,3.985,3.985,0,0,1-1.985-2.708,1.908,1.908,0,0,1,1.892-2.123c1.615,0,3.215,2.477,3.615,3.862,0,.108.292,1.539.338,1.954.415-1.015.831-2.015,1.2-3.077a33.944,33.944,0,0,0,1.246-4.185,13.415,13.415,0,0,1-3.862-1.077,4,4,0,0,1-1.985-2.708,1.923,1.923,0,0,1,1.908-2.123c1.615,0,3.2,2.477,3.616,3.862,0,.092.215,1.215.292,1.754h.154a24.309,24.309,0,0,0,.477-4.369V399.1a12.479,12.479,0,0,1-3.846-.646,3.923,3.923,0,0,1-2.262-2.477,1.892,1.892,0,0,1,1.646-2.308c1.538-.139,3.462,2.108,4.015,3.431,0,.077.262.846.415,1.415V397.5c-.108-1.215-.277-2.323-.431-3.308-.092-.554-.2-1.062-.292-1.539a12.583,12.583,0,0,1-3.077-2.338,3.97,3.97,0,0,1-.862-3.246,1.908,1.908,0,0,1,2.523-1.292c1.538.631,2.108,3.477,1.985,4.908,0,.123-.4,2.046-.415,2.031h0c.092.446.2.938.292,1.462.185.985.385,2.092.508,3.308a31.625,31.625,0,0,1,.231,3.954,25.87,25.87,0,0,1-.369,4.4h0c.215-.415.877-1.538.938-1.646.846-1.169,3.169-2.923,4.708-2.415a1.908,1.908,0,0,1,1.062,2.646,4.031,4.031,0,0,1-2.785,1.877,13.076,13.076,0,0,1-3.969-.292,33.342,33.342,0,0,1-1.185,4.354c-.277.831-.585,1.662-.908,2.477l.415-.708c.862-1.169,3.185-2.908,4.723-2.4a1.923,1.923,0,0,1,1.062,2.631,3.97,3.97,0,0,1-2.785,1.877,12.94,12.94,0,0,1-3.862-.262l-.369.939c-.615,1.539-1.231,3.077-1.785,4.523-.2.523-.385,1.046-.554,1.538.185-.323.339-.585.354-.631.862-1.154,3.185-2.908,4.723-2.4a1.908,1.908,0,0,1,1.062,2.631,4,4,0,0,1-2.785,1.892,12.106,12.106,0,0,1-3.754-.262c-.169.554-.323,1.092-.462,1.631s-.185.708-.262,1.092l-.2,1.092c-.108.692-.231,1.415-.323,2.108s-.108.939-.169,1.385c.185-.523.585-1.539.631-1.631a7.278,7.278,0,0,1,2.6-2.677,1.756,1.756,0,0,1,.231-.354,1.908,1.908,0,0,1,2.831-.308c1.169,1.123.708,4,.077,5.292a14.849,14.849,0,0,1-.846,1.354c.231-.262.462-.508.692-.785a20.723,20.723,0,0,1,1.539-1.539l.8-.769c.262-.277.569-.523.862-.785q1.015-.877,2.123-1.708a12.433,12.433,0,0,1-2.508-2.908,4,4,0,0,1-.154-3.354,1.892,1.892,0,0,1,2.754-.723c1.323.923,1.308,3.831.877,5.216,0,.077-.431,1.031-.677,1.539.446-.323.877-.662,1.339-.985,1.323-.908,2.692-1.8,4.062-2.692l1.246-.831a13.585,13.585,0,0,1-2.615-3.077,4,4,0,0,1-.154-3.354,1.923,1.923,0,0,1,2.754-.723c1.323.938,1.308,3.846.892,5.216a15.05,15.05,0,0,1-.8,1.815c.908-.6,1.815-1.215,2.677-1.862a33.146,33.146,0,0,0,3.339-2.8,13.6,13.6,0,0,1-2.616-3.077,3.892,3.892,0,0,1-.154-3.354,1.908,1.908,0,0,1,2.738-.723c1.323.938,1.308,3.846.892,5.216,0,.092-.492,1.138-.723,1.631h.077a24.354,24.354,0,0,0,2.8-3.385c.462-.662.877-1.323,1.262-1.969a12.307,12.307,0,0,1-2.862-2.662,3.954,3.954,0,0,1-.523-3.308,1.908,1.908,0,0,1,2.646-1.031c1.415.785,1.723,3.677,1.462,5.092,0,0-.262.846-.431,1.4l.492-.877c.585-1.077,1.062-2.092,1.538-3,.231-.508.415-.985.6-1.431a12.418,12.418,0,0,1-1.308-3.662,3.939,3.939,0,0,1,1.077-3.185,1.908,1.908,0,0,1,2.815.323c.908,1.339-.154,4.046-1.046,5.185-.077.092-1.539,1.539-1.539,1.462h0l-.554,1.385c-.385.908-.846,1.939-1.4,3.077a35.517,35.517,0,0,1-2,3.415A24.614,24.614,0,0,1,336,416.082h0c.415-.231,1.539-.831,1.692-.862,1.354-.508,4.262-.677,5.262.585a1.908,1.908,0,0,1-.569,2.785,3.985,3.985,0,0,1-3.354,0,13.449,13.449,0,0,1-3.077-2.446,33.5,33.5,0,0,1-3.385,2.985c-.692.539-1.415,1.062-2.138,1.538l.754-.369c1.338-.492,4.246-.662,5.246.6a1.892,1.892,0,0,1-.569,2.785,3.939,3.939,0,0,1-3.354,0,12.721,12.721,0,0,1-3.077-2.354c-.277.2-.554.4-.846.585-1.338.923-2.677,1.846-3.969,2.785-.462.323-.892.677-1.339,1.015l.646-.323c1.354-.492,4.262-.662,5.262.6a1.923,1.923,0,0,1-.923,3.277,3.97,3.97,0,0,1-3.369,0,12.077,12.077,0,0,1-2.985-2.277c-.431.369-.877.723-1.277,1.092s-.554.492-.815.769l-.785.8L317.6,431.19c-.308.369-.6.723-.908,1.062.446-.323,1.339-.969,1.431-1.015,1.262-.692,4.108-1.308,5.277-.2a1.892,1.892,0,0,1-.138,2.831,3.985,3.985,0,0,1-3.308.554A13,13,0,0,1,316.5,432.5C315.958,433.083,315.481,433.652,315.035,434.206Z",
    transform: "translate(-139.862 -360.812)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048-2",
    "data-name": "Path 2048",
    d: "M238.709,408.148a15.2,15.2,0,0,0,3.945-1.827s-1.626-1.37-1.735-1.443c-1.333-.84-4.384-1.717-5.736-.585a2.064,2.064,0,0,0,0,3.087,4.365,4.365,0,0,0,3.525.767Z",
    transform: "translate(318.384 -355.542)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049-2",
    "data-name": "Path 2049",
    d: "M230.168,401.771s-.6-2.046-.658-2.174c-.639-1.425-2.7-3.836-4.457-3.653a2.082,2.082,0,0,0-1.827,2.557,4.311,4.311,0,0,0,2.521,2.649A14.612,14.612,0,0,0,230.168,401.771Z",
    transform: "translate(359.106 -362.006)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050-2",
    "data-name": "Path 2050",
    d: "M245.208,438.565l1.626,2.1h1.315c-.621-.785-1.352-1.7-2.174-2.667-.475-.585-.986-1.187-1.534-1.827a18.522,18.522,0,0,0,1.37-1.827,14.321,14.321,0,0,0,3.653.256,19.461,19.461,0,0,0,.219,2.1c.128,1.516.219,2.849.274,3.982h1c0-1.151-.2-2.521-.365-4.073-.091-.749-.2-1.534-.31-2.338a12.126,12.126,0,0,0,3.452-1.571,3.8,3.8,0,0,0,1.48-2.849,1.827,1.827,0,0,0-2.1-1.735c-1.516.274-2.685,2.813-2.868,4.183v1.534a2.32,2.32,0,0,0-.146-.986c-.091-.676-.219-1.352-.347-2.064l-.219-1.041a4.917,4.917,0,0,0-.274-1.078c-.237-.822-.511-1.662-.8-2.484a11.688,11.688,0,0,0,3.544-1,3.8,3.8,0,0,0,1.827-2.612A1.827,1.827,0,0,0,252,420.536c-1.553,0-3.087,2.375-3.471,3.653,0,0-.2,1.059-.274,1.607-.183-.493-.365-1-.566-1.5-.566-1.425-1.187-2.868-1.827-4.311l-.548-1.315a12.167,12.167,0,0,0,3.653-1.023,3.8,3.8,0,0,0,1.827-2.594,1.826,1.826,0,0,0-1.827-2.027c-1.553,0-3.069,2.375-3.471,3.653,0,.11-.274,1.516-.311,1.827-.4-.968-.8-1.936-1.151-2.9a31.224,31.224,0,0,1-1.187-4.018,13.282,13.282,0,0,0,3.653-1.023,3.909,3.909,0,0,0,1.827-2.612,1.827,1.827,0,0,0-1.827-2.027c-1.534,0-3.069,2.375-3.452,3.653,0,.091-.219,1.169-.292,1.68h0a22.517,22.517,0,0,1-.457-4.183c0-.767,0-1.516,0-2.229a11.836,11.836,0,0,0,3.653-.621,3.781,3.781,0,0,0,2.174-2.375,1.827,1.827,0,0,0-1.571-2.21c-1.553-.128-3.324,2.028-3.854,3.288,0,0-.256.8-.4,1.352v-.968c.091-1.169.256-2.228.4-3.16.091-.548.183-1.023.274-1.461a12.217,12.217,0,0,0,2.977-2.247,3.872,3.872,0,0,0,.84-3.105,1.827,1.827,0,0,0-2.429-1.242c-1.425.6-2.009,3.324-1.827,4.694,0,.128.384,1.973.4,1.954h0c-.11.438-.2.895-.292,1.406a31.579,31.579,0,0,0-.475,3.16,30.574,30.574,0,0,0-.219,3.781,22.852,22.852,0,0,0,.347,4.238h0c-.219-.4-.84-1.5-.9-1.571-.822-1.114-3.05-2.795-4.512-2.3a1.827,1.827,0,0,0-1.023,2.521,3.818,3.818,0,0,0,2.667,1.826,12.987,12.987,0,0,0,3.8-.292,33.117,33.117,0,0,0,1.133,4.183c.274.785.566,1.589.877,2.375l-.4-.676c-.822-1.114-3.05-2.795-4.512-2.3a1.827,1.827,0,0,0-1.023,2.521,3.781,3.781,0,0,0,2.667,1.827,12.05,12.05,0,0,0,3.653-.256l.365.913c.585,1.443,1.169,2.886,1.7,4.329.2.493.365,1,.53,1.516a5.552,5.552,0,0,0-.347-.6c-.8-1.114-3.05-2.776-4.512-2.3a1.827,1.827,0,0,0-1.023,2.521,3.854,3.854,0,0,0,2.667,1.827,11.8,11.8,0,0,0,3.653-.237c.164.511.31,1.041.438,1.553s.183.694.256,1.041.128.712.2,1.059c.11.657.219,1.352.292,2.009s.128.9.164,1.333c-.183-.493-.548-1.48-.585-1.553a7.307,7.307,0,0,0-2.5-2.576l-.219-.347a1.827,1.827,0,0,0-2.722-.274c-1.114,1.059-.676,3.818,0,5.06l.822,1.3-.676-.749c-.457-.511-.913-.986-1.425-1.516l-.767-.749c-.256-.256-.548-.493-.822-.749-.639-.566-1.333-1.1-2.028-1.626a12.165,12.165,0,0,0,2.393-2.795,3.818,3.818,0,0,0,.146-3.215,1.827,1.827,0,0,0-2.63-.694c-1.26.877-1.26,3.653-.84,4.987,0,.091.42,1,.639,1.5l-1.279-.932c-1.279-.877-2.576-1.735-3.891-2.594l-1.187-.785a13.038,13.038,0,0,0,2.5-2.886,3.89,3.89,0,0,0,.146-3.215,1.826,1.826,0,0,0-2.648-.694c-1.26.9-1.242,3.653-.84,5,0,0,.6,1.407.767,1.735a24.909,24.909,0,0,1-2.575-1.827,35.459,35.459,0,0,1-3.2-2.685,12.953,12.953,0,0,0,2.521-2.9,3.872,3.872,0,0,0,.146-3.215,1.827,1.827,0,0,0-2.63-.676c-1.279.877-1.26,3.653-.859,4.987a16.737,16.737,0,0,0,.676,1.553h0a24.064,24.064,0,0,1-2.667-3.233c-.457-.639-.84-1.26-1.206-1.827a12.255,12.255,0,0,0,2.74-2.557,3.781,3.781,0,0,0,.493-3.178,1.826,1.826,0,0,0-2.539-.968c-1.352.749-1.644,3.507-1.388,4.877,0,0,.237.8.42,1.333-.164-.274-.347-.566-.493-.84-.548-1.023-1-2.009-1.406-2.868-.219-.493-.4-.95-.566-1.37a12.165,12.165,0,0,0,1.242-3.507,3.781,3.781,0,0,0-1.023-3.05,1.827,1.827,0,0,0-2.7.292c-.858,1.3.146,3.891,1,4.968a14.715,14.715,0,0,0,1.425,1.407h0c.164.42.329.858.53,1.333.384.877.8,1.827,1.352,2.9a37.438,37.438,0,0,0,1.827,3.288,25.571,25.571,0,0,0,2.63,3.324h0c-.384-.219-1.516-.8-1.607-.822-1.3-.493-4.092-.657-5.041.566a1.827,1.827,0,0,0,.548,2.667,3.872,3.872,0,0,0,3.215,0,12.9,12.9,0,0,0,3.014-2.338,30.762,30.762,0,0,0,3.251,2.85c.658.511,1.352,1.023,2.046,1.516l-.712-.365c-1.3-.475-4.092-.639-5.041.585a1.827,1.827,0,0,0,.548,2.667,3.872,3.872,0,0,0,3.215,0,12.353,12.353,0,0,0,3.05-1.936l.8.566c1.279.877,2.576,1.827,3.8,2.667.438.311.859.639,1.279.968l-.621-.31c-1.279-.475-4.073-.639-5.023.566a1.826,1.826,0,0,0,.53,2.685,3.854,3.854,0,0,0,3.233,0,11.342,11.342,0,0,0,2.85-2.174l1.242,1.041c.256.256.53.475.767.749l.749.749c.457.511.932,1.023,1.37,1.534s.585.676.877,1c-.438-.311-1.279-.932-1.37-.968-1.206-.676-3.927-1.26-5.06-.2a1.827,1.827,0,0,0,.128,2.722,3.818,3.818,0,0,0,3.178.512,12.366,12.366,0,0,0,3.324-1.827Z",
    transform: "translate(347.918 -365.281)",
    fill: "#eceff1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-122",
    transform: "translate(29.682 524.906)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    x2: 588.169,
    transform: "translate(196.455)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-122-2",
    "data-name": "freepik--Floor--inject-122",
    transform: "translate(-566.969 524.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M0,0H28.445",
    transform: "translate(271.986)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M0,0H35.232",
    transform: "translate(729.986)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x2: 179.173,
    transform: "translate(445.581)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62422",
    "data-name": "Path 62422",
    d: "M0,0H218.978",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-122-3",
    "data-name": "freepik--Floor--inject-122",
    transform: "translate(649.33 524.906)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_254-2",
    "data-name": "Line 254",
    x2: 449.5,
    transform: "translate(196.455)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-132.84 123.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M102.485,429.582l9.293-5.1,9.94,5.288,9.941-5.288,9.941,5.288,9.954-5.288,9.941,5.288,9.941-5.288,9.94,5.288,9.941-5.288,9.941,5.288,9.94-5.288,9.941,5.288,9.941-5.288,10.139,5.882,9.729-5.882,9.585,7.881V436.4L88.42,436.06Z",
    transform: "translate(558.071 289.775)",
    fill: "#f0f0f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M102.524,429.6l9.319-5.117,9.968,5.3,9.968-5.3,9.968,5.3,9.982-5.3,9.969,5.3,9.968-5.3,9.968,5.3,9.969-5.3,9.968,5.3,9.968-5.3,9.969,5.3,9.968-5.3,10.167,5.9,9.756-5.9,9.968,5.3,9.968-5.3,9.968,5.3,9.955-5.3,9.968,5.3V435.8l-212.811.287Z",
    transform: "translate(106.089 289.775)",
    fill: "#f0f0f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M105.063,430.518l11-6.038,11.762,6.257,11.763-6.257,11.763,6.257,11.778-6.257,11.763,6.257,11.763-6.257,11.762,6.257,11.763-6.257,11.763,6.257L233.7,424.48l11.763,6.257,11.763-6.257,12,6.961,11.512-6.961,11.342,9.325v4.785L88.42,438.182Z",
    transform: "translate(956.258 287.589)",
    fill: "#f0f0f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M326.491,424.48l-9.955,5.3-9.968-5.3-9.955,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.955,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.982,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.968,5.3-9.968-5.3-9.982,5.3",
    transform: "translate(90.784 289.775)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M266.232,424.48l-9.927,5.288-9.941-5.288-9.941,5.288-9.941-5.288-9.94,5.288L206.6,424.48l-9.941,5.288-9.941-5.288-9.941,5.288-9.941-5.288-9.954,5.288-9.941-5.288-9.941,5.288-9.941-5.288-9.94,5.288-9.941-5.288-9.954,5.288",
    transform: "translate(542.784 289.775)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M297.209,424.48l-11.747,6.257L273.7,424.48l-11.763,6.257-11.763-6.257-11.762,6.257-11.763-6.257-11.763,6.257-11.763-6.257-11.763,6.257L179.6,424.48l-11.778,6.257-11.763-6.257L144.3,430.737l-11.763-6.257-11.762,6.257-11.763-6.257L97.23,430.737",
    transform: "translate(939.784 287.589)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(165.518 296.766)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-758-2",
    "data-name": "freepik--Tree--inject-758",
    transform: "translate(14.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222-2",
    "data-name": "Path 222",
    d: "M189.51,465.858c-7.431-13.133-22.921-43.272-25.2-51.287-9.811-34.494-4.265-66.07,0-81.516s16.007-40.533,35.168-72.468,34.629-76.2,41.532-89.519,73.535-49.547,88.453-58.078l14.918-8.52",
    transform: "translate(-87.576 -50.848)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223-2",
    "data-name": "Path 223",
    d: "M294.1,84.53s29.847,30.375,45.832,50.625S398.01,240.67,398.01,240.67s-25.582,40.5-36.234,62.86-22.383,53.274-22.383,80.988-.528,54.351-.528,67.664c0,5.8-1.919,11.91-4.086,16.95",
    transform: "translate(-293.034 -53.291)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224-2",
    "data-name": "Path 224",
    d: "M247.919,90.166l1.9,96.3,1.56,2.458L275.42,227.47s4.883-7.667,14.334-28.22c10.911-23.741,27.344-62.86,26.805-67.653S272.7,82.567,270.032,78.84",
    transform: "translate(-159.758 -53.988)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225-2",
    "data-name": "Path 225",
    d: "M250.161,105.556s-78.328,43.688-83.649,44.754S194.743,86.9,194.743,86.9",
    transform: "translate(-1.325 -53.001)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226-2",
    "data-name": "Path 226",
    d: "M290.094,87.535s-20.2,28.242-22.91,30.9S222.43,77.41,222.43,77.41",
    transform: "translate(-104.669 -54.163)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227-2",
    "data-name": "Path 227",
    d: "M392.738,63.17l-6.926,53.285L345.84,77.022",
    transform: "translate(-345.84 -55.907)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228-2",
    "data-name": "Path 228",
    d: "M349.493,84.886l-6.331,81.729L313.82,120.267,317.906,56.7",
    transform: "translate(-266.653 -56.7)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229-2",
    "data-name": "Path 229",
    d: "M344.4,439.367s.909-6.858-3.21-22.876-6.858-44.844-4.569-66.351",
    transform: "translate(-286.315 -20.754)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230-2",
    "data-name": "Path 230",
    d: "M337.674,360.33a155.572,155.572,0,0,0,1.381,29.286",
    transform: "translate(-282.795 -19.506)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231-2",
    "data-name": "Path 231",
    d: "M325.68,381.94a109.308,109.308,0,0,0,3.21,23.8c3.2,12.808,5.949,18.3,5.949,18.3",
    transform: "translate(-265.312 -16.859)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232-2",
    "data-name": "Path 232",
    d: "M341.969,308.15s-5.949,20.6-7.319,30.206",
    transform: "translate(-282.51 -25.898)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233-2",
    "data-name": "Path 233",
    d: "M338.11,337.1s-1.37,13.268-1.83,16.927",
    transform: "translate(-280.481 -22.351)",
    fill: "rgba(232,24,24,0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83-2",
    "data-name": "Line 83",
    y1: 36.156,
    x2: 20.138,
    transform: "translate(72.727 212.242)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84-2",
    "data-name": "Line 84",
    y1: 28.366,
    x2: 18.308,
    transform: "translate(88.285 198.065)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-758-2",
    "data-name": "freepik--Leaves--inject-758",
    transform: "translate(0 20.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296-2",
    "data-name": "Path 296",
    d: "M186.972,228.144a6.735,6.735,0,0,1-4.894,4.041c-3.626.617-8.318-1.841-8.318-1.841a23.573,23.573,0,0,1,7.341-4.108,6.1,6.1,0,0,1,5.871,1.908Z",
    transform: "translate(67.588 -51.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297-2",
    "data-name": "Path 297",
    d: "M186.51,141.805s4.49-4.49,10.551-2.773,11.663,8.89,11.663,8.89-8.329,2.245-14.447,1.122S186.51,141.805,186.51,141.805Z",
    transform: "translate(31.524 -62.569)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298-2",
    "data-name": "Path 298",
    d: "M255.58,286.415s4.49-4.49,10.552-2.773,11.674,8.89,11.674,8.89-8.34,2.245-14.447,1.122S255.58,286.415,255.58,286.415Z",
    transform: "translate(-115.088 -44.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299-2",
    "data-name": "Path 299",
    d: "M165.767,131.17s5.927,2.088,7.049,8.329-3,14.357-3,14.357-5.613-6.567-7.229-12.561S165.767,131.17,165.767,131.17Z",
    transform: "translate(94.462 -63.485)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-2",
    "data-name": "Path 300",
    d: "M194.65,323.84s5.927,2.1,7.061,8.329-2.952,14.357-2.952,14.357-5.613-6.567-7.229-12.561S194.65,323.84,194.65,323.84Z",
    transform: "translate(33.083 -39.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-2",
    "data-name": "Path 301",
    d: "M277.363,131.954a6.735,6.735,0,0,1-4.894,4.041c-3.626.617-8.329-1.841-8.329-1.841a23.7,23.7,0,0,1,7.352-4.108,6.1,6.1,0,0,1,5.871,1.908Z",
    transform: "translate(-124.254 -63.64)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-2",
    "data-name": "Path 302",
    d: "M233.772,122.114a6.735,6.735,0,0,1-4.883,4.041c-3.637.617-8.329-1.841-8.329-1.841a23.572,23.572,0,0,1,7.352-4.108,6.084,6.084,0,0,1,5.859,1.908Z",
    transform: "translate(-31.745 -64.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-2",
    "data-name": "Path 303",
    d: "M143.812,323.034a6.735,6.735,0,0,1-4.883,4.041c-3.637.606-8.329-1.841-8.329-1.841s3.85-3.21,7.352-4.12A6.106,6.106,0,0,1,143.812,323.034Z",
    transform: "translate(159.195 -40.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-2",
    "data-name": "Path 304",
    d: "M305.651,105.173s-1.729,6.039-7.858,7.543-14.514-2.122-14.514-2.122,6.219-5.983,12.1-7.97S305.651,105.173,305.651,105.173Z",
    transform: "translate(-174.027 -67.043)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305-2",
    "data-name": "Path 305",
    d: "M222.991,93.338s-1.729,6.039-7.858,7.543-14.514-2.11-14.514-2.11,6.23-6.039,12.067-8.026S222.991,93.338,222.991,93.338Z",
    transform: "translate(1.419 -68.498)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306-2",
    "data-name": "Path 306",
    d: "M339.447,81.4s.685,6.241-4.49,9.968S320.723,94.9,320.723,94.9s3.48-7.857,8.172-11.966S339.447,81.4,339.447,81.4Z",
    transform: "translate(-249.882 -69.679)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307-2",
    "data-name": "Path 307",
    d: "M114.26,185.827s1.291-6.151,7.319-8.1,14.592,1.033,14.592,1.033-5.758,6.432-11.472,8.845S114.26,185.827,114.26,185.827Z",
    transform: "translate(185.178 -57.863)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308-2",
    "data-name": "Path 308",
    d: "M280.25,79.648s1.28-6.163,7.307-8.116,14.593,1.044,14.593,1.044-5.747,6.432-11.472,8.845S280.25,79.648,280.25,79.648Z",
    transform: "translate(-167.125 -70.871)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309-2",
    "data-name": "Path 309",
    d: "M112.28,140.287s1.291-6.151,7.319-8.1,14.592,1.044,14.592,1.044-5.758,6.421-11.472,8.845S112.28,140.287,112.28,140.287Z",
    transform: "translate(189.38 -63.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310-2",
    "data-name": "Path 310",
    d: "M112.28,140.287s1.291-6.151,7.319-8.1,14.592,1.044,14.592,1.044-5.758,6.421-11.472,8.845S112.28,140.287,112.28,140.287Z",
    transform: "translate(189.38 -63.442)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311-2",
    "data-name": "Path 311",
    d: "M242.69,211.3s1.28-6.151,7.307-8.1,14.592,1.044,14.592,1.044-5.747,6.421-11.472,8.845S242.69,211.3,242.69,211.3Z",
    transform: "translate(-87.404 -54.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312-2",
    "data-name": "Path 312",
    d: "M242.69,211.3s1.28-6.151,7.307-8.1,14.592,1.044,14.592,1.044-5.747,6.421-11.472,8.845S242.69,211.3,242.69,211.3Z",
    transform: "translate(-87.404 -54.743)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313-2",
    "data-name": "Path 313",
    d: "M186.341,177.448s5.612-2.93,10.9.46,8.531,11.943,8.531,11.943-8.621-.337-14.132-3.2S186.341,177.448,186.341,177.448Z",
    transform: "translate(34.668 -57.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314-2",
    "data-name": "Path 314",
    d: "M186.341,177.448s5.612-2.93,10.9.46,8.531,11.943,8.531,11.943-8.621-.337-14.132-3.2S186.341,177.448,186.341,177.448Z",
    transform: "translate(34.668 -57.96)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315-2",
    "data-name": "Path 315",
    d: "M384.045,267.523s-5.208,3.525-10.9.73-9.766-10.944-9.766-10.944,8.61-.606,14.39,1.65S384.045,267.523,384.045,267.523Z",
    transform: "translate(-342.333 -48.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316-2",
    "data-name": "Path 316",
    d: "M384.045,267.523s-5.208,3.525-10.9.73-9.766-10.944-9.766-10.944,8.61-.606,14.39,1.65S384.045,267.523,384.045,267.523Z",
    transform: "translate(-342.333 -48.042)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317-2",
    "data-name": "Path 317",
    d: "M402.8,123.783s-5.208,3.525-10.9.73-9.766-10.944-9.766-10.944,8.61-.606,14.39,1.65S402.8,123.783,402.8,123.783Z",
    transform: "translate(-382.13 -65.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318-2",
    "data-name": "Path 318",
    d: "M402.8,123.783s-5.208,3.525-10.9.73-9.766-10.944-9.766-10.944,8.61-.606,14.39,1.65S402.8,123.783,402.8,123.783Z",
    transform: "translate(-382.13 -65.65)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2",
    "data-name": "Path 319",
    d: "M226.611,79.559s5.556-2.941,10.911.46,8.52,11.932,8.52,11.932-8.61-.337-14.121-3.2S226.611,79.559,226.611,79.559Z",
    transform: "translate(-50.805 -69.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2",
    "data-name": "Path 320",
    d: "M226.611,79.559s5.556-2.941,10.911.46,8.52,11.932,8.52,11.932-8.61-.337-14.121-3.2S226.611,79.559,226.611,79.559Z",
    transform: "translate(-50.805 -69.951)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2",
    "data-name": "Path 321",
    d: "M192.391,107.319s5.556-2.941,10.9.46,8.531,11.932,8.531,11.932-8.621-.337-14.132-3.2S192.391,107.319,192.391,107.319Z",
    transform: "translate(21.827 -66.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-2",
    "data-name": "Path 322",
    d: "M192.391,107.319s5.556-2.941,10.9.46,8.531,11.932,8.531,11.932-8.621-.337-14.132-3.2S192.391,107.319,192.391,107.319Z",
    transform: "translate(21.827 -66.551)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323-2",
    "data-name": "Path 323",
    d: "M191.641,98.6s4.31,4.58,2.458,10.641-9.238,11.393-9.238,11.393-1.964-8.4-.673-14.469S191.641,98.6,191.641,98.6Z",
    transform: "translate(48.787 -67.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324-2",
    "data-name": "Path 324",
    d: "M191.641,98.6s4.31,4.58,2.458,10.641-9.238,11.393-9.238,11.393-1.964-8.4-.673-14.469S191.641,98.6,191.641,98.6Z",
    transform: "translate(48.787 -67.474)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325-2",
    "data-name": "Path 325",
    d: "M148.2,90.818s-.056,6.286-5.613,9.384S128,102.032,128,102.032s4.49-7.42,9.6-10.855S148.2,90.818,148.2,90.818Z",
    transform: "translate(157.721 -68.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326-2",
    "data-name": "Path 326",
    d: "M148.2,90.818s-.056,6.286-5.613,9.384S128,102.032,128,102.032s4.49-7.42,9.6-10.855S148.2,90.818,148.2,90.818Z",
    transform: "translate(157.721 -68.583)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327-2",
    "data-name": "Path 327",
    d: "M147.422,117.1s-6.073,1.616-10.518-2.885-5.613-13.549-5.613-13.549,8.329,2.245,13.055,6.286S147.422,117.1,147.422,117.1Z",
    transform: "translate(154.53 -67.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2",
    "data-name": "Path 328",
    d: "M147.422,117.1s-6.073,1.616-10.518-2.885-5.613-13.549-5.613-13.549,8.329,2.245,13.055,6.286S147.422,117.1,147.422,117.1Z",
    transform: "translate(154.53 -67.221)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329-2",
    "data-name": "Path 329",
    d: "M348.593,143.454s-5.556-2.941-5.758-9.272,5.074-13.762,5.074-13.762,4.569,7.307,5.3,13.47S348.593,143.454,348.593,143.454Z",
    transform: "translate(-288.495 -64.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330-2",
    "data-name": "Path 330",
    d: "M348.593,143.454s-5.556-2.941-5.758-9.272,5.074-13.762,5.074-13.762,4.569,7.307,5.3,13.47S348.593,143.454,348.593,143.454Z",
    transform: "translate(-288.495 -64.801)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331-2",
    "data-name": "Path 331",
    d: "M347.6,127.4s1.358-6.14,7.408-8.015S369.6,120.62,369.6,120.62s-5.837,6.353-11.584,8.7S347.6,127.4,347.6,127.4Z",
    transform: "translate(-310.176 -65.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332-2",
    "data-name": "Path 332",
    d: "M347.6,127.4s1.358-6.14,7.408-8.015S369.6,120.62,369.6,120.62s-5.837,6.353-11.584,8.7S347.6,127.4,347.6,127.4Z",
    transform: "translate(-310.176 -65.002)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333-2",
    "data-name": "Path 333",
    d: "M341,93.716s-.067,6.286-5.613,9.373-14.592,1.841-14.592,1.841,4.389-7.431,9.53-10.922S341,93.716,341,93.716Z",
    transform: "translate(-251.476 -68.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334-2",
    "data-name": "Path 334",
    d: "M341,93.716s-.067,6.286-5.613,9.373-14.592,1.841-14.592,1.841,4.389-7.431,9.53-10.922S341,93.716,341,93.716Z",
    transform: "translate(-251.476 -68.237)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335-2",
    "data-name": "Path 335",
    d: "M340.22,119.982s-6.084,1.628-10.529-2.885-5.612-13.537-5.612-13.537,8.329,2.245,13.066,6.275S340.22,119.982,340.22,119.982Z",
    transform: "translate(-254.674 -66.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336-2",
    "data-name": "Path 336",
    d: "M340.22,119.982s-6.084,1.628-10.529-2.885-5.612-13.537-5.612-13.537,8.329,2.245,13.066,6.275S340.22,119.982,340.22,119.982Z",
    transform: "translate(-254.674 -66.867)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337-2",
    "data-name": "Path 337",
    d: "M241.875,128.216s-.056,6.286-5.612,9.373-14.592,1.841-14.592,1.841,4.389-7.431,9.53-10.922S241.875,128.216,241.875,128.216Z",
    transform: "translate(-41.094 -64.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338-2",
    "data-name": "Path 338",
    d: "M241.875,128.216s-.056,6.286-5.612,9.373-14.592,1.841-14.592,1.841,4.389-7.431,9.53-10.922S241.875,128.216,241.875,128.216Z",
    transform: "translate(-41.094 -64.01)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339-2",
    "data-name": "Path 339",
    d: "M241.107,154.482s-6.073,1.616-10.529-2.885-5.613-13.537-5.613-13.537,8.329,2.245,13.055,6.275S241.107,154.482,241.107,154.482Z",
    transform: "translate(-44.299 -62.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340-2",
    "data-name": "Path 340",
    d: "M241.107,154.482s-6.073,1.616-10.529-2.885-5.613-13.537-5.613-13.537,8.329,2.245,13.055,6.275S241.107,154.482,241.107,154.482Z",
    transform: "translate(-44.299 -62.641)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341-2",
    "data-name": "Path 341",
    d: "M253.01,140.324s1.774-6.028,7.947-7.487,14.491,2.245,14.491,2.245S269.2,141.02,263.3,142.94,253.01,140.324,253.01,140.324Z",
    transform: "translate(-109.847 -63.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342-2",
    "data-name": "Path 342",
    d: "M253.01,140.324s1.774-6.028,7.947-7.487,14.491,2.245,14.491,2.245S269.2,141.02,263.3,142.94,253.01,140.324,253.01,140.324Z",
    transform: "translate(-109.847 -63.322)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343-2",
    "data-name": "Path 343",
    d: "M254.1,116.76s6.286.1,9.339,5.612,1.706,14.593,1.706,14.593-7.386-4.49-10.832-9.62S254.1,116.76,254.1,116.76Z",
    transform: "translate(-99.523 -65.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344-2",
    "data-name": "Path 344",
    d: "M254.1,116.76s6.286.1,9.339,5.612,1.706,14.593,1.706,14.593-7.386-4.49-10.832-9.62S254.1,116.76,254.1,116.76Z",
    transform: "translate(-99.523 -65.25)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345-2",
    "data-name": "Path 345",
    d: "M234.24,109.855s1.774-6.039,7.936-7.5,14.5,2.245,14.5,2.245-6.252,5.938-12.157,7.857S234.24,109.855,234.24,109.855Z",
    transform: "translate(-70.007 -67.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346-2",
    "data-name": "Path 346",
    d: "M234.24,109.855s1.774-6.039,7.936-7.5,14.5,2.245,14.5,2.245-6.252,5.938-12.157,7.857S234.24,109.855,234.24,109.855Z",
    transform: "translate(-70.007 -67.056)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347-2",
    "data-name": "Path 347",
    d: "M235.36,86.29s6.286.112,9.328,5.612,1.717,14.592,1.717,14.592-7.386-4.49-10.832-9.609S235.36,86.29,235.36,86.29Z",
    transform: "translate(-59.734 -68.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348-2",
    "data-name": "Path 348",
    d: "M235.36,86.29s6.286.112,9.328,5.612,1.717,14.592,1.717,14.592-7.386-4.49-10.832-9.609S235.36,86.29,235.36,86.29Z",
    transform: "translate(-59.734 -68.982)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349-2",
    "data-name": "Path 349",
    d: "M310.535,158.556s-.056,6.286-5.612,9.373-14.593,1.841-14.593,1.841,4.389-7.431,9.53-10.922S310.535,158.556,310.535,158.556Z",
    transform: "translate(-186.824 -60.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350-2",
    "data-name": "Path 350",
    d: "M310.535,158.556s-.056,6.286-5.612,9.373-14.593,1.841-14.593,1.841,4.389-7.431,9.53-10.922S310.535,158.556,310.535,158.556Z",
    transform: "translate(-186.824 -60.294)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351-2",
    "data-name": "Path 351",
    d: "M309.767,184.792s-6.073,1.616-10.529-2.885-5.612-13.537-5.612-13.537,8.329,2.245,13.055,6.275S309.767,184.792,309.767,184.792Z",
    transform: "translate(-190.03 -58.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352-2",
    "data-name": "Path 352",
    d: "M309.767,184.792s-6.073,1.616-10.529-2.885-5.612-13.537-5.612-13.537,8.329,2.245,13.055,6.275S309.767,184.792,309.767,184.792Z",
    transform: "translate(-190.03 -58.928)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353-2",
    "data-name": "Path 353",
    d: "M346.691,205.438s5.556-2.93,10.9.46,8.531,11.943,8.531,11.943-8.621-.337-14.132-3.2S346.691,205.438,346.691,205.438Z",
    transform: "translate(-305.675 -54.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354-2",
    "data-name": "Path 354",
    d: "M346.691,205.438s5.556-2.93,10.9.46,8.531,11.943,8.531,11.943-8.621-.337-14.132-3.2S346.691,205.438,346.691,205.438Z",
    transform: "translate(-305.675 -54.531)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355-2",
    "data-name": "Path 355",
    d: "M345.936,196.73s4.31,4.58,2.458,10.641-9.238,11.393-9.238,11.393-1.976-8.4-.673-14.48S345.936,196.73,345.936,196.73Z",
    transform: "translate(-278.698 -55.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356-2",
    "data-name": "Path 356",
    d: "M345.936,196.73s4.31,4.58,2.458,10.641-9.238,11.393-9.238,11.393-1.976-8.4-.673-14.48S345.936,196.73,345.936,196.73Z",
    transform: "translate(-278.698 -55.454)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357-2",
    "data-name": "Path 357",
    d: "M292.107,131.946c-3.491,5.141-4.827,13.661-4.827,13.661s8.845-2.155,12.841-7.072,1.729-10.787,1.729-10.787S295.587,126.8,292.107,131.946Zm9.62,14.682c5.882,2,6.634,8.284,6.634,8.284s-5.051,3.749-10.843,1.2-10.237-10.507-10.237-10.507S295.845,144.63,301.727,146.628Z",
    transform: "translate(-181.226 -63.912)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358-2",
    "data-name": "Path 358",
    d: "M315.959,140.964c6.129,1.021,14.424-1.325,14.424-1.325s-5.613-7.139-11.8-8.711a11.466,11.466,0,0,0-10.507,2.93S309.83,139.943,315.959,140.964Zm9.317-14.929c-.651-6.174,4.748-9.485,4.748-9.485s5.511,3.02,5.612,9.35-5.264,13.695-5.264,13.695S325.915,132.265,325.276,126.035Z",
    transform: "translate(-231.85 -65.276)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-2",
    "data-name": "Path 359",
    d: "M244.419,91.385c2.963,5.467,9.923,10.563,9.923,10.563s2.144-8.856-.382-14.66-8.778-6.488-8.778-6.488S241.455,85.93,244.419,91.385Zm17.466-1.807c4.49-4.31,10.406-2.088,10.406-2.088s1.01,6.207-3.918,10.192-14.031,4.265-14.031,4.265S257.406,93.888,261.885,89.578Z",
    transform: "translate(-95.845 -69.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360-2",
    "data-name": "Path 360",
    d: "M198.329,121.075c2.963,5.455,9.923,10.563,9.923,10.563s2.144-8.856-.382-14.671-8.778-6.477-8.778-6.477S195.365,115.62,198.329,121.075Zm17.466-1.807c4.49-4.31,10.406-2.088,10.406-2.088s1.01,6.2-3.918,10.181-14.031,4.277-14.031,4.277S211.316,123.578,215.795,119.268Z",
    transform: "translate(1.981 -66.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361-2",
    "data-name": "Path 361",
    d: "M153.057,92.885c-3.491,5.141-4.827,13.661-4.827,13.661s8.845-2.155,12.853-7.072S162.811,88.7,162.811,88.7,156.548,87.743,153.057,92.885Zm9.62,14.682c5.882,2,6.634,8.284,6.634,8.284s-5.04,3.749-10.843,1.2-10.237-10.507-10.237-10.507S156.795,105.569,162.677,107.567Z",
    transform: "translate(113.907 -68.696)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362-2",
    "data-name": "Path 362",
    d: "M348.08,173.383c1.5-6.039-.191-14.491-.191-14.491s-7.554,5.085-9.609,11.079,2.1,10.709,2.1,10.709S346.587,179.411,348.08,173.383Zm-14.132-10.45c-6.219.157-9.092-5.478-9.092-5.478s3.435-5.264,9.766-4.883,13.234,6.32,13.234,6.32S340.189,162.764,333.948,162.933Z",
    transform: "translate(-263.747 -60.865)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363-2",
    "data-name": "Path 363",
    d: "M179.339,105.345c6.14-.943,13.3-5.747,13.3-5.747s-7.611-5.029-13.93-4.613-9.081,6.05-9.081,6.05S173.188,106.277,179.339,105.345Zm4.221-17.04c-2.537-5.613,1.572-10.5,1.572-10.5s6.174,1.122,8.25,7.139-.741,14.592-.741,14.592-6.544-5.568-9.081-11.236Z",
    transform: "translate(65.051 -70.021)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364-2",
    "data-name": "Path 364",
    d: "M91.959,191.743c-5.994-1.628-14.491-.123-14.491-.123s4.917,7.667,10.866,9.856S99.087,199.6,99.087,199.6,97.953,193.37,91.959,191.743ZM81.206,205.594c0,6.219-5.68,8.98-5.68,8.98s-5.186-3.558-4.67-9.867,6.612-13.1,6.612-13.1S81.172,199.409,81.206,205.594Z",
    transform: "translate(271.023 -56.157)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365-2",
    "data-name": "Path 365",
    d: "M350.292,80.136c.1,6.207,3.9,13.953,3.9,13.953s6.005-6.847,6.454-13.167S355.87,71.1,355.87,71.1,350.179,73.929,350.292,80.136Zm16.31,6.5c5.96-1.751,10.192,2.975,10.192,2.975s-1.987,5.96-8.194,7.206-14.413-2.728-14.413-2.728S360.641,88.375,366.6,86.635Z",
    transform: "translate(-320.388 -70.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366-2",
    "data-name": "Path 366",
    d: "M104.578,232.5a7.307,7.307,0,0,1,5.725,3.884c1.762,3.614.629,9.283.629,9.283s-4.49-3.053-6.555-6.432a6.668,6.668,0,0,1,.2-6.735Z",
    transform: "translate(222.069 -51.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367-2",
    "data-name": "Path 367",
    d: "M104.578,232.5a7.307,7.307,0,0,1,5.725,3.884c1.762,3.614.629,9.283.629,9.283s-4.49-3.053-6.555-6.432a6.668,6.668,0,0,1,.2-6.735Z",
    transform: "translate(222.069 -51.072)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-2",
    "data-name": "Path 368",
    d: "M274.36,252.52a7.308,7.308,0,0,1,5.736,3.873c1.751,3.614.628,9.283.628,9.283s-4.49-3.053-6.567-6.432A6.656,6.656,0,0,1,274.36,252.52Z",
    transform: "translate(-138.302 -48.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-2",
    "data-name": "Path 369",
    d: "M274.36,252.52a7.308,7.308,0,0,1,5.736,3.873c1.751,3.614.628,9.283.628,9.283s-4.49-3.053-6.567-6.432A6.656,6.656,0,0,1,274.36,252.52Z",
    transform: "translate(-138.302 -48.619)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370-2",
    "data-name": "Path 370",
    d: "M76.717,333.55a7.308,7.308,0,0,1,5.725,3.884c1.762,3.614.629,9.283.629,9.283s-4.49-3.053-6.555-6.432A6.735,6.735,0,0,1,76.717,333.55Z",
    transform: "translate(281.192 -38.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-2",
    "data-name": "Path 371",
    d: "M76.717,333.55a7.308,7.308,0,0,1,5.725,3.884c1.762,3.614.629,9.283.629,9.283s-4.49-3.053-6.555-6.432A6.735,6.735,0,0,1,76.717,333.55Z",
    transform: "translate(281.192 -38.693)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-2",
    "data-name": "Path 372",
    d: "M277.55,164.08a7.308,7.308,0,0,1,6.915.292c3.367,2.155,5.41,7.566,5.41,7.566s-5.467-.213-8.98-2.032A6.645,6.645,0,0,1,277.55,164.08Z",
    transform: "translate(-151.819 -59.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-2",
    "data-name": "Path 373",
    d: "M277.55,164.08a7.308,7.308,0,0,1,6.915.292c3.367,2.155,5.41,7.566,5.41,7.566s-5.467-.213-8.98-2.032A6.645,6.645,0,0,1,277.55,164.08Z",
    transform: "translate(-151.819 -59.543)",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 157.46,
    cy: 13.657,
    rx: 157.46,
    ry: 13.657,
    transform: "translate(202.078 887.957)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlight--inject-734",
    transform: "translate(1266.314 532.578)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M443.671,473.923H432.93l1.6-272.393h7.521Z",
    transform: "translate(-425.344 -165.127)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M447.166,202.469H429.723L427.54,176.84h21.809Z",
    transform: "translate(-425.837 -167.387)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M445.019,202.469H431.462L429.77,176.84h16.941Z",
    transform: "translate(-425.633 -167.387)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 25.356,
    height: 4.268,
    transform: "translate(0 7.095)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 21.361,
    height: 5.272,
    transform: "translate(1.987 32.299)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 18.229,
    height: 2.849,
    transform: "translate(3.416 4.246)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 3.133,
    height: 4.268,
    transform: "translate(10.555)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 18.905,
    height: 22.944,
    transform: "translate(3.711 292.499)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M383.75,174.075s.777-13.126-5.412-20.506-15.478-1.928-23.979-3.867,1.928-12.368-11.611-20.112-23.979.394-26.251,8.905-3.483,11.6-11.217,8.077-15.084,1.161-15.084,7.734,2.706,11.6-6.189,10.44-17.023,1.161-18.567,4.644,7.734,4.251-4.644,4.251-18.557,2.322-19.335,4.261-11.217,2.322-17.013,3.09-6.967,1.939-6.967,1.939H399.218s.384-4.644-5.412-6.189S389.555,177.165,383.75,174.075Z",
    transform: "translate(-97.48 60.342)",
    fill: "#f0f0f0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M354.482,171.728s.641-12.478-4.459-19.495-12.753-1.833-19.758-3.676,1.589-11.758-9.567-19.12-19.758.374-21.63,8.466-2.87,11.029-9.243,7.679-12.429,1.1-12.429,7.353,2.23,11.029-5.1,9.925-14.026,1.1-15.3,4.415,6.373,4.041-3.827,4.041-15.291,2.208-15.931,4.051S228,177.573,223.22,178.3s-5.74,1.843-5.74,1.843H367.227a5.914,5.914,0,0,0-4.459-5.884C357.993,172.793,359.266,174.665,354.482,171.728Z",
    transform: "translate(748.264 63.125)",
    fill: "#f0f0f0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-587",
    transform: "translate(1233.477 162.479)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M297.485,152.3s.943-15.986-6.579-24.922-18.815-2.336-29.143-4.693,2.336-15-14.1-24.45-29.165.471-31.972,10.822-4.286,14.1-13.629,9.857-18.343,1.414-18.343,9.407,3.279,14.1-7.522,12.707-20.679,1.393-22.565,5.636,9.407,5.164-5.636,5.164-22.565,2.829-23.572,5.164-13.65,2.829-20.7,3.772-8.464,2.357-8.464,2.357H316.3s.45-5.657-6.6-7.522S304.535,156.072,297.485,152.3Z",
    transform: "translate(-95.26 -94.438)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M297.485,152.3s.943-15.986-6.579-24.922-18.815-2.336-29.143-4.693,2.336-15-14.1-24.45-29.165.471-31.972,10.822-4.286,14.1-13.629,9.857-18.343,1.414-18.343,9.407,3.279,14.1-7.522,12.707-20.679,1.393-22.565,5.636,9.407,5.164-5.636,5.164-22.565,2.829-23.572,5.164-13.65,2.829-20.7,3.772-8.464,2.357-8.464,2.357H316.3s.45-5.657-6.6-7.522S304.535,156.072,297.485,152.3Z",
    transform: "translate(-95.26 -94.438)",
    fill: "#f0f0f0",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-758",
    transform: "translate(1339.922 633.141)",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 101.13,
    cy: 8.903,
    rx: 101.13,
    ry: 8.903,
    transform: "translate(0 220.831)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M307.6,334.06s-6.81,20.934-4.7,41.867",
    transform: "translate(-62.055 -219.436)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M169.468,334.06s-6.81,20.934-4.708,41.867",
    transform: "translate(-65.599 -219.436)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M170.778,433.04s-4.872-41.714-4.872-53.4-3.569-13.631-6.01-13.334-17.682,7.467-18.462,20.616,8.431,37.16,5.518,42.678-12.667,6.492-14.287-4.1,8.605-7.795,8.923-4.1-2.1,6.821-3.887,4.872",
    transform: "translate(-66.417 -218.609)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M151.97,341.082H316.527l8.626-37.252H160.586Z",
    transform: "translate(-65.917 -220.212)",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M148.21,341.082H312.767l8.626-37.252H156.826Z",
    transform: "translate(-66.014 -220.212)",
    fill: "#f0f0f0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M150.63,330.085H315.187l3.662-15.8H154.281Z",
    transform: "translate(-65.952 -219.943)",
    fill: "#f0f0f0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M308.958,433.04s-4.872-41.714-4.872-53.4-3.569-13.631-6-13.334-17.693,7.467-18.462,20.616,8.441,37.16,5.518,42.678-12.657,6.492-14.287-4.1,8.605-7.795,8.933-4.1-2.113,6.821-3.9,4.872",
    transform: "translate(-62.871 -218.609)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M217.032,273.225a14.494,14.494,0,0,0-4.862,0c-2.051.482-4.39,2.677-4.39,10.462s2.051,34.452,2.677,42.852-.482,33.713-.482,33.713-5.354,1.21-9.857,2.051-4.749,3.539-4.749,3.539,16.913.728,18.134.236,1.344-3.159,2.051-6.564.123-26.667,1.7-34.811,1.456-26.3,2.308-34.206.369-14.728-.482-16.072A2.339,2.339,0,0,0,217.032,273.225Z",
    transform: "translate(-64.804 -221.002)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M229.548,229.859s-7.067-7.3-14.729-7.549-8.523,6.574-5.723,12.41,5.477,8.646-2.677,8.892-10.349-6.092-20.575-2.687-6.687,13.272-10.339,14.852-6.821-1.333-5.6-3.528,3.077-.851,2.913.123-.482,1.949.369,1.221.851-2.441,0-4.267-6.082-1.333-8.4,1.7-3.077,11.446,6.092,15.221,14.841,2.185,22.39-.851,12.657-1.826,16.072,1.7,3.405,5.231,10.954,6.81,22.267-.236,27.621-8.882-7.057-28.965-11.19-32.493S229.548,229.859,229.548,229.859Z",
    transform: "translate(-65.627 -222.304)",
    fill: "#f0f0f0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M225.789,231.846s-8.4-7.672-11.518-4.1,7.18,12.236,2.4,19.672-9.354,4.8-20.144,2.4-15.385-3.077-17.272,4.79-15.108,9.6-15.385-1.918",
    transform: "translate(-65.612 -222.188)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M230.168,238s-10.554,4.1-9.354,10.8-2.626,12.975-11.036,12.5-19.19-10.082-24.226-6.964-2.39,12.452-14.862,11.508",
    transform: "translate(-65.437 -221.901)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M199.92,262.615s2.636-2.4,7.672.236,10.687,7.846,20.934,1.169",
    transform: "translate(-64.687 -221.295)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M240.226,364.786h-23.98c-3.528,0-11.282-.246-11.282-.246s-7.3,26.534-9.61,37.949-3.774,21.662-3.651,22.565,2.677,3.077,2.185,7.795a93.544,93.544,0,0,0-.123,11.559l-1.333.605-1.344-.236L190,440.387s-.974,4.021-1.344,5.846-3.077,4.021-5.723,4.872-12.052,1.333-13.508.728,5.846-6.821,6.328-7.549,7.3-11.2,7.8-17.159,1.579-60.616,1.579-64.76.482-13.016,4.01-17.036,7.918-2.051,11.2-.482,19.959,13.99,28.236,16.308S241.2,364.294,240.226,364.786Z",
    transform: "translate(-65.474 -219.208)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M227.4,360.747a35.1,35.1,0,0,1-6.3-2.7l-2.051,2.256a20.576,20.576,0,0,1-5.61,4.1h25.641C240.066,363.906,235.676,363.055,227.4,360.747Z",
    transform: "translate(-64.34 -218.821)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M194.462,361.632c-5.415-.3-8.1.462-9.385,1.118-.092,8.205-1.108,58.186-1.569,63.878-.492,5.959-7.3,16.411-7.8,17.159s-7.785,6.934-6.328,7.549,10.831.123,13.508-.728,5.354-3.077,5.723-4.872,1.344-5.846,1.344-5.846l1.087,4.39,1.344.236,1.333-.605a93.527,93.527,0,0,1,.123-11.559c.492-4.749-2.051-6.944-2.185-7.8s1.333-11.077,3.651-22.564,9.58-37.929,9.58-37.929S203.467,362.114,194.462,361.632Z",
    transform: "translate(-65.475 -218.73)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M222.553,265.657s2.308,2.923,1.826,5.723-4.38,2.318-6.451,2.051-2.8.359-4.257,3.774-2.051,7.662-2.923,12.78-4.021,8.636-2.051,13.508,10.328,12.934,10.328,13.652a105.508,105.508,0,0,1-2.554,13.4c-1.292,4.739-6.215,12.554-6.574,17.682s8.031,11.693,19.713,14.482,15.385.615,20.205-3.159,4.626-11.805,4.021-19.108-8.892-21.426-9.128-24.462,2.308-16.8,3.774-26.052-1.508-16.841-5.969-18.626-9.005.369-10.1-.974.492-10.954.492-10.954Z",
    transform: "translate(-64.478 -221.353)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M253.837,340.118c-.615-7.3-8.892-21.426-9.128-24.462a43.847,43.847,0,0,1,.687-7.057h-.082c-5.959,0-10.472-3.159-11.077-5.836s-1.456-14.246,1.58-22.154c2.267-5.887,4.462-8.872,5.436-10.021a11.724,11.724,0,0,0-2.051-.328c-5.446,6.431-9.877,22.277-9.877,22.277l-16.79-1.026s2.923-11.282,4.1-14.728a12.2,12.2,0,0,1,1.99-3.569l-.769-.082c-2.051-.246-2.8.359-4.256,3.774s-2.051,7.662-2.923,12.78-4.021,8.636-2.051,13.508,10.4,12.954,10.4,13.672a105.509,105.509,0,0,1-2.554,13.4c-1.292,4.739-6.215,12.554-6.574,17.682s8.031,11.693,19.713,14.482,15.385.615,20.205-3.159S254.442,347.42,253.837,340.118Z",
    transform: "translate(-64.48 -221.073)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M221.36,309.17a24.449,24.449,0,0,0,9.61,4.39",
    transform: "translate(-64.137 -220.075)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M246.778,339.061s-13.631-5.713-34.319-7.426S185.68,329.7,184.1,331.4s-8.4,17.436-8.4,17.436l11.282,6.328s5.231-5.241,6.687-9.621c0,0,12.421,7.3,20.329,12.9s27.385,8.4,32.821,5.477,8.646-10.708,7.18-17.529",
    transform: "translate(-65.308 -219.534)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M184.07,331.4c-1.58,1.7-8.4,17.436-8.4,17.436l11.282,6.328s5.231-5.241,6.687-9.621c0,0,12.421,7.3,20.329,12.9a26.245,26.245,0,0,0,5.713,2.913c2.605-2.257,5.795-6.451,6.092-13.5a22.031,22.031,0,0,0-5.385-15.3c-2.533-.349-5.2-.656-8-.892C191.732,329.932,185.65,329.7,184.07,331.4Z",
    transform: "translate(-65.309 -219.534)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M226.542,231.433a7.436,7.436,0,0,0-6.892,3.077c-3.077,3.826-7.651,14.544-7.949,17.436s2.133,11.477,2.595,13.928,4.595,3.672,5.662,3.21a83.645,83.645,0,0,1,8.267-4.277c4.441-1.836,7.344-4.595,8.872-8.267s3.682-14.7-1.221-20.513S226.542,231.433,226.542,231.433Z",
    transform: "translate(-64.385 -222.072)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M216.18,241.212s1.7-2.195,3.733-.81",
    transform: "translate(-64.27 -221.851)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M223.61,241.187s3.815-1.7,6.328,3.241",
    transform: "translate(-64.079 -221.826)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M219.292,244.56s-.462,1.528-2.913,2.9-2.9.769-1.836,1.99a3.313,3.313,0,0,0,2.3,1.231",
    transform: "translate(-64.326 -221.733)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M215.28,253.36a8.277,8.277,0,0,0,6.267,0",
    transform: "translate(-64.293 -221.507)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 2.123,
    y2: 2.862,
    transform: "translate(158.813 22.366)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M227.967,248.194s-5.815-.769-6.277-2.144",
    transform: "translate(-64.128 -221.694)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 1.528,
    y2: 2.523,
    transform: "translate(149.756 21.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M217.316,246.373a3.805,3.805,0,0,1-3.826-.923",
    transform: "translate(-64.339 -221.71)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M238.093,297.133a163.316,163.316,0,0,0,3.169,24.124c2.677,12.544,11.805,41.755,12.164,42.965s3.077,2.923,6.7,3.077,17.528.123,17.528.123-2.195-2.8-3.774-5.231-4.257-2.051-6.451-1.344-6.574,1.579-7.549.615-1.7-2.051-3.774-12.9-4.256-30.77-4.256-42.729.851-21.18-2.195-28.842-9.128-6.154-11.682-4.995",
    transform: "translate(-63.711 -221.053)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M273.6,360.129c-1.579-2.441-4.256-2.051-6.451-1.344s-6.574,1.579-7.549.615-1.579-1.9-3.282-10.431l-6.574,2.082c1.836,6.154,3.251,10.636,3.385,11.1.369,1.221,3.077,2.923,6.7,3.077s17.528.123,17.528.123S275.156,362.56,273.6,360.129Z",
    transform: "translate(-63.409 -219.053)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M267.455,360.69s1.7,1.21,5.354.482,6.574-1.7,5.6.369-2.308,2.431-4.749,2.8c0,0-5.713.123-8.39.123",
    transform: "translate(-63.01 -218.763)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 183.388,
    height: 4.062,
    transform: "translate(61.345 144.645)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 48.524,
    height: 4.062,
    transform: "translate(196.219 144.645)",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M177.2,341s3.077.359,8.031,3.9,8.759,8.513,8.277,9.487-26.411,32.36-30.575,40.76a121.788,121.788,0,0,1-7.18,13.262c-1.456,2.318-5.231,5.354-6.7,6.451s-3.528,2.554-3.528,2.554l-1.21-.851L147.723,410s-7.672-1.467-10.954-4.39-9.98-14.359-10.831-16.308.123-4.1,1.21-3.651,3.292,5.477,10.718,7.18,12.041,2.677,12.041,2.677,1.59-.123,4.995-5.713S177.2,341,177.2,341Z",
    transform: "translate(-66.593 -219.258)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M183.931,299.93a42.441,42.441,0,0,0-6.821,8.092l9.446,5.918c.492-2.462,1.939-5.58,5.477-8.985Z",
    transform: "translate(-65.272 -220.312)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M200.348,291c-2.636,1.108-5.19,2.226-7.508,3.323l6.021,5.436.338-.215q2.821-1.682,5.559-3.18Z",
    transform: "translate(-64.869 -220.541)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M216.238,284.28c-2.215,1.026-4.79,2.133-7.508,3.262l5.128,4.041c2.349-1.19,4.585-2.287,6.667-3.323Z",
    transform: "translate(-64.461 -220.713)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M234.673,279.863l-7.108-4.1a35.419,35.419,0,0,1-3.426,3.518l5.733,4.051A22.091,22.091,0,0,0,234.673,279.863Z",
    transform: "translate(-64.065 -220.932)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M232.957,266.74a4.1,4.1,0,0,1-.226,3.9c-1.774,2.892-5.61,8.339-11.077,11.7-7.723,4.759-29.283,11.6-36.124,17.1a42.052,42.052,0,0,0-10.41,12.944l11.9,7.877s-4.9-9.662,12.636-20.072,33.6-16.062,36.924-20.811,2.677-9.375,1.631-10.708-5.2-1.928-5.2-1.928Z",
    transform: "translate(-65.323 -221.163)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M183.931,299.93a42.441,42.441,0,0,0-6.821,8.092l9.446,5.918c.492-2.462,1.939-5.58,5.477-8.985Z",
    transform: "translate(-65.272 -220.312)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M200.348,291c-2.636,1.108-5.19,2.226-7.508,3.323l6.021,5.436.338-.215q2.821-1.682,5.559-3.18Z",
    transform: "translate(-64.869 -220.541)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M216.238,284.28c-2.215,1.026-4.79,2.133-7.508,3.262l5.128,4.041c2.349-1.19,4.585-2.287,6.667-3.323Z",
    transform: "translate(-64.461 -220.713)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M234.673,279.863l-7.108-4.1a35.419,35.419,0,0,1-3.426,3.518l5.733,4.051A22.091,22.091,0,0,0,234.673,279.863Z",
    transform: "translate(-64.065 -220.932)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M225.6,267.76s1.026,5.723-10.769,7.056-22.031-7.056-32.257-2.308S171.7,284.417,164.19,291.74s-17.518,8.636-19.959,8.759,5.846,7.3,6.821,7.3,12.164.492,19.488-7.057,10.257-18.626,19.488-22.031,20.934,2.051,28.236-.605S227.361,272.868,225.6,267.76Z",
    transform: "translate(-66.127 -221.137)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M189.082,278.628c.349-.133.708-.215,1.026-.328l-4.287-7.18a15.581,15.581,0,0,0-4.195,1.262c-.8.369-1.518.759-2.205,1.159l5.662,7.231A15.988,15.988,0,0,1,189.082,278.628Z",
    transform: "translate(-65.213 -221.051)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M165.654,303.658l-6.708-8.718a34.024,34.024,0,0,1-9.036,3.836l7.508,7.795a26.472,26.472,0,0,0,8.236-2.913Z",
    transform: "translate(-65.97 -220.44)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M172.938,296.83c1.7-2.267,3.2-4.677,4.708-7.005l-6.974-7.385a64.19,64.19,0,0,1-5.241,7.036Z",
    transform: "translate(-65.572 -220.761)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M202.023,277.855l-.7-4.41c-1.836-.451-3.651-.954-5.436-1.385l2.38,5.457C199.531,277.588,200.782,277.711,202.023,277.855Z",
    transform: "translate(-64.79 -221.027)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M226.3,224.254s-2.195,11.682.123,18.739,5.723,10.954,5.723,17.652-4.39,10.585-9.375,11.077-12.175-.246-18.985,5.477-4.1,11.928-1.1,13.139,4.626-.113,4.626-.113A2.933,2.933,0,0,1,205,286.685c.615-2.913,2.051-5.231,12.657-4.985s23.252-4.1,34.575-10.349,5.836-24.093,1.826-32.493-18.626-14.975-23.006-16.072S226.3,224.254,226.3,224.254Z",
    transform: "translate(-64.697 -222.298)",
    fill: "#f0f0f0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M246.313,230.32s13.918,23.744,4.318,34.77-19.416,7.18-31.8,10.441-13.8,8.513-13.8,9.231",
    transform: "translate(-64.556 -222.098)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M233.63,224.24s-2.882,8.626,5.508,20.38,2.4,24.944-3.59,26.862a114.719,114.719,0,0,1-12.718,3.077",
    transform: "translate(-64.099 -222.254)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M224.47,236.4s1.436,8.626,6.472,15.385,5.6,17.262.523,19.672",
    transform: "translate(-64.057 -221.942)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M194.462,361.632c-5.415-.3-8.1.462-9.385,1.118-.092,8.205-1.108,58.186-1.569,63.878-.492,5.959-7.3,16.411-7.8,17.159s-7.785,6.934-6.328,7.549,10.831.123,13.508-.728,5.354-3.077,5.723-4.872,1.344-5.846,1.344-5.846l1.087,4.39,1.344.236,1.333-.605a93.527,93.527,0,0,1,.123-11.559c.492-4.749-2.051-6.944-2.185-7.8s1.333-11.077,3.651-22.564,9.58-37.929,9.58-37.929S203.467,362.114,194.462,361.632Z",
    transform: "translate(-65.475 -218.73)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M204,364.186a42.582,42.582,0,0,0,.851-7.426",
    transform: "translate(-64.582 -218.854)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M323.742,430.507l11.33-6.027,11.33,6.027,11.33-6.027,11.315,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.345,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.33,6.027,11.33-6.027,11.345,6.027",
    transform: "translate(1273.863 411.857)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-587",
    transform: "translate(258 635.141)",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M279.424,367s8.026,4.766,11.287,6.772,8.568,4.264,6.561,5.749-11.287,1.5-14.547,1-9.782-.5-13.293-1-1-4.515-1-7.023a9.781,9.781,0,0,1,1.5-4.766Z",
    transform: "translate(-220.617 -125.996)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M297.29,377.846c.552.6.652,1.164,0,1.645-2.007,1.5-11.287,1.5-14.548,1s-9.782-.5-13.293-1c-2.007-.291-2.007-1.736-1.706-3.381,1.776.261,5.287.753,12.742,1.876C288.732,379.23,294.27,378.548,297.29,377.846Z",
    transform: "translate(-220.685 -125.966)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M328.787,171.738s7.274,6.02,6.02,12.039-6.02,24.329-6.27,29.847-1,13.293-1,13.293l-8.026,2.508s-1.214-11.538-1.214-13.273.251-4.264.251-4.264-10.284,5.769-12.792,7.023-7.023,5.518-7.023,5.518a70.863,70.863,0,0,1,1.5,11.287,38.128,38.128,0,0,0,1.254,8.779s20.065,37.623,24.329,45.9,2.257,12.541,1.5,13.8S306,342.064,302.993,351.344s-4.264,14.046-4.264,14.046,1.254.251,1.254,1.254a19.375,19.375,0,0,0,.251,2.508,9.872,9.872,0,0,1-3.261,1c-1.254,0-7.775-.251-7.775-.251s10.033-43.642,11.788-53.424a66.686,66.686,0,0,1,6.521-18.31s-34.111-33.108-43.392-41.887-14.8-13.8-13.544-24.079,13.293-23.326,13.293-23.326,7.735-18.811,14.758-26.838,19.564-10.284,28.342-11.788S323.309,168.728,328.787,171.738Z",
    transform: "translate(-240.634 -126.643)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M250.4,219.935a80.786,80.786,0,0,1,8.317-11.036s7.775-18.831,14.8-26.858,19.564-10.284,28.342-11.788,16.3-1.5,21.821,1.5c0,0,7.274,6.02,6.02,12.039s-6.02,24.329-6.27,29.847-1,13.293-1,13.293l-8.026,2.508s-1.214-11.558-1.214-13.293.251-4.264.251-4.264-10.284,5.769-12.792,7.023-7.023,5.518-7.023,5.518a70.874,70.874,0,0,1,1.5,11.287v.492c-3.592,1.936-10.966,4.113-23.587.512C259.515,233.269,253.525,225.885,250.4,219.935Z",
    transform: "translate(-235.521 -126.643)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M259.79,211.788s1.5.5,2.257-5.016,2.007-9.029,4.766-12.792",
    transform: "translate(-181.92 -126.562)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M287.652,229.19a4.756,4.756,0,0,0-3.6,2.609,19.061,19.061,0,0,0-1.605,4.806l1-.8-1.2,3.812a61.932,61.932,0,0,1-11.217-8.026c-4.615-4.414-7.414-5.217-9.822-5.217s-17.437,1-19.243.8-5.809-2.408-6.411.2,2.207,4.645,5.628,6.652,10.033.8,12.039.6a17.489,17.489,0,0,1,4.2.2s8.618,6.21,13.634,13.424,10.615,13.635,14.628,12.631,8.217-6.21,8.819-6.21,5.408.2,7.214-3.411a27.166,27.166,0,0,0,2.2-5.408",
    transform: "translate(-194.623 -126.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(40.847 99.654)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M287.652,229.19a4.756,4.756,0,0,0-3.6,2.609,19.061,19.061,0,0,0-1.605,4.806l1-.8-1.2,3.812a61.932,61.932,0,0,1-11.217-8.026c-4.615-4.414-7.414-5.217-9.822-5.217s-17.437,1-19.243.8-5.809-2.408-6.411.2,2.207,4.645,5.628,6.652,10.033.8,12.039.6a17.489,17.489,0,0,1,4.2.2s8.618,6.21,13.634,13.424,10.615,13.635,14.628,12.631,8.217-6.21,8.819-6.21,5.408.2,7.214-3.411a27.166,27.166,0,0,0,2.2-5.408",
    transform: "translate(-235.47 -226.111)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M287.652,229.19a4.756,4.756,0,0,0-3.6,2.609,19.061,19.061,0,0,0-1.605,4.806l1-.8-1.2,3.812a61.932,61.932,0,0,1-11.217-8.026c-4.615-4.414-7.414-5.217-9.822-5.217s-17.437,1-19.243.8-5.809-2.408-6.411.2,2.207,4.645,5.628,6.652,10.033.8,12.039.6a17.489,17.489,0,0,1,4.2.2s8.618,6.21,13.634,13.424,10.615,13.635,14.628,12.631,8.217-6.21,8.819-6.21,5.408.2,7.214-3.411a27.166,27.166,0,0,0,2.2-5.408",
    transform: "translate(-194.623 -126.457)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M223.506,334.677a73.869,73.869,0,0,1-5.016,7.816,59.554,59.554,0,0,1-7.214,8.026s3.6,5.809,6.812,10.615,4.2,5.418,2.007,6.812-7.224,9.22-9.421,11.227-8.417,2.207-8.417,2.207-4.013-.8-3.21-2.809a4.525,4.525,0,0,1,4.013-2.609c1,0,3.6-.2,4.4-.793s5.016-5.217,5.608-6.622-5.408-6.411-8.809-11.819-6.421-5.809-3.812-13.825S221.9,329.259,223.506,334.677Z",
    transform: "translate(-77.564 -126.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(121.376 206.425)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M223.506,334.677a73.869,73.869,0,0,1-5.016,7.816,59.554,59.554,0,0,1-7.214,8.026s3.6,5.809,6.812,10.615,4.2,5.418,2.007,6.812-7.224,9.22-9.421,11.227-8.417,2.207-8.417,2.207-4.013-.8-3.21-2.809a4.525,4.525,0,0,1,4.013-2.609c1,0,3.6-.2,4.4-.793s5.016-5.217,5.608-6.622-5.408-6.411-8.809-11.819-6.421-5.809-3.812-13.825S221.9,329.259,223.506,334.677Z",
    transform: "translate(-198.94 -332.533)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M223.506,334.677a73.869,73.869,0,0,1-5.016,7.816,59.554,59.554,0,0,1-7.214,8.026s3.6,5.809,6.812,10.615,4.2,5.418,2.007,6.812-7.224,9.22-9.421,11.227-8.417,2.207-8.417,2.207-4.013-.8-3.21-2.809a4.525,4.525,0,0,1,4.013-2.609c1,0,3.6-.2,4.4-.793s5.016-5.217,5.608-6.622-5.408-6.411-8.809-11.819-6.421-5.809-3.812-13.825S221.9,329.259,223.506,334.677Z",
    transform: "translate(-77.564 -126.108)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M192.222,232.246s1.8,4.806.6,7.414-2.809,5.016-3.21,8.026,1.806,23.246,3.01,33.469,7.214,20.637,11.417,25.082,5.207,5.418,5.207,5.418,11.628,3.01,16.835,8.217,7.214,8.618,12.039,10.033a15.3,15.3,0,0,0,14.046-3.6,60.2,60.2,0,0,0,4.254-4.7c.371-.462.552-.712.552-.712v2.237s6.622-5.247,6.622-4.013a34.229,34.229,0,0,1-.592,4.2s3.2-3.6,3.2-2.007.2,9.029,0,9.611,1.4-.4,1.4,1-1,5.809-4.806,10.424-16.273,11.086-27.721,7.725-12.22-17.236-14.628-22.243S210,321.026,210,321.026s-1.2,11.819-6.812,17.056-16.052,9.621-18.631,13.635.793,11.618,1.395,12.621,5.618,5.809,4.013,7.816-11.628,11.227-15.049,13.424-8.217,2.408-9.421,2.809-11.819.2-11.819-2.408,2.4-3.8,6.612-4.806,8.217,1.605,9.812.6,8.819-7.023,9.421-9.029-.8-9.029-5.016-12.621-15.049-9.22-13.624-24.249,6.411-22.453,6.411-22.453-7.023-14.046-16.052-22.072S140.2,271.916,140.2,271.916l-1,2.207-.8-6.822-1.194,1.2-.4-3.4s-2.609-14.828-.2-24.65,6.21-13.043,6.21-13.043L140.6,228l4.816-2.8-.6-.8s3.4-2.408,5.016-2.608,6.812-1.605,6.812-1.605-2.8-.592-2.207-.592,6.22-1.4,6.22-1.4l2.4-.2s4.615.6,11.829,5.207a153.1,153.1,0,0,0,17.337,9.05Z",
    transform: "translate(-58.099 -126.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(77.481 91.507)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0.419 7.503)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M220.362,339.372c-5.518,0-7.525-11.036-16.554-19.062s-23.075-11.538-29.6-21.069-10.033-27.59-13.043-36.619,3.01-14.547,4.013-23.577-3.01-8.026-7.525-11.036,3.511-2.508,3.511-2.508,1.364.231,3.01.462c6.24,3.471,12.611,6.28,12.611,6.28s1.8,4.806.6,7.414-2.809,5.016-3.21,8.026,1.806,23.246,3.01,33.469,7.214,20.637,11.417,25.082,5.207,5.418,5.207,5.418,11.628,3.01,16.835,8.217,7.214,8.618,12.039,10.033a14.588,14.588,0,0,0,8.718-.421C227.014,334.616,222.861,339.372,220.362,339.372Z",
    transform: "translate(-120.567 -225.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M246.164,268.4l-.4-3.4s-.552-3.11-.913-7.424c1.665-1.515,3.18-2.588,4.013-2.588,2.508,0,14.046-.5,14.046-.5l3.923.07s-2.92,11.969-4.926,12.471-6.521,1-6.521,1,1.5,1-4.013,3.01a9.029,9.029,0,0,1-3.471.482l-.512-4.324Z",
    transform: "translate(-244.85 -225.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M199.481,380.807c4.2-1,8.217,1.605,9.812.6s8.819-7.023,9.421-9.029a10.524,10.524,0,0,0-.431-4.816c2.1-.431,2.779-1.9,2.007-5.458-1.5-6.521-9.029-14.046-2.007-15.551s14.547-9.531,19.564-15.049,6.02-13.043,11.377-10.825c0,0-1.2,11.819-6.812,17.056s-16.052,9.621-18.631,13.634.793,11.618,1.395,12.621,5.618,5.809,4.013,7.815-11.628,11.227-15.049,13.424-8.217,2.408-9.421,2.809-11.819.2-11.819-2.408S195.268,381.811,199.481,380.807Z",
    transform: "translate(-175.122 -225.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M135.62,328.486a49.4,49.4,0,0,1,3.371,4.535c5.016,7.525,10.033,14.046,25.583,10.033,10.544-2.719,15.049-14.658,14.889-21.912.742-.622,1.435-1,1.435-.251,0,1.6.2,9.029,0,9.611s1.4-.4,1.4,1-1,5.809-4.806,10.424-16.233,11.177-27.68,7.815C139.091,346.535,137.777,334.124,135.62,328.486Z",
    transform: "translate(-50.733 -225.158)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M192.222,232.246s1.8,4.806.6,7.414-2.809,5.016-3.21,8.026,1.806,23.246,3.01,33.469,7.214,20.637,11.417,25.082,5.207,5.418,5.207,5.418,11.628,3.01,16.835,8.217,7.214,8.618,12.039,10.033a15.3,15.3,0,0,0,14.046-3.6,60.2,60.2,0,0,0,4.254-4.7c.371-.462.552-.712.552-.712v2.237s6.622-5.247,6.622-4.013a34.229,34.229,0,0,1-.592,4.2s3.2-3.6,3.2-2.007.2,9.029,0,9.611,1.4-.4,1.4,1-1,5.809-4.806,10.424-16.273,11.086-27.721,7.725-12.22-17.236-14.628-22.243S210,321.026,210,321.026s-1.2,11.819-6.812,17.056-16.052,9.621-18.631,13.635.793,11.618,1.395,12.621,5.618,5.809,4.013,7.816-11.628,11.227-15.049,13.424-8.217,2.408-9.421,2.809-11.819.2-11.819-2.408,2.4-3.8,6.612-4.806,8.217,1.605,9.812.6,8.819-7.023,9.421-9.029-.8-9.029-5.016-12.621-15.049-9.22-13.624-24.249,6.411-22.453,6.411-22.453-7.023-14.046-16.052-22.072S140.2,271.916,140.2,271.916l-1,2.207-.8-6.822-1.194,1.2-.4-3.4s-2.609-14.828-.2-24.65,6.21-13.043,6.21-13.043L140.6,228l4.816-2.8-.6-.8s3.4-2.408,5.016-2.608,6.812-1.605,6.812-1.605-2.8-.592-2.207-.592,6.22-1.4,6.22-1.4l2.4-.2s4.615.6,11.829,5.207a153.1,153.1,0,0,0,17.337,9.05Z",
    transform: "translate(-58.099 -126.483)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M240.516,232.252l.846,3.572a69.658,69.658,0,0,1-17.6-5.293c-8.417-4.013-16.334-8.28-16.525-10.477s3.821-3.834,3.821-3.834,14.437,9.621,20.246,12.421a50.314,50.314,0,0,0,9.21,3.612Z",
    transform: "translate(-106.393 -126.489)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M213.477,182.069s4.615,4.615,8.618,5.418,15.049.6,19.243,9.411,1.4,24.249-1.4,28.463-2.007,7.023-3.411,7.815-14.628-4.013-22.243-8.819-9.812-4.806-10.033-7.615,2.007-4.414,3.6-5.809,2.809-2.609,2.007-3.01-6.02-2.207-7.214-3.8.2-5.418,2.007-5.016,9.029,2.609,9.029,2.609-8.819-3.812-10.414-9.621a11.879,11.879,0,0,1,2.8-11.819C208.069,178.066,211.882,180.073,213.477,182.069Z",
    transform: "translate(-100.804 -126.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(101.393 52.699)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M229.214,219.72a19.273,19.273,0,0,1-2.127,5.508c-2.809,4.2-2.007,7.023-3.411,7.815s-12.3-3.18-20.065-7.5a20.652,20.652,0,0,1,2.809,0s6.02,1,8.026,1,4.013-3.511,4.013-3.511-1,5.016,1,6.02,4.013-3.01,7.525-6.521A18.51,18.51,0,0,0,229.214,219.72Z",
    transform: "translate(-189.35 -179.177)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M213.477,182.069s4.615,4.615,8.618,5.418,15.049.6,19.243,9.411,1.4,24.249-1.4,28.463-2.007,7.023-3.411,7.815-14.628-4.013-22.243-8.819-9.812-4.806-10.033-7.615,2.007-4.414,3.6-5.809,2.809-2.609,2.007-3.01-6.02-2.207-7.214-3.8.2-5.418,2.007-5.016,9.029,2.609,9.029,2.609-8.819-3.812-10.414-9.621a11.879,11.879,0,0,1,2.8-11.819C208.069,178.066,211.882,180.073,213.477,182.069Z",
    transform: "translate(-100.804 -126.61)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M221.637,189.65l1.4.8s1.2,2.609,0,2.007S220.433,192.66,221.637,189.65Z",
    transform: "translate(-99.944 -126.576)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M219.032,196.84s-8.417-1-9.029,2.207.6,9.421-1.194,11.427-4.816,5.207-2.408,5.408,8.417-2.408,12.039-5.016,3.21.2,3.21.2-2.007,2.007-4.013,2.2",
    transform: "translate(-82.31 -126.553)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M232.5,207.83a10.485,10.485,0,0,1,3.2,4.184",
    transform: "translate(-123.429 -126.517)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M228.867,201.64s3.411,1.605,3.01,4.605a18.643,18.643,0,0,1-1,4.414",
    transform: "translate(-115.994 -126.537)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M240.909,206.255a21.99,21.99,0,0,0-6.612-2.8c-3.612-.8-5.418-3.01-5.418-4.414s6.622,1.806,6.622,1.806S241.311,202.452,240.909,206.255Z",
    transform: "translate(-125.026 -126.547)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M237.115,185.279a10.7,10.7,0,0,1-1.625-3.17,14.418,14.418,0,0,1,1.425-1.836,3.5,3.5,0,0,1,4.013-.612,2.007,2.007,0,0,1-.642,1C238.319,182.671,238.52,187.085,237.115,185.279Z",
    transform: "translate(-131.656 -126.61)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M295.052,234.61a4.776,4.776,0,0,0-3.612,2.6,19.16,19.16,0,0,0-1.605,4.816l1-.8-1.194,3.8A61.272,61.272,0,0,1,278.417,237c-4.605-4.4-7.414-5.207-9.822-5.207s-17.437,1-19.233.8-5.819-2.408-6.421.2,2.207,4.605,5.618,6.612,10.033.8,12.039.6a17.6,17.6,0,0,1,4.214.2s8.618,6.21,13.624,13.424,10.625,13.624,14.628,12.631,8.217-6.22,8.819-6.22,5.408.2,7.214-3.4a27.088,27.088,0,0,0,2.207-5.418",
    transform: "translate(-209.427 -126.439)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M232.9,313.113s1-3.2,2.6-7.214",
    transform: "translate(-123.628 -126.196)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M241.709,192.486l4.264,30.349s14.3.5,22.824-.752,12.792-4.766,14.8-7.023,4.515-3.762,6.02-3.762,6.772-.251,8.277-.752,1,2.007-1.5,2.508a26.082,26.082,0,0,0-5.769,2.257s9.28.752,11.538.752,2.257,1.756,2.257,1.756,1.756,1.254,1.254,2.508-5.518,2.508-8.779,3.511-18.561,3.01-22.323,4.264-12.25,5.036-20.276,6.27-15.8,4.515-18.31,1.5-8.779-38.626-9.28-45.147",
    transform: "translate(-187.667 -126.573)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M231.486,211.233c1.5,0,6.772-.251,8.277-.752s1,2.007-1.5,2.508a26.085,26.085,0,0,0-5.769,2.257s9.28.752,11.538.752,2.257,1.756,2.257,1.756,1.756,1.254,1.254,2.508-5.518,2.508-8.779,3.511c-1.555.482-5.879,1.194-10.364,1.936a74.5,74.5,0,0,1-1.7-11.949C228.426,212.216,230.272,211.233,231.486,211.233Z",
    transform: "translate(-129.538 -126.508)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M236.648,217.73a74.794,74.794,0,0,1-8.648,1",
    transform: "translate(-119.862 -126.484)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M236.381,220.23s-6.722,1.786-9.591,1.374",
    transform: "translate(-118.381 -126.476)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M320.155,362.5s.251,5.518,0,10.033,2.759,10.033,3.762,13.293-3.261,1.756-4.264,1.254-10.284-10.785-12.541-14.3-4.224-7.755-4.224-9.762,7.525-5.518,7.525-5.518S319.4,359.737,320.155,362.5Z",
    transform: "translate(-282.417 -126.027)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M303.04,363.006c0-.5.482-1.114,1.2-1.726a46.742,46.742,0,0,0,6.321,12.26,60.089,60.089,0,0,0,13.5,13.845c-.752,1.053-3.451.08-4.224-.3-1-.5-10.284-10.785-12.541-14.3S303.04,365.012,303.04,363.006Z",
    transform: "translate(-282.568 -126.014)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M302.63,330.542c2.978-4.517,7.38-10.943,11.091-17.08a164.478,164.478,0,0,0,8.635-15.908c2.187-5.257-13.153-32-60.076-56.555",
    transform: "translate(-240.162 -126.408)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M295.23,251.947s6.08-4.685,7.9-8.327",
    transform: "translate(-253.789 -126.399)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M331.153,240.136S324.13,235.751,318,235.31",
    transform: "translate(-304.661 -126.427)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M278.715,182.04s-4.264,7.525-7.023,10.284-6.02-1-7.274-6.772-1.756-10.033.752-13.795,7.775-1.5,11.538,3.01S278.715,182.04,278.715,182.04Z",
    transform: "translate(-197.836 -126.641)",
    fill: "#ffaf18",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M275.248,180.762s-3.762,3.01-5.016,6.02-3.762,3.261-4.766-.752-.291-8.9,1.234-13.855S275.248,180.762,275.248,180.762Z",
    transform: "translate(-195.582 -126.637)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 15.601,
    cy: 27.169,
    rx: 15.601,
    ry: 27.169,
    transform: "translate(93.042 60.31) rotate(-165.87)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M257.288,166.38s-2.007,2.809-2.007,4.776c0,.572.7,2.819.732,3.241a1,1,0,0,1-.211.622,2.007,2.007,0,0,1-3.01.1l-1.124-1.154",
    transform: "translate(-164.249 -126.652)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M262.415,177.941s-3.371.562-4.495-3.371",
    transform: "translate(-175.646 -126.626)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M259.957,162.424a4.394,4.394,0,0,0-5.3-.562",
    transform: "translate(-169.918 -126.669)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M247.564,164.5a1.746,1.746,0,0,1,2.237,1.816",
    transform: "translate(-152.649 -126.659)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M259.8,167.274a3.01,3.01,0,0,0-3.15-1.094",
    transform: "translate(-171.758 -126.653)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M250,169.08a1.716,1.716,0,0,1,2.007,1.2",
    transform: "translate(-157.292 -126.644)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M238.99,201.547c1.675-14.708,9.371-9.029,10.7-15.38s-5.347-13.715,3.01-20.065,21.069-4.685,30.429-6.351a14.859,14.859,0,0,0,2.4-.662c9.631-11.778,17.668-29.777,35.064-30.1,13.635-.261,25.222,7.224,21.4,18.27,1.756,3.13,4.334,9.29,1.475,15a31.886,31.886,0,0,1-2.819,4.515c-1.766,1-3.833,2.267-5.6,3.371a46.07,46.07,0,0,0,4.846-18.751,18.285,18.285,0,0,1-1.395,1.856c-5.739,6.762-15.25,9.662-22.734,10.9-1.946,1.635-4.906,4.595-5.819,8.177-1.395,5.5-1.063,11.849-10.093,13.183s-14.046-7.685-18.731-3.672a15.048,15.048,0,0,0-3.953,4.806,39.129,39.129,0,0,0-1.495,4.936c-.191,1-.371,2.087-.572,3.3a26.858,26.858,0,0,1-1.154,4.354c-1.716,7.264-4.2,14.678-10.544,16.715C255.043,218.6,237.275,216.285,238.99,201.547Z",
    transform: "translate(-238.874 -126.775)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M249.62,161.786c5.016.7,11.989,1.254,18.37-.1a37.272,37.272,0,0,0,17.387-8.678s-5.689-6.692-31.433,2.338",
    transform: "translate(-190.281 -126.704)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M289.2,160.65a30.483,30.483,0,0,1,3.1.482",
    transform: "translate(-236.914 -126.671)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M334.294,201.82a4.254,4.254,0,0,0-.732,2.5",
    transform: "translate(-323.413 -126.536)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M328.692,179.508c-8.849-2.187-15.049-10.785-21.791-7.856-7.7,3.341-2.348,15.711-4.354,22.4-1.174,3.923-6.832,4.164-11.317,5.247",
    transform: "translate(-275.343 -126.637)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M287.271,165s1.334,15.049-9.7,15.049",
    transform: "translate(-220.267 -126.657)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M328.933,166.65s-4.013,4.344-14.046,1.665-20.407-2.007-21.741,8.026,7.023,13.043,2.338,18.731",
    transform: "translate(-277.359 -126.651)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M293.144,147.676s1-11.377-17.4-6.692S246.994,156.7,245.99,157.056",
    transform: "translate(-194.417 -126.739)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M268.01,225.23s-8.528,12.792-6.772,24.58,14.8,20.567,25.082,28.342,32.1,22.072,32.1,22.072-11.538,11.036-15.049,22.574-21.57,35.616-21.57,35.616,4.013,2.759,6.02,3.762a31,31,0,0,0,4.766,1.756s4.515-7.775,4.766-8.528,14.8-16.554,22.824-29.095,12.664-19.716,16.535-27.879",
    transform: "translate(-254.852 -126.46)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-122",
    transform: "translate(338.301 263.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(75.803 -140) rotate(17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M129.171,75.351,67.519,105.034l-.046.015-40.4,19.443-.03.015-2.7,1.31h-.015l-9.051,4.358h-.015l-1.6.777L7.756,133.8l-1.067.518-4.068,1.966-.823.381-1.8.869.213-1.067L20.327,34.681,36.464,28.83,64.746,18.59l.091-.046L95.1,7.588l.076-.046L116.006,0l2.712,15.573h0l.107.488,4.068,23.36.015.076,4.5,25.737Z",
    transform: "translate(100.247 0)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M64.746,0,1.8,118.078l-1.8.869.213-1.067L36.464,10.24Z",
    transform: "translate(100.246 18.59)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M92.478,0,4.068,126.733,0,128.7,62.216,10.956Z",
    transform: "translate(102.868 7.588)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M110.962,15.573,72.517,58.163l-.472.518-64.517,71.5H7.512l-1.6.777L0,133.8,87.419,7.543,108.249,0Z",
    transform: "translate(108.004 0)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M109.225,23.36l-98.543,86.4h-.015l-9.051,4.358H1.6l-1.6.777L66.132,42.62,66.6,42.1,105.156,0Z",
    transform: "translate(113.915 16.061)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M100.326,25.737l-59.885,39.8-.046.015L0,85,95.831,0Z",
    transform: "translate(127.325 39.496)",
    fill: "#FE5F55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x2: 108.844,
    y2: 40.67,
    transform: "translate(120.573 34.681)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x1: 116.006,
    y2: 137.537,
    transform: "translate(100.248 0)",
    fill: "#eceff1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M52.388,0S46.75,45.927,0,60.433",
    transform: "translate(148.658 19.687)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M100.247,0A203.438,203.438,0,0,1,80.209,23.222,83.34,83.34,0,0,1,63.844,36.175c-4.5,2.636-8.929,5.943-11.642,10.514s-3.566,14.065,1.234,17.767c5.272,4.084,13.714,3.87,19.931,3.657a191.886,191.886,0,0,0,23.238-2.606c7.39-1.143,14.781-2.469,22.247-3.154,5.364-.5,11.5-1.036,16.67.93A10.392,10.392,0,0,1,140,66.33a12.19,12.19,0,0,1,1.524,2.88,10.46,10.46,0,0,1,.32,1.326c.366,1.067.686-4.236,0,.472a32.944,32.944,0,0,1-4.251,12.632C131.347,94,119.949,100.4,109.253,105.232c-15.573,7.025-33.417,13.714-50.711,13.607-16.442-.183-33.234-6.232-44.936-18.011A46.186,46.186,0,0,1,1.75,80.928,40.487,40.487,0,0,1,.592,75.366a33.369,33.369,0,0,1-.335-3.489c.107,3.124.168-.853.381-2.331A52.354,52.354,0,0,1,4.523,56.288c.731-1.707-.716-4.312,0-5.988C-3.492,69.1-1.1,91.975,13.666,106.8a62.475,62.475,0,0,0,32,16.67c14.948,3.048,28.952.122,43.2-4.571,18.529-6.1,44.693-14.842,51.61-35.443A41.721,41.721,0,0,0,142,64.959c-1.432-8.945-11.885-9.143-19.062-8.868-14,.671-27.748,4.145-41.691,5.516-7.848.777-29.79,3.489-30.9-8.67v5.272c.518-5.12,4.328-9.3,8.167-12.4,5.729-4.571,12.19-7.741,17.767-12.769a187.979,187.979,0,0,0,24-27c.975-1.31-.945-4.708,0-5.973Z",
    transform: "translate(0 134.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M83.969,0A128.849,128.849,0,0,1,66.827,30.872c-3.2,4.328-9.752,9.143-10.377,14.75-.168,1.417-.61,4.8.366,6.1,1.6,2.027,6.948,1.371,9.143,1.356,15.863-.122,31.634-2.255,47.527-1.524,9.143.427,25.9,1.31,26.895,13.531V62.033c0,5.5-3.185,13.044-5.288,18.194a59.276,59.276,0,0,1-13.181,20.266,44.54,44.54,0,0,1-23.786,11.931c-11.748,1.966-23.421-.9-35.047-2.255-10.24-1.188-20.586-1.859-30.735-3.733-7.04-1.31-14.567-3.261-19.977-8.228S4.474,85.149,4.565,77.85C4.748,64.913,7.43,51.87,8.847,39.009S11.62,12.434.3,3.733c.929.716-1.006,5.211,0,5.973a22.856,22.856,0,0,1,7.619,9.143A24.826,24.826,0,0,1,9.289,24.4a17.639,17.639,0,0,1,.168,2c-.107-2.316,0-.594,0,0-.122,1.829-.289,3.657-.472,5.486C7.46,46.719,4.58,61.546,4.413,76.509c-.076,9.31,0,19.642,6.948,26.8,7.451,7.741,19.626,9.143,29.714,10.484,7.314.914,14.659,1.524,21.973,2.423,8.4.975,16.762,2.849,25.28,3.048a46.521,46.521,0,0,0,35.184-14.308c7.268-7.787,11.916-17.737,14.72-27.931,1.707-6.2,3.947-15.009,1.524-21.333-8.213-20.952-82.406-1.432-83.138-10.834v5.988c.229-2.088,2.21-3.947,3.474-5.455,2.834-3.368,5.684-6.689,8.228-10.3a129.934,129.934,0,0,0,15.8-28.952c.655-1.752-.64-4.236,0-5.973Z",
    transform: "translate(16.048 137.933)",
    fill: "#eceff1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M331.891,159.6l-6.913-13.814-1.818,1.089,7.642,14.364Z",
    transform: "translate(26.062 221.146)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M347.423,163.439c-2.536-8.551-6.172-16.732-12.176-14.364s-5.274,11.817-5.274,11.817.359,3.995,3.995,10.908,9.819,10.549,13.466,7.855S349.97,171.979,347.423,163.439Zm-4.354,5.039c-1.975,1.234-5.319-.4-7.294-3.524a13.3,13.3,0,0,1-2.166-4.915s-.393-4.264,2.862-5.33,5.218,2.626,6.6,6.475S345.044,167.255,343.069,168.478Z",
    transform: "translate(26.891 221.497)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M340.346,236.612l-6.733-3.03s7.732-25.642,8.428-31.028a115.028,115.028,0,0,1,2.693-12.827s2.357-2.02,2.357-3.7a43.9,43.9,0,0,0-1.01-6.071s2.7-2.368,2.368-4.388-1.358-8.091-2.7-10.8-3.03-4.04-4.051-4.04a34.717,34.717,0,0,0-5.386,1.683l4.713-5.061,2.7-2.357s0-2.368-4.051-1.358-8.091,7.429-9.1,9.112,2.02,15.509,3.367,17.876a54.681,54.681,0,0,1,3.041,8.091s-9.785,19.571-12.479,24.621-9.112,13.163-11.805,22.6-3.041,13.825.673,15.52,16.519,7.418,22.937,8.091,8.764-12.479,8.764-15.509S340.346,236.612,340.346,236.612Z",
    transform: "translate(24.531 222.074)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M342.24,163.29s-7.272,2.727-8.54,4.724",
    transform: "translate(27.35 223.284)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M336.61,172.436c1.279-.909,7.272-4.006,7.272-4.006",
    transform: "translate(27.706 223.912)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M335.32,174.14a6.407,6.407,0,0,0,1.818,2.244c1.122.729,2.727-.37,2.727-.37",
    transform: "translate(27.548 224.61)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M342.457,178.084l-1.627-2.547s1.627-3.1,2.177-2.188",
    transform: "translate(28.221 224.493)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M329.32,166.2s1.268,4.186,2.727,5.611",
    transform: "translate(26.815 223.64)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M455.776,352.569s1.594,1.606,2.133,5.872,1.336,5.6,2.133,5.332.527-4.266.527-4.266,2.942,4.805,3.739,4.805,1.863.527,1.863-1.079a13.261,13.261,0,0,0-1.324-4.266s3.2,3.739,4.266,4.008,1.324-2.133-.27-4.266-7.735-6.4-9.071-8a30.333,30.333,0,0,0-5.063-4Z",
    transform: "translate(38.372 244.225)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M421.64,294.765l6.834,8.3s7.328,10.953,12.647,17.82,14.162,23.2,14.162,23.2-5.128,5.364-4.635,7.855a66.121,66.121,0,0,1,.483,9.516c0,1.953-.236,3.67,1.47,2.929s2.929-6.093,3.423-6.834,2.929.976,3.658,1.953,6.1,3.423,7.563,4.4,4.4,3.658,5.858,3.658,2.446-.247,1.223-1.953-4.152-2.682-5.128-5.364-1.706-3.67-2.435-6.1-2.693-10.257-3.905-14.162-7.328-23.678-8.551-30.512-7.081-13.926-10.01-16.361a54.475,54.475,0,0,1-6.34-6.834Z",
    transform: "translate(38.095 238.311)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M337.812,383.139a67.665,67.665,0,0,0-2.794,14.353c-.258,6.329-.763,17.955,3.535,22.017s8.349,3.288,10.38-.258,2.02-11.884,2.02-14.925-.258-6.834-.258-7.855a22.579,22.579,0,0,0-5.308-10.1C342.11,383.139,339.585,380.042,337.812,383.139Z",
    transform: "translate(27.491 249.99)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M336.6,375.73s-.5,15.711,1.01,20.749,8.091,9.853,12.647,7.608,7.586-8.6,8.6-11.379,3.546-12.344,3.546-12.344S343.422,382.059,336.6,375.73Z",
    transform: "translate(27.694 249.241)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M368.348,391.639s6.834,1.953,16.833-.483,24.9-2.446,26.125-6.1,2.244-3.658-.247-7.328-9.269-7.317-19.279-3.658-15.632,5.375-18.808,8.54S367.865,389.2,368.348,391.639Z",
    transform: "translate(31.575 248.852)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M386.462,451.687a10.2,10.2,0,0,0-1.762,4.8,26.782,26.782,0,0,1-.505,6.071c-.516,2.783-3.142,17.259-1.38,19.481,4.253,5.319,29.457,6.15,31.129-1.739,1.044-4.87-5.308-12.467-7.328-13.983s-4.971-8.82-4.971-10.84.505-3.793-1.268-4.556S387.933,450.172,386.462,451.687Z",
    transform: "translate(33.278 258.368)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M378.74,377.232s.505,12.647,2.02,18.213,3.041,29.682,5.061,38.289,1.526,30.86,1.526,30.86a12.9,12.9,0,0,1,6.823-1.01l3.793.5,2.783,1.268s1.526-13.668,3.793-21,6.576-34.238,4.556-41.072a88.862,88.862,0,0,1-3.03-14.42V375.212S390.882,366.111,378.74,377.232Z",
    transform: "translate(32.853 248.749)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M337.1,327.8s-2.682,17.091-4.141,27.348-4.646,24.408-4.646,24.408,4.881,9.763,14.891,13.466,16.833,4.635,21.972,4.152,6.352-3.423,6.352-3.423l1.706,3.658s2.244-4.388,8.551-7.081,15.621-7.564,22.444-7.564,13.186,4.4,13.186,4.4.729-1.717.236-13.915-.976-22.444-3.905-28.571a65.508,65.508,0,0,0-5.858-10.01l-.561-1.01s.325-2.648.325-3.872-9.527-4.152-19.537-4.152-24.9,3.916-31.736,3.176-15.138-1.953-15.138-1.953S337.837,324.923,337.1,327.8Z",
    transform: "translate(26.691 243.12)",
    fill: "#e5e5e5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M342.83,336s9.4,13.859,13.859,18.314",
    transform: "translate(28.466 244.387)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M356.69,358.9a19.885,19.885,0,0,0,4.747,2.536",
    transform: "translate(30.159 247.185)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M348.13,351.46a77.989,77.989,0,0,0,6.183,5.746",
    transform: "translate(29.113 246.276)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M366.82,391.856a53.506,53.506,0,0,0,1.459-18.8c-1.212-9.28-1.212-15.621.494-17.82s15.868-13.915,21.243-14.409",
    transform: "translate(31.397 244.977)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M384.739,338.87c-1.223.741-6.834,2.94-10.739,7.328",
    transform: "translate(32.274 244.737)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M385.242,242.733s-3.03-2.031-7.754-5.4-17.54-8.428-20.918-8.428H346.8l-8.439-1.358s-2.02,13.837-4.724,17.54-6.733,8.439-6.733,8.439,13.837,8.091,18.213,10.1a55.7,55.7,0,0,1,9.112,5.734s-9.112,16.833-10.1,31.421-6.071,34.788-6.733,37.1-1.01,3.7-1.01,3.7,3.03,4.051,18.55,6.071,16.833-1.347,31.421-3.367,21.254,1.347,21.254,1.347,2.693-2.693,2.693-8.428,0-20.918.673-25.305,5.633-23.252,5.633-23.252,4.388,9.1,6.733,12.815a39.881,39.881,0,0,0,4.724,6.071,46.361,46.361,0,0,0,10.1-4.388c6.071-3.367,12.479-7.754,13.152-9.785s2.368-5.734,2.368-5.734a30.553,30.553,0,0,1-7.766-5.4c-3.367-3.367-11.469-19.56-13.825-22.59s-.337-4.051-5.4-7.092-13.825-5.05-19.56-8.091S385.242,242.733,385.242,242.733Z",
    transform: "translate(26.519 231.136)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M406.84,284.461s6.408-16.193,9.786-22.6",
    transform: "translate(36.287 235.328)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M409.85,278.95s9.786-11.469,12.142-16.53",
    transform: "translate(36.655 235.396)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M402.163,247.39s-3.7,14.5-6.733,22.264",
    transform: "translate(34.893 233.56)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M372.28,242.28s1.01,9.785,3.7,15.52",
    transform: "translate(32.064 232.936)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M370,258a38.8,38.8,0,0,0,1.56,5.274",
    transform: "translate(31.785 234.856)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M369.653,238.07a67.449,67.449,0,0,0-.415,16.945",
    transform: "translate(31.65 232.421)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M350.7,247.414l1.347,20.233L344.63,241.68",
    transform: "translate(28.685 232.862)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M360.28,319.11a34.79,34.79,0,0,1-6.34,2.828",
    transform: "translate(29.823 242.323)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M398.137,297.89s-19.56,11.121-30.018,18.213c-1.122.763-2.244,1.459-3.2,2.1",
    transform: "translate(31.165 239.73)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M397.813,299.39a74.5,74.5,0,0,0-9.785,12.142c-5.734,8.428-14.835,14.162-25.967,18.886",
    transform: "translate(30.815 239.914)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M374.309,192.679s-4.859,6.576-4.859,9.426.292,6.576-.853,7.709-7.137,3.142-7.137,4.578,2.85,4.276,2.85,4.276.572,9.146,1.436,11.716.853,6.565,3.995,7.99,10-1.122,10-1.122.853,4.579-.572,6.857-4.006,2-2.244,5.14,5.14,7.429,14.588,7.709,12.569-6.565,12.569-8.562-1.717-3.714-1.717-8,2-11.7,2-11.7,7.709-7.429,7.709-13.994-7.709-23.7-17.955-25.126S374.309,192.679,374.309,192.679Z",
    transform: "translate(30.742 226.461)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M375.629,208.929c-.3,1.3-.92,2.244-1.38,2.166s-.584-1.257-.281-2.559.92-2.244,1.38-2.166S375.943,207.627,375.629,208.929Z",
    transform: "translate(32.25 228.547)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M367.06,219.862a9.247,9.247,0,0,0,8.854-.572",
    transform: "translate(31.426 230.127)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M373.16,202.6s2.862-3.142,5.151,1.717",
    transform: "translate(32.172 227.965)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M377.812,232.28l9.707-2.57-10.279,9.426S379.215,234.3,377.812,232.28Z",
    transform: "translate(32.67 231.4)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M409.269,182.317a49.291,49.291,0,0,0-14.286-6c-7.709-1.706-17.708,4.287-21.411,6.284s-8.574,1.122-9.426.572-4.859,3.142-2.57,8.854S373,197.163,373,197.163a7.63,7.63,0,0,0,3.714,3.714c2.85,1.425,9.988,0,11.424-.572s-1.122,4.287-.292,5.712,3.715-2,3.715-2,.281,5.712.853,9.426-4,4.848-3.142,6.565,6-2.57,6-2.57-4.567,5.14-.292,4.567,11.143-7.137,11.143-7.137,1.122,5.712-.292,9.987-8.282,4.578-8.282,4.578a7.149,7.149,0,0,0,5.431,4.848c4.567,1.122,5.712-2.244,5.712-2.244s.572,4.276,3.714,2.85,2.57-10,2.57-10,3.423-2.57,7.418-10.852.292-21.7-2.85-26.843S409.269,182.317,409.269,182.317Z",
    transform: "translate(30.671 224.839)",
    fill: "#263238",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M69.946-35.882C128.165,181.394-77.661,321.343,195.441,370.073",
    transform: "translate(154.444 -2.436)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62424",
    "data-name": "Path 62424",
    d: "M210.5,430.507l11.315-6.027,11.33,6.027,11.33-6.027,11.33,6.027,11.33-6.027",
    transform: "translate(1273.863 411.857)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBanner);
export default __webpack_public_path__ + "static/media/welcome-banner.864dc69897e32be7e3dded3efd0abd50.svg";
export { ForwardRef as ReactComponent };